import React, { useState, useEffect } from "react";
import "./admin.css";
import {  } from "firebase/firestore";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from "xlsx";
import {
  collection,
  getDocs,
  deleteDoc,
  doc,
  getDoc,
  addDoc,
  updateDoc,
  query,
  orderBy,
  limit,
  where,
  serverTimestamp,
  arrayUnion,
  runTransaction,

} from "firebase/firestore";
import { db } from "../FirebaseComp/firebase"; // adjust your path


import { Bar, Doughnut, Line } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title } from 'chart.js';

// Register ChartJS components
ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title);


function AdminPanel() {
const [openMenu, setOpenMenu] = useState(null); 

  const [selectedOption, setSelectedOption] = useState("dashboard");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownOpenStock, setDropdownOpenStock] = useState(false);
  const [dropdownOpenSupplier, setDropdownOpenSupplier] = useState(false);
  const [dropdownOpenReport, setDropdownOpenReport] = useState(false);
  const [dropdownOpenInvoice, setDropdownOpenInvoice] = useState(false);




// ✅ State variables MUST come first
const [suppliers, setSuppliers] = useState([]);
const [lensList, setLensList] = useState([]);
const [frameList, setFrameList] = useState([]);
const [supplierName, setSupplierName] = useState("");
const [purchaseOrderNo, setPurchaseOrderNo] = useState("");




const [purchaseOrders, setPurchaseOrders] = useState([]);

const [purchaseDate, setPurchaseDate] = useState("");
const [items, setItems] = useState([]);



useEffect(() => {
  const close = () => setOpenMenu(null);
  document.addEventListener("click", close);
  return () => document.removeEventListener("click", close);
}, []);


  const handleSelect = (option) => {
    setSelectedOption(option);
    setDropdownOpen(false);
  };

    const handleSelectStock = (optionstock) => {
    setSelectedOption(optionstock);
    setDropdownOpenStock(false);
  };


    const handleSelectSupplier = (optionsupplier) => {
    setSelectedOption(optionsupplier);
    setDropdownOpenSupplier(false);
  };



      const handleSelectInvoice = (optioninvoice) => {
    setSelectedOption(optioninvoice);
    setDropdownOpenInvoice(false);
  };



  
    const handleSelectReport = (optionsReport) => {
    setSelectedOption(optionsReport);
    setDropdownOpenReport(false);
  };



///////////////////////////////////////////// Add Item ////////////////////////////////////////////

// Add Items states
const [itemName, setItemName] = useState("");
const [itemPrice, setItemPrice] = useState("");


// Add Items handler
const handleAddItemforconsultation = async () => {
  // Validation
  if (!itemName.trim()) return alert("Item Name is required");
  if (!itemPrice) return alert("Price is required");
  if (parseFloat(itemPrice) <= 0) return alert("Price must be greater than 0");

  try {
    await addDoc(collection(db, "items"), {
      name: itemName.trim(),
      price: parseFloat(itemPrice),
      createdAt: serverTimestamp()
    });

    alert("Item added successfully!");
    handleClearItems();
  } catch (err) {
    console.error(err);
    alert("Failed to add item.");
  }
};

// Clear Items form
const handleClearItems = () => {
  setItemName("");
  setItemPrice("");
};










const handleLogout = () => {
  // Remove login token / session
  localStorage.removeItem("adminToken");

  // Redirect to login page
  window.location.href = "/";
};





//////////////////////////////////////////// Add Supplier //////////////////////////////////////////////////// 

  const [supplierForm, setSupplierForm] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    address: ""
  });

  // Handle input changes
  const handleSupplierChange = (e) => {
    setSupplierForm({ ...supplierForm, [e.target.name]: e.target.value });
  };

  // Submit & save to Firestore
  const handleSupplierSubmit = async (e) => {
    e.preventDefault();

    if (!supplierForm.name || !supplierForm.phone) {
      alert("Name and Phone are required!");
      return;
    }

    try {
      await addDoc(collection(db, "suppliers"), {
        ...supplierForm,
        createdAt: serverTimestamp()
      });

      alert("Supplier added successfully!");

      setSupplierForm({
        name: "",
        email: "",
        phone: "",
        company: "",
        address: ""
      });

    } catch (error) {
      console.error("Error adding supplier:", error);
      alert("Failed to save supplier. Check console for error.");
    }
  };



/////////////////////////////////////////////////////// view supplier ////////////////////////////////////////////////////////////


  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState("");
  const [sortType, setSortType] = useState("newest");
  const [currentPage, setCurrentPage] = useState(1);
  const [editData, setEditData] = useState(null);

  const itemsPerPage = 5;

  // FETCH DATA
  const fetchSuppliers = async () => {
    try {
      const q = query(collection(db, "suppliers"), orderBy("createdAt", "desc"));
      const snapshot = await getDocs(q);
      const list = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setSuppliers(list);
      setFiltered(list);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchSuppliers();
  }, []);

  // SEARCH
  useEffect(() => {
    let data = [...suppliers];

    if (search) {
      data = data.filter((s) =>
        s.name.toLowerCase().includes(search.toLowerCase())
      );
    }

    // SORT
    if (sortType === "az") {
      data.sort((a, b) => a.name.localeCompare(b.name));
    } else if (sortType === "newest") {
      data.sort((a, b) => b.createdAt?.seconds - a.createdAt?.seconds);
    }

    setFiltered(data);
    setCurrentPage(1);
  }, [search, sortType, suppliers]);

  // DELETE
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this supplier?")) return;
    await deleteDoc(doc(db, "suppliers", id));
    fetchSuppliers();
  };

  // UPDATE
  const handleUpdate = async () => {
    try {
      const ref = doc(db, "suppliers", editData.id);
      await updateDoc(ref, {
        name: editData.name,
        email: editData.email,
        phone: editData.phone,
        company: editData.company,
        address: editData.address,
      });
      setEditData(null);
      fetchSuppliers();
    } catch (err) {
      console.error(err);
    }
  };

  // PAGINATION
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentItems = filtered.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filtered.length / itemsPerPage);


 
  

//////////////////////////////////////////////////// purchasing order //////////////////////////////////////////////////////////////////////

// Fetch suppliers from Firestore
useEffect(() => {
  const fetchSuppliers = async () => {
    const snapshot = await getDocs(collection(db, "suppliers"));
    const supplierData = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    setSuppliers(supplierData);
  };

  fetchSuppliers();
}, []);

// Generate next PO number
useEffect(() => {
  const fetchLastPO = async () => {
    const q = query(
      collection(db, "purchasing_order"),
      orderBy("createdAt", "desc"),
      limit(1)
    );

    const snapshot = await getDocs(q);

    if (!snapshot.empty) {
      const lastPO = snapshot.docs[0].data().purchaseOrderNo;
      const lastNum = parseInt(lastPO.split("-").pop());
      const newNum = String(lastNum + 1).padStart(3, "0");
      setPurchaseOrderNo(`PO-${newNum}`);
    } else {
      setPurchaseOrderNo("PO-001");
    }
  };

  fetchLastPO();
}, [lensList, frameList]);

// Create PO
const handleCreatePurchaseOrder = async () => {
  if (!supplierName) return alert("Select a supplier");

  try {
    await addDoc(collection(db, "purchasing_order"), {
      purchaseOrderNo,
      supplierName,
      lensList,
      frameList,
      createdAt: serverTimestamp(),
    });

    alert("Purchase Order Created Successfully!");

    // Reset fields
    setLensList([]);
    setFrameList([]);
    setSupplierName("");

    // Update PO no
    const lastNum = parseInt(purchaseOrderNo.split("-").pop());
    const nextNum = String(lastNum + 1).padStart(3, "0");
    setPurchaseOrderNo(`PO-${nextNum}`);

  } catch (error) {
    console.error("Error creating PO:", error);
    alert("Failed to create purchase order. Check console for details.");
  }
};






/////////////////////////////////////////// Add Stock //////////////////////////////////////////////
const [selectedCategory, setSelectedCategory] = useState(""); // "lens" or "frame"

useEffect(() => {
  const fetchPurchaseOrders = async () => {
    const q = query(
      collection(db, "purchasing_order"),
      orderBy("createdAt", "desc")
    );
    const snapshot = await getDocs(q);
    const list = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setPurchaseOrders(list);
  };

  fetchPurchaseOrders();
}, []);








const handleAddItems = async () => {
  if (!selectedCategory) return alert("Select Lens or Frame");

  try {
    await addDoc(collection(db, "stock"), {
      purchaseOrderNo,
      supplierName,
      category: selectedCategory,
      purchaseDate,
      items,
      createdAt: serverTimestamp()
    });

    alert("Stock added successfully!");
    handleClear();
  } catch (err) {
    console.error(err);
    alert("Failed to add stock.");
  }
};




  // Clears the form fields
const handleClear = () => {
  setPurchaseOrderNo("");
  setSupplierName("");
  setPurchaseDate("");
  setSelectedCategory("");
  setItems([]);
};




const handleLoad = () => {
  if (!selectedCategory) return alert("Select Lens or Frame first");

  const selectedOrder = purchaseOrders.find(po => po.purchaseOrderNo === purchaseOrderNo);
  if (!selectedOrder) return;

  setSupplierName(selectedOrder.supplierName || "");
  setPurchaseDate(selectedOrder.createdAt
    ? selectedOrder.createdAt.toDate().toISOString().split("T")[0]
    : ""
  );

  // Load only lens or frame items
  const dataToLoad = selectedCategory === "lens" ? selectedOrder.lensList || [] : selectedOrder.frameList || [];

  const formattedItems = dataToLoad.map(item => ({ ...item, supplyQty: item.supplyQty || 0 }));
  setItems(formattedItems);
};






// Example: Update quantity of an item
const handleSupplyQtyChange = (index, value) => {
  const updatedItems = [...items];
  updatedItems[index].supplyQty = value;
  setItems(updatedItems);
};






 
  
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


  const [lensForm, setLensForm] = useState({
    itemCode: "",
    sph: "",
    add: "",
    cyl: "",
    axis: "",
    model: "CR39",
    progressive: false,
    qty: ""
  });

  const [frameForm, setFrameForm] = useState({
    itemCode: "",
    modelNo: "",
    brand: "",
    colour: "",
    sex: "",
    qty: ""
  });

  const handleLensAdd = () => {
    setLensList([...lensList, lensForm]);
    setLensForm({
      itemCode: "",
      sph: "",
      add: "",
      cyl: "",
      axis: "",
      model: "CR39",
      progressive: false,
      qty: ""
    });
  };

  const handleFrameAdd = () => {
    setFrameList([...frameList, frameForm]);
    setFrameForm({
      itemCode: "",
      modelNo: "",
      brand: "",
      colour: "",
      sex: "",
      qty: ""
    });
  };




////////////////////////////////////////////////////// Quick Stock add/////////////////////////////////////////////////////////

// State
const [lensFormquickAdd, setLensFormquickAdd] = useState({
  sph: 0,
  cyl: 0,
  add: 0,
  model: "",
  buyingPrice: "",
  sellingPrice: "",
  qty: "",
});

// Handle Input Change
const handleChange = (e) => {
  setLensFormquickAdd({
    ...lensFormquickAdd,
    [e.target.name]: e.target.value,
  });
};

// Add Lens to List
const handleAdd = () => {
  if (
    lensFormquickAdd.buyingPrice === "" ||
    lensFormquickAdd.sellingPrice === "" ||
    lensFormquickAdd.qty === ""
  ) {
    alert("Please fill all fields!");
    return;
  }

  setLensList([...lensList, lensFormquickAdd]);

  // Reset fields
  setLensFormquickAdd({
    sph: 0,
    cyl: 0,
    add: 0,
    model: "CR39 S/V",
    buyingPrice: "",
    sellingPrice: "",
    qty: "",
  });
};

// Clear Entire List
const clearList = () => {
  setLensList([]);
};


/////////////////////////////////////////////////////////////////////// Add Suppliers//////////////////////////////////////////////

// Add Supplier states
const [supplierEmail, setSupplierEmail] = useState("");
const [supplierPhone, setSupplierPhone] = useState("");
const [supplierCompany, setSupplierCompany] = useState("");
const [supplierAddress, setSupplierAddress] = useState("");


// Add Supplier handler
const handleAddSupplier = async () => {
  // Validation
  if (!supplierName.trim()) return alert("Supplier Name is required");
  if (!supplierPhone.trim()) return alert("Phone number is required");
  if (!supplierCompany.trim()) return alert("Company name is required");
  if (!supplierAddress.trim()) return alert("Address is required");
  
  // Email validation (if provided)
  if (supplierEmail && !/\S+@\S+\.\S+/.test(supplierEmail)) {
    return alert("Please enter a valid email address");
  }

  try {
    await addDoc(collection(db, "suppliers"), {
      name: supplierName.trim(),
      email: supplierEmail.trim() || null,
      phone: supplierPhone.trim(),
      company: supplierCompany.trim(),
      address: supplierAddress.trim(),
      createdAt: serverTimestamp()
    });

    alert("Supplier added successfully!");
    handleClearSupplier();
  } catch (err) {
    console.error(err);
    alert("Failed to add supplier.");
  }
};

// Clear Supplier form
const handleClearSupplier = () => {
  setSupplierName("");
  setSupplierEmail("");
  setSupplierPhone("");
  setSupplierCompany("");
  setSupplierAddress("");
};






  


//////////////////////////////////////////////////////////////////////Hisotry report - stock history/////////////////////////////////////////////////////////
 

// Add these states with your other useState declarations
const [historyCategory, setHistoryCategory] = useState("lens");
const [lensStockHistory, setLensStockHistory] = useState([]);
const [frameStockHistory, setFrameStockHistory] = useState([]);
const [loading, setLoading] = useState(false);

// Add this useEffect to fetch stock history when component mounts or category changes
useEffect(() => {
  const fetchStockHistory = async () => {
    setLoading(true);
    try {
      const q = query(
        collection(db, "stock"),
        orderBy("createdAt", "desc")
      );
      const snapshot = await getDocs(q);
      
      const lensStocks = [];
      const frameStocks = [];
      
      snapshot.docs.forEach(doc => {
        const stockData = { id: doc.id, ...doc.data() };
        if (stockData.category === "lens") {
          lensStocks.push(stockData);
        } else if (stockData.category === "frame") {
          frameStocks.push(stockData);
        }
      });
      
      setLensStockHistory(lensStocks);
      setFrameStockHistory(frameStocks);
    } catch (err) {
      console.error("Error fetching stock history:", err);
      alert("Failed to load stock history");
    } finally {
      setLoading(false);
    }
  };
  
  if (selectedOption === "StockHistory") {
    fetchStockHistory();
  }
}, [selectedOption]);



///////////////////////////////////////////// create consultation //////////////////////////////////////////////////////

// Create Consultation states
const [billNo, setBillNo] = useState("");
const [customerName, setCustomerName] = useState("");
const [itemsList, setItemsList] = useState([]);
const [selectedItemId, setSelectedItemId] = useState("");
const [cartItems, setCartItems] = useState([]);
const [deliveryDate, setDeliveryDate] = useState("");
const [totalamount, setTotalAmount] = useState(0);

// Fetch items from database
useEffect(() => {
  const fetchItems = async () => {
    try {
      const q = query(collection(db, "items"), orderBy("name"));
      const snapshot = await getDocs(q);
      const items = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setItemsList(items);
    } catch (err) {
      console.error("Error fetching items:", err);
    }
  };
  
  if (selectedOption === "createConsultation") {
    fetchItems();
  }
}, [selectedOption]);



const getNextBillNumber = async () => {
  const counterRef = doc(db, "counters", "consultationBills");

  try {
    const newNumber = await runTransaction(db, async (transaction) => {
      const counterDoc = await transaction.get(counterRef);

      if (!counterDoc.exists()) {
        transaction.set(counterRef, { lastNumber: 1 });
        return 1;
      }

      const current = counterDoc.data().lastNumber || 0;
      const next = current + 1;

      transaction.update(counterRef, { lastNumber: next });

      return next;
    });

    // Format: 001, 002, 003
    return String(newNumber).padStart(3, "0");

  } catch (error) {
    console.error("Error getting bill number:", error);
    throw error;
  }
};









// Calculate total when cart changes
useEffect(() => {
  const total = cartItems.reduce((sum, item) => sum + item.price, 0);
  setTotalAmount(total);
}, [cartItems]);

// Add item to cart
const handleAddToCart = () => {
  if (!selectedItemId) {
    alert("Please select an item");
    return;
  }
  
  const selectedItem = itemsList.find(item => item.id === selectedItemId);
  if (selectedItem) {
    setCartItems([...cartItems, {
      id: selectedItem.id,
      name: selectedItem.name,
      price: selectedItem.price
    }]);
    setSelectedItemId("");
  }
};

// Remove last item
const handleRemoveLastItem = () => {
  if (cartItems.length > 0) {
    const newCart = [...cartItems];
    newCart.pop();
    setCartItems(newCart);
  }
};

// Generate PDF Bill
const generateBill = (billNo) => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: [80, 200] // 80mm width thermal
  });

  let y = 8;

  const centerX = 40;

  // Header
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);

  y += 5;
  doc.setFontSize(9);
   doc.setFont("helvetica", "bold");
  doc.text("Eye Care Clinic & Optical", centerX, y, { align: "center" });
  y += 4;
   doc.setFont("helvetica", "normal");
  doc.text("932, Maradana Road,Colombo 08", centerX, y, { align: "center" });
  y += 4;
  doc.text("Tel: 011 268 2277 / 076 136 0944", centerX, y, { align: "center"});
  y += 4;
  doc.text("Colombo, Sri Lanka", centerX, y, { align: "center" });
  y += 4;
  doc.text("www.optica")
  doc.setFont("helvetica", "bold");
  doc.text("Member of Optica", centerX, y, { align: "center" });
  y += 5;
  doc.line(5, y, 75, y);

  // Bill Info
  y += 5;
  doc.setFontSize(9);
  doc.text(`Bill No: ${billNo}`, 5, y);
  
  y += 6;
  doc.text(`Date: ${new Date().toLocaleDateString()}`, 5, y);

  y += 6;
  doc.text(`Name: ${customerName}`, 5, y);

  y += 6;
  doc.text(`Delivery: ${deliveryDate}`, 5, y);

  // Divider
  y += 5;
  doc.line(5, y, 75, y);

  // Items
  y += 5;
  doc.setFont("helvetica", "bold");
  doc.text("Item", 5, y);
  doc.text("Amount (Rs)", 70, y, { align: "right" });

  y += 3;
  doc.line(5, y, 75, y);

  doc.setFont("helvetica", "normal");

  cartItems.forEach(item => {
    y += 5;

    // Auto wrap long names
    const splitName = doc.splitTextToSize(item.name, 45);
    doc.text(splitName, 5, y);

    doc.text(item.price.toFixed(2), 75, y, { align: "right" });

    y += (splitName.length - 1) * 4;
  });

  // Total
  y += 5;
  doc.line(5, y, 75, y);

  y += 6;
  doc.setFont("helvetica", "bold");
  doc.text("Total Amount", 5, y);
  doc.text(`Rs. ${totalamount.toFixed(2)}`, 75, y, { align: "right" });

  // Footer
  y += 8;
  doc.setFontSize(8);
  doc.setFont("helvetica", "normal");
  doc.text("Thank You For Visiting Us!", centerX, y, { align: "center" });

  y += 4;

  doc.save(`Bill_${billNo}.pdf`);
};




// Create consultation
const handleCreateConsultation = async () => {
  if (!customerName.trim()) {
    alert("Please enter customer name");
    return;
  }

  if (cartItems.length === 0) {
    alert("Please add at least one item");
    return;
  }

  if (!deliveryDate) {
    alert("Please select delivery date");
    return;
  }

  try {
    const newBillNo = await getNextBillNumber();
    setBillNo(newBillNo);

    await addDoc(collection(db, "consultations"), {
      billNo: newBillNo,
      customerName: customerName.trim(),
      items: cartItems,
      totalAmount: totalAmount,
      deliveryDate,
      createdAt: serverTimestamp(),
      status: "pending"
    });

    generateBill(newBillNo);

    alert(`Bill Created: ${newBillNo}`);

    handleClearConsultation();

  } catch (err) {
    console.error(err);
    alert("Failed to create consultation");
  }
};





// Clear consultation form
const handleClearConsultation = () => {
  setCustomerName("");
  setCartItems([]);
  setDeliveryDate("");
  setSelectedItemId("");
};





////////////////////////////////////////////////// Quick Add Stock /////////////////////////////////////////////////






// Quick Add Stock states
const [quickSelectedCategory, setQuickSelectedCategory] = useState("");
const [quickSupplierName, setQuickSupplierName] = useState("");
const [quickPurchaseDate, setQuickPurchaseDate] = useState("");
const [quickItems, setQuickItems] = useState([]);
const [suppliersList, setSuppliersList] = useState([]);

// Fetch suppliers for quick add
useEffect(() => {
  const fetchSuppliers = async () => {
    try {
      const q = query(collection(db, "suppliers"), orderBy("name"));
      const snapshot = await getDocs(q);
      const suppliers = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setSuppliersList(suppliers);
    } catch (err) {
      console.error("Error fetching suppliers:", err);
    }
  };
  
  if (selectedOption === "quickAdd") {
    fetchSuppliers();
  }
}, [selectedOption]);



// Quick Add Stock handlers
const handleAddQuickItemRow = () => {
  if (!quickSelectedCategory) {
    alert("Please select a category first");
    return;
  }
  
  if (quickSelectedCategory === "lens") {
    setQuickItems([
      ...quickItems,
      {
        itemCode: "",
        sph: "",
        add: "",
        cyl: "",
        axis: "",
        model: "",
        progressive: false,
        buyingPrice: "",
        sellingPrice: "",
        qty: 0,
        supplyQty: 0
      }
    ]);
  } else if (quickSelectedCategory === "frame") {
    setQuickItems([
      ...quickItems,
      {
        itemCode: "",
        modelNo: "",
        brand: "",
        colour: "",
        sex: "",
        qty: 0,
        buyingPrice: "",
        sellingPrice: "",
        supplyQty: 0
      }
    ]);
  }
};

const handleQuickItemChange = (index, field, value) => {
  const updatedItems = [...quickItems];
  updatedItems[index][field] = value;
  setQuickItems(updatedItems);
};

const handleRemoveQuickItem = (index) => {
  const updatedItems = quickItems.filter((_, i) => i !== index);
  setQuickItems(updatedItems);
};

const handleQuickAddStock = async () => {
  // Validation
  if (!quickSelectedCategory) {
    alert("Select Lens or Frame");
    return;
  }
  
  if (!quickSupplierName) {
    alert("Select Supplier");
    return;
  }
  
  if (!quickPurchaseDate) {
    alert("Select Purchase Date");
    return;
  }
  
  if (quickItems.length === 0) {
    alert("Add at least one item");
    return;
  }
  
  // Validate each item
  let hasError = false;
  
  if (quickSelectedCategory === "lens") {
    for (let i = 0; i < quickItems.length; i++) {
      const item = quickItems[i];
      if (!item.itemCode) {
        alert(`Item ${i + 1}: Item Code is required`);
        hasError = true;
        break;
      }
      if (!item.model) {
        alert(`Item ${i + 1}: Model is required`);
        hasError = true;
        break;
      }
      if (item.qty <= 0) {
        alert(`Item ${i + 1}: Quantity must be greater than 0`);
        hasError = true;
        break;
      }
      if (item.supplyQty <= 0) {
        alert(`Item ${i + 1}: Supply Quantity must be greater than 0`);
        hasError = true;
        break;
      }
    }
  } else if (quickSelectedCategory === "frame") {
    for (let i = 0; i < quickItems.length; i++) {
      const item = quickItems[i];
      if (!item.itemCode) {
        alert(`Item ${i + 1}: Item Code is required`);
        hasError = true;
        break;
      }
      if (!item.modelNo) {
        alert(`Item ${i + 1}: Model No is required`);
        hasError = true;
        break;
      }
      if (!item.brand) {
        alert(`Item ${i + 1}: Brand is required`);
        hasError = true;
        break;
      }
      if (item.qty <= 0) {
        alert(`Item ${i + 1}: Quantity must be greater than 0`);
        hasError = true;
        break;
      }
      if (item.supplyQty <= 0) {
        alert(`Item ${i + 1}: Supply Quantity must be greater than 0`);
        hasError = true;
        break;
      }
    }
  }
  
  if (hasError) return;
  
  try {
    // Generate a quick purchase order number
    const quickPONo = `QUICK-${Date.now()}`;
    
    await addDoc(collection(db, "stock"), {
      purchaseOrderNo: quickPONo,
      supplierName: quickSupplierName,
      category: quickSelectedCategory,
      purchaseDate: quickPurchaseDate,
      items: quickItems,
      isQuickAdd: true,
      createdAt: serverTimestamp()
    });
    
    alert("Stock added successfully!");
    handleClearQuickForm();
  } catch (err) {
    console.error(err);
    alert("Failed to add stock.");
  }
};

const handleClearQuickForm = () => {
  setQuickSelectedCategory("");
  setQuickSupplierName("");
  setQuickPurchaseDate("");
  setQuickItems([]);
};



///////////////////////////////////////// create invoice /////////////////////////////////////////////////////

  // State for invoice number management
  const [currentInvoiceNumber, setCurrentInvoiceNumber] = useState('');
  
  // State declarations
  const [showSuccess, setShowSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [frameSearchTerm, setFrameSearchTerm] = useState('');
  const [frameSuggestions, setFrameSuggestions] = useState([]);
  const [showFrameSuggestions, setShowFrameSuggestions] = useState(false);
  const [availableFrames, setAvailableFrames] = useState([]);
  const [lensOptions, setLensOptions] = useState([]);

  // Form data state
  const [formData, setFormData] = useState({
    // Customer Information
    title: '',
    firstName: '',
    lastName: '',
    address: '',
    tpNo: '',
    email: '',
    age: '',
    
    // Prescription
    prescriptionDate: '',
    referredBy: 'OWN',
    pd: '',
    sh: '',
    
    // Right Eye
    rightVisualAcuity: '',
    rightSph: '',
    rightCyl: '',
    rightAxis: '',
    rightAdd: '',
    rightNearVA: '',
    
    // Left Eye
    leftVisualAcuity: '',
    leftSph: '',
    leftCyl: '',
    leftAxis: '',
    leftAdd: '',
    leftNearVA: '',
    
    // Lens & Frame
    lensModel: '',
    lensPrice: '',
    frameModel: '',
    framePrice: '',
    brand: '',
    colour: '',
    selectedFrameId: '',
    selectedLensId: '',
    
    // Pricing & Delivery
    deliveryDate: '',
    discount: '',
    advancePayment: '',
    billDescription: 'Frame and Lenses',
    paymentMethod: 'Cash'
  });

  // Errors state
  const [errors, setErrors] = useState({});

  // Calculate total amount
  const totalAmount = (parseFloat(formData.lensPrice) || 0) + (parseFloat(formData.framePrice) || 0) - (parseFloat(formData.discount) || 0);

  // Validate form
  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.firstName.trim()) newErrors.firstName = 'First name is required';
    if (!formData.lastName.trim()) newErrors.lastName = 'Last name is required';
    if (!formData.address.trim()) newErrors.address = 'Address is required';
    if (!formData.tpNo.trim()) newErrors.tpNo = 'Phone number is required';
    if (!formData.age) newErrors.age = 'Age is required';
    if (formData.age && (formData.age < 0 || formData.age > 120)) newErrors.age = 'Valid age is required (1-120)';
    // if (!formData.frameModel) newErrors.frameModel = 'Frame selection is required';
    
    return newErrors;
  };

  // Function to generate next invoice number (simple sequential)
  const generateNextInvoiceNumber = async () => {
    try {
      // Get the last invoice number from Firestore
      const invoicesRef = collection(db, 'invoices');
      const q = query(invoicesRef, orderBy('invoiceNumber', 'desc'), limit(1));
      const querySnapshot = await getDocs(q);
      
      let lastNumber = 0;
      
      if (!querySnapshot.empty) {
        const lastInvoice = querySnapshot.docs[0].data();
        const lastInvoiceNum = lastInvoice.invoiceNumber;
        
        // Extract numeric part from INV-XXX format
        const match = lastInvoiceNum.match(/INV-(\d+)/);
        if (match) {
          lastNumber = parseInt(match[1]);
        }
      }
      
      // Generate next number (increment by 1)
      const nextNumber = lastNumber + 1;
      
      // Format invoice number as INV-001, INV-002, etc.
      const formattedNumber = `INV-${nextNumber.toString().padStart(3, '0')}`;
      
      // Update state
      setCurrentInvoiceNumber(formattedNumber);
      
      return formattedNumber;
    } catch (error) {
      console.error('Error generating invoice number:', error);
      // Fallback to timestamp if Firestore read fails
      const fallbackNumber = `INV-${Date.now().toString().slice(-3)}`;
      setCurrentInvoiceNumber(fallbackNumber);
      return fallbackNumber;
    }
  };

  // Function to refresh/snapshot the invoice number
  const refreshInvoiceNumber = async () => {
    const newNumber = await generateNextInvoiceNumber();
    return newNumber;
  };

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  // Reset form
  const handleResetForm = () => {
    setFormData({
      title: '',
      firstName: '',
      lastName: '',
      address: '',
      tpNo: '',
      email: '',
      age: '',
      prescriptionDate: '',
      referredBy: 'OWN',
      pd: '',
      sh: '',
      rightVisualAcuity: '',
      rightSph: '',
      rightCyl: '',
      rightAxis: '',
      rightAdd: '',
      rightNearVA: '',
      leftVisualAcuity: '',
      leftSph: '',
      leftCyl: '',
      leftAxis: '',
      leftAdd: '',
      leftNearVA: '',
      lensModel: '',
      lensPrice: '',
      frameModel: '',
      framePrice: '',
      brand: '',
      colour: '',
      selectedFrameId: '',
      selectedLensId: '',
      deliveryDate: '',
      discount: '',
      advancePayment: '',
      billDescription: 'Frame and Lenses',
      paymentMethod: 'Cash'
    });
    setFrameSearchTerm('');
    setErrors({});
    setShowFrameSuggestions(false);
    setFrameSuggestions([]);
  };

  // Generate PDF functions
const generateCustomerPrescriptionPDF = async (invoiceData) => {
  const pdf = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: [80, 200]
  });

  let y = 6;
  const centerX = 40;


 // Helper function to format date safely
  const formatDateSafe = (dateValue) => {
    if (!dateValue) return "N/A";
    try {
      if (dateValue.toDate) {
        // Firestore Timestamp
        return dateValue.toDate().toLocaleDateString();
      } else if (dateValue.seconds) {
        // Firestore Timestamp in object form
        return new Date(dateValue.seconds * 1000).toLocaleDateString();
      } else if (typeof dateValue === 'string') {
        // ISO string
        return new Date(dateValue).toLocaleDateString();
      } else if (dateValue instanceof Date) {
        // Date object
        return dateValue.toLocaleDateString();
      }
      return "Invalid Date";
    } catch (e) {
      return "Invalid Date";
    }
  };




  // ===== HEADER =====
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(12);

  pdf.setFontSize(9);
  pdf.setFont("helvetica", "normal");
  pdf.text("Eye Care Clinic & Optical", centerX, y, { align: "center" });
  y += 5;
  pdf.text("932, Maradana Road,Colombo 08", centerX, y, { align: "center" });
  y += 5;
  pdf.text("Tel: 011 268 2277 / 076 136 0944", centerX, y, { align: "center"});
  y += 5;
  pdf.text("www.eyecareclinicandoptical.com", centerX, y, { align: "center" });
  y += 5;
  pdf.text("Member of Optica", centerX, y, { align: "center" });
  y += 4;
  pdf.line(5, y, 75, y);

  // ===== TITLE =====
  y += 5;
  pdf.setFont("helvetica", "bold");
  pdf.text("PRESCRIPTION", centerX, y, { align: "center" });

  y += 5;
  pdf.setFontSize(8);
  pdf.text(`Invoice: ${invoiceData.invoiceNumber}`, 5, y);
  y += 5;
  // FIX: Use safe date formatting
  const invoiceDate = invoiceData.createdAt;
  pdf.text(`Date: ${formatDateSafe(invoiceDate)}`, 5, y);
  
  // ===== CUSTOMER =====
  y += 5;
  pdf.line(5, y, 75, y);

  y += 5;
  pdf.setFont("helvetica", "bold");
  pdf.text("Patient Details", 5, y);

  pdf.setFont("helvetica", "normal");

  y += 4;
  pdf.text(
    pdf.splitTextToSize(`Name: ${invoiceData.customer.fullName}`, 65),
    5,
    y
  );

  y += 5;
  pdf.text(`Age: ${invoiceData.customer.age}`, 5, y);

  y += 4;
  pdf.text(`Tel: ${invoiceData.customer.tpNo}`, 5, y);

  y += 4;
  pdf.text(
    pdf.splitTextToSize(`Address: ${invoiceData.customer.address}`, 65),
    5,
    y
  );

  // ===== PRESCRIPTION =====
  y += 6;
  pdf.line(5, y, 75, y);

  y += 5;
  pdf.setFont("helvetica", "bold");
  pdf.text("Prescription", 5, y);


    // FIX: Ensure PD and SH are displayed
  y += 5;
  pdf.text(`PD: ${invoiceData.prescription.pd || "-"}`, 5, y);
  y += 5;
  pdf.text(`SH: ${invoiceData.prescription.sh || "-"}`, 5, y);
  y += 5;


  const p = invoiceData.prescription;

  const rows = [
    ["SPH", p.rightEye.sph, p.leftEye.sph],
    ["CYL", p.rightEye.cyl, p.leftEye.cyl],
    ["AXIS", p.rightEye.axis, p.leftEye.axis],
    ["ADD", p.rightEye.add, p.leftEye.add],
  ];

  pdf.setFont("helvetica", "normal");

  // FIX: Align headers with values
  y += 5;
  pdf.text("R", 30, y);  // Position exactly where right eye values go
  pdf.text("L", 55, y);  // Position exactly where left eye values go

  rows.forEach(row => {
    y += 5;
    pdf.text(`${row[0]}:`, 5, y);        // Label at X=5
    pdf.text(`${row[1] || "-"}`, 30, y); // Right eye at X=30
    pdf.text(`${row[2] || "-"}`, 55, y); // Left eye at X=55
  });



  // ===== FOOTER =====
  y += 8;
  pdf.line(5, y, 75, y);

  y += 5;
  pdf.setFontSize(8);
  pdf.text("Thank You!", centerX, y, { align: "center" });

  pdf.save(`${invoiceData.invoiceNumber}_PRESCRIPTION.pdf`);
};









  const generateFullInvoicePDF = async (invoiceData) => {
  const pdf = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: [80, 200]
  });

  let y = 6;
  const centerX = 40;

// Safe date formatting function
const formatDateSafe = (dateValue) => {
  if (!dateValue) return "Not set";
  
  try {
    // Handle Firestore Timestamp
    if (dateValue && typeof dateValue.toDate === 'function') {
      return dateValue.toDate().toLocaleDateString();
    }
    
    // Handle Firestore Timestamp with seconds
    if (dateValue && dateValue.seconds) {
      return new Date(dateValue.seconds * 1000).toLocaleDateString();
    }
    
    // Handle Date object
    if (dateValue instanceof Date) {
      return dateValue.toLocaleDateString();
    }
    
    // Handle ISO string or date string
    if (typeof dateValue === 'string') {
      const parsedDate = new Date(dateValue);
      if (!isNaN(parsedDate.getTime())) {
        return parsedDate.toLocaleDateString();
      }
    }
    
    return "Invalid date";
  } catch (error) {
    console.error('Date formatting error:', error);
    return "Invalid date";
  }
};






  // ===== HEADER =====
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(12);

  pdf.setFontSize(9);

  pdf.text("Eye Care Clinic & Optical", centerX, y, { align: "center" });
  y += 4;
    pdf.setFont("helvetica", "normal");
  pdf.text("932, Maradana Road,Colombo 08", centerX, y, { align: "center" });
  y += 4;
  pdf.text("Tel: 011 268 2277 / 076 136 0944", centerX, y, { align: "center"});
  y += 4;
  pdf.text("www.eyecareclinicandoptical.com", centerX, y, { align: "center" });
  y += 4;
  pdf.setFont("helvetica", "bold");
  pdf.text("Member of Optica", centerX, y, { align: "center" });
  y += 5;
  pdf.line(5, y, 75, y);

  // ===== TITLE =====
  y += 5;
  pdf.setFont("helvetica", "bold");
  pdf.text("INVOICE", centerX, y, { align: "center" });

  y += 5;
  pdf.setFontSize(8);
  pdf.text(`No: ${invoiceData.invoiceNumber}`, 5, y);
  y += 4;
  // FIX: Use safe date formatting
  pdf.text(`Date: ${formatDateSafe(invoiceData.createdAt)}`, 5, y);

  // ===== CUSTOMER =====
  y += 5;
  pdf.line(5, y, 75, y);

  y += 5;
  pdf.setFont("helvetica", "bold");
  pdf.text("Patient Details", 5, y);

  pdf.setFont("helvetica", "normal");

  y += 4;
  pdf.text(
    pdf.splitTextToSize(`Name: ${invoiceData.customer.fullName}`, 65),
    5,
    y
  );

  y += 5;
  pdf.text(`Tel: ${invoiceData.customer.tpNo}`, 5, y);
y += 4;
  pdf.text(
    pdf.splitTextToSize(`Address: ${invoiceData.customer.address}`, 65),
    5,
    y
  );

  // ===== PRODUCTS =====
  y += 5;
  pdf.line(5, y, 75, y);

  y += 5;
  pdf.setFont("helvetica", "bold");
  pdf.text("Items", 5, y);

  pdf.setFont("helvetica", "normal");

  y += 5;
  pdf.text(
    pdf.splitTextToSize(`Lens: ${invoiceData.products.lensModel}`, 50),
    5,
    y
  );
  pdf.text(
    `${invoiceData.products.lensPrice.toFixed(2)}`,
    75,
    y,
    { align: "right" }
  );

  y += 6;
  pdf.text(
    pdf.splitTextToSize(`Frame: ${invoiceData.products.frameModel}`, 50),
    5,
    y
  );
  pdf.text(
    `${invoiceData.products.framePrice.toFixed(2)}`,
    75,
    y,
    { align: "right" }
  );

  // ===== PAYMENT =====
  y += 6;
  pdf.line(5, y, 75, y);

  y += 5;
  pdf.text(`Subtotal:`, 5, y);
  pdf.text(`${invoiceData.financial.subtotal.toFixed(2)}`, 75, y, { align: "right" });

  y += 4;
  pdf.text(`Discount:`, 5, y);
  pdf.text(`${invoiceData.financial.discount.toFixed(2)}`, 75, y, { align: "right" });

  y += 4;
  pdf.text(`Advance:`, 5, y);
  pdf.text(`${invoiceData.financial.advancePayment.toFixed(2)}`, 75, y, { align: "right" });

  y += 5;
  pdf.setFont("helvetica", "bold");
  pdf.text(`Balance:`, 5, y);
  pdf.text(`${invoiceData.financial.balanceDue.toFixed(2)}`, 75, y, { align: "right" });

  // ===== FOOTER =====
  y += 8;
  pdf.line(5, y, 75, y);

  y += 5;

  const formatDate = (ts) => {
  if (!ts) return "N/A";
  if (ts.seconds) return new Date(ts.seconds * 1000).toLocaleDateString();
  return new Date(ts).toLocaleDateString();
};
  pdf.setFont("helvetica", "normal");
  pdf.text(`Delivery Date: ${formatDateSafe(invoiceData.delivery.date)}`, 5, y);
  y += 8;
  pdf.setFontSize(8);
  pdf.text("Thank You For Your Purchase!", centerX, y, { align: "center" });

  pdf.save(`${invoiceData.invoiceNumber}_FULL.pdf`);
};





  const generateBothPDFs = async (invoiceData) => {
    await generateCustomerPrescriptionPDF(invoiceData);
    await generateFullInvoicePDF(invoiceData);
  };

  // Fetch frames data
  const fetchFramesData = async () => {
    try {
      const q = query(
        collection(db, "stock"),
        where("category", "==", "frame")
      );

      const querySnapshot = await getDocs(q);
      const framesList = [];

      querySnapshot.forEach(docSnap => {
        const data = docSnap.data();

        if (Array.isArray(data.items)) {
          data.items.forEach(item => {
            framesList.push({
              id: docSnap.id,
              ...item
            });
          });
        } else {
          framesList.push({
            id: docSnap.id,
            modelNo: data.modelNo,
            brand: data.brand,
            colour: data.colour,
            sellingPrice: data.sellingPrice,
            qty: data.quantity
          });
        }
      });

      setAvailableFrames(framesList);
    } catch (err) {
      console.log("Error loading frames:", err);
    }
  };

  // Fetch stock items (lenses)
  const fetchStockItems = async () => {
    try {
      const lensesQuery = query(collection(db, 'stock'), where('type', '==', 'lens'));
      const lensesSnapshot = await getDocs(lensesQuery);
      const lensesList = lensesSnapshot.docs.map(doc => ({ 
        id: doc.id, 
        ...doc.data(),
        availableQty: doc.data().quantity || 0
      }));
      setLensOptions(lensesList);
    } catch (error) {
      console.error('Error fetching lenses:', error);
    }
  };

  // Select frame
  const selectFrame = (frame) => {
    console.log('Selected frame:', frame);
    
    // Check if frame has sufficient quantity
    if (frame.qty <= 0) {
      alert(`Frame "${frame.modelNo}" is out of stock!`);
      return;
    }
    
    setFrameSearchTerm(frame.modelNo);
    setShowFrameSuggestions(false);
    setFrameSuggestions([]);

    // Auto-fill formData
    setFormData(prev => ({
      ...prev,
      frameModel: frame.modelNo,
      brand: frame.brand || "",
      colour: frame.colour || "",
      framePrice: frame.sellingPrice || 0,
      selectedFrameId: frame.id || "",
      frameQty: frame.qty || 0
    }));
  };

  // Handle frame search
  const handleFrameSearch = (text) => {
    console.log('Searching for:', text);
    setFrameSearchTerm(text);

    if (text.length < 2) {
      setShowFrameSuggestions(false);
      setFrameSuggestions([]);
      return;
    }

    const filtered = availableFrames.filter(frame => {
      const matchesSearch = frame.modelNo && frame.modelNo.toLowerCase().includes(text.toLowerCase());
      const hasStock = frame.qty > 0;
      return matchesSearch && hasStock;
    });

    console.log('Filtered suggestions:', filtered);
    setFrameSuggestions(filtered);
    setShowFrameSuggestions(true);
  };

  // Save order with specific invoice number
  const handleSaveOrderWithNumber = async (invoiceNumber) => {

  const lensSelectValue = document.querySelector('select[name="lensModel"]')?.value || formData.lensModel;


    let frameStockDoc = null;
    let frameItemIndex = -1;
    let currentQty = 0;
    
    // Handle frame stock deduction
    if (formData.selectedFrameId) {
      const frameRef = doc(db, 'stock', formData.selectedFrameId);
      const frameDoc = await getDoc(frameRef);
      
      if (frameDoc.exists()) {
        const frameData = frameDoc.data();
        
        if (frameData.items && Array.isArray(frameData.items)) {
          const itemIndex = frameData.items.findIndex(item => item.modelNo === formData.frameModel);
          
          if (itemIndex !== -1) {
            currentQty = frameData.items[itemIndex].qty || 0;
            
            if (currentQty <= 0) {
              alert(`Frame "${formData.frameModel}" is out of stock!`);
              setIsLoading(false);
              return;
            }
            
            const updatedItems = [...frameData.items];
            updatedItems[itemIndex] = {
              ...updatedItems[itemIndex],
              qty: currentQty - 1
            };
            
            await updateDoc(frameRef, { items: updatedItems });
            frameStockDoc = frameData;
            frameItemIndex = itemIndex;
          } else {
            alert('Frame item not found in stock!');
            setIsLoading(false);
            return;
          }
        } else if (frameData.quantity !== undefined) {
          currentQty = frameData.quantity;
          
          if (currentQty <= 0) {
            alert(`Frame "${formData.frameModel}" is out of stock!`);
            setIsLoading(false);
            return;
          }
          
          await updateDoc(frameRef, { quantity: currentQty - 1 });
          frameStockDoc = frameData;
        }
      } else {
        alert('Frame document not found!');
        setIsLoading(false);
        return;
      }
    }
    










    // Handle lens stock deduction
    let lensStockDoc = null;
    if (formData.selectedLensId) {
      const lensRef = doc(db, 'stock', formData.selectedLensId);
      const lensDoc = await getDoc(lensRef);
      
      if (lensDoc.exists()) {
        const lensData = lensDoc.data();
        currentQty = lensData.quantity || 0;
        
        if (currentQty <= 0) {
          alert(`Lens "${formData.lensModel}" is out of stock!`);
          setIsLoading(false);
          return;
        }
        
        await updateDoc(lensRef, { quantity: currentQty - 1 });
        lensStockDoc = lensData;
      } else {
        alert('Lens document not found!');
        setIsLoading(false);
        return;
      }
    }
    
    // Create invoice data with the permanent invoice number
    const invoiceData = {
      customer: {
        title: formData.title,
        firstName: formData.firstName,
        lastName: formData.lastName,
        fullName: `${formData.title || ''} ${formData.firstName} ${formData.lastName}`.trim(),
        address: formData.address,
        tpNo: formData.tpNo,
        email: formData.email,
        age: formData.age
      },
      prescription: {
         date: formData.prescriptionDate || new Date().toISOString().split('T')[0],
        referredBy: formData.referredBy,
        pd: formData.pd || '', // FIX: Include PD value
        sh: formData.sh || '', // FIX: Include SH value
        rightEye: {
          visualAcuity: formData.rightVisualAcuity,
          sph: formData.rightSph,
          cyl: formData.rightCyl,
          axis: formData.rightAxis,
          add: formData.rightAdd,
          nearVA: formData.rightNearVA
        },
        leftEye: {
          visualAcuity: formData.leftVisualAcuity,
          sph: formData.leftSph,
          cyl: formData.leftCyl,
          axis: formData.leftAxis,
          add: formData.leftAdd,
          nearVA: formData.leftNearVA
        }
      },
      products: {
        lensModel: lensSelectValue,
        lensModel: formData.lensModel,
        lensPrice: parseFloat(formData.lensPrice) || 0,
        frameModel: formData.frameModel,
        framePrice: parseFloat(formData.framePrice) || 0,
        brand: formData.brand,
        colour: formData.colour
      },
      financial: {
        subtotal: (parseFloat(formData.lensPrice) || 0) + (parseFloat(formData.framePrice) || 0),
        discount: parseFloat(formData.discount) || 0,
        advancePayment: parseFloat(formData.advancePayment) || 0,
        totalAmount: totalAmount,
        balanceDue: totalAmount - (parseFloat(formData.advancePayment) || 0),
        billDescription: formData.billDescription,
        paymentMethod: formData.paymentMethod
      },
      delivery: {
         date: formData.deliveryDate || ''
      },
      createdAt: new Date().toISOString(),
      invoiceNumber: invoiceNumber,
      status: 'pending'
    };
    
    // Save to Firestore
    await addDoc(collection(db, 'invoices'), invoiceData);
    
    // Create stock_out records
    const stockOutPromises = [];
    
    // Record frame stock out
    if (formData.selectedFrameId && formData.frameModel) {
      stockOutPromises.push(addDoc(collection(db, 'stock_out'), {
        productId: formData.selectedFrameId,
        productType: 'frame',
        productModel: formData.frameModel,
        brand: formData.brand,
        colour: formData.colour,
        quantity: 1,
        price: parseFloat(formData.framePrice) || 0,
        invoiceNumber: invoiceNumber,
        customerName: `${formData.firstName} ${formData.lastName}`,
        date: new Date(),
        type: 'sale',
        remainingStock: frameStockDoc ? (frameStockDoc.items ? 
          (frameStockDoc.items[frameItemIndex]?.qty - 1) : 
          (frameStockDoc.quantity - 1)) : 0
      }));
    }
    
    // Record lens stock out
    if (formData.selectedLensId && formData.lensModel) {
      stockOutPromises.push(addDoc(collection(db, 'stock_out'), {
        productId: formData.selectedLensId,
        productType: 'lens',
        productModel: formData.lensModel,
        quantity: 1,
        price: parseFloat(formData.lensPrice) || 0,
        invoiceNumber: invoiceNumber,
        customerName: `${formData.firstName} ${formData.lastName}`,
        date: new Date(),
        type: 'sale',
        remainingStock: lensStockDoc ? (lensStockDoc.quantity - 1) : 0
      }));
    }
    
    await Promise.all(stockOutPromises);
    
    // Generate PDFs
    try {
      await generateBothPDFs(invoiceData);
    } catch (pdfError) {
      console.error('PDF generation error:', pdfError);
    }
    
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 3000);
    handleResetForm();
    
    // Refresh stock data
    await fetchFramesData();
    await fetchStockItems();
    
    // Generate next invoice number for future use
    await generateNextInvoiceNumber();
    
    console.log(`Invoice ${invoiceNumber} created successfully and cannot be modified`);
  };

  // Main handleSaveOrder function
  const handleSaveOrder = async () => {
    // Validation
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }











    // Validate frame is selected
    // if (!formData.frameModel) {
    //   alert('Please select a frame model');
    //   return;
    // }
    
    setIsLoading(true);
    
    try {
      // Refresh and get a new invoice number (snapshot)
      const invoiceNumber = await refreshInvoiceNumber();
      
      // Verify invoice number is unique (double-check)
      const invoiceCheckQuery = query(
        collection(db, 'invoices'),
        where('invoiceNumber', '==', invoiceNumber)
      );
      const existingInvoice = await getDocs(invoiceCheckQuery);
      
      if (!existingInvoice.empty) {
        // If somehow duplicate exists, generate another one
        console.warn('Duplicate invoice number detected, regenerating...');
        const newInvoiceNumber = await generateNextInvoiceNumber();
        await handleSaveOrderWithNumber(newInvoiceNumber);
        return;
      }
      
      await handleSaveOrderWithNumber(invoiceNumber);
      


    } catch (error) {
      console.error('Error saving order:', error);
      alert('Error saving order: ' + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  // Initialize invoice number on component mount
  useEffect(() => {
    const init = async () => {
      await fetchFramesData();
      await fetchStockItems();
      await generateNextInvoiceNumber();
    };
    init();
  }, []);

  // Invoice Number Display Component
  const InvoiceNumberDisplay = () => (
    <div style={{
      position: 'fixed',
      top: '10px',
      right: '10px',
      backgroundColor: '#4CAF50',
      color: 'white',
      padding: '8px 12px',
      borderRadius: '4px',
      fontSize: '12px',
      fontWeight: 'bold',
      zIndex: 1000
    }}>
      Next Invoice: {currentInvoiceNumber}
    </div>
  );






// Update frame stock
const updateFrameStock = async (docId, modelNo, changeQty) => {
  const ref = doc(db, "stock", docId);
  const snap = await getDoc(ref);
  const data = snap.data();

  const updatedItems = data.items.map(item =>
    item.modelNo === modelNo
      ? { ...item, qty: (item.qty || 0) + changeQty }
      : item
  );

  await updateDoc(ref, { items: updatedItems });
};

// Handle lens selection

const handleLensSelect = (e) => {
  setFormData({...formData, lensModel: e.target.value});
};





// Fetch stock on component mount
useEffect(() => {
  fetchStockItems();
}, []);




// Add this CSS for suggestions dropdown (add to your CSS file or styled-components)
const styles = `
  .suggestions-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    max-height: 200px;
    overflow-y: auto;
    z-index: 1000;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  }
  
  .suggestion-item {
    padding: 10px;
    cursor: pointer;
    border-bottom: 1px solid #eee;
  }
  
  .suggestion-item:hover {
    background-color: #f5f5f5;
  }
  
  .suggestion-details {
    font-size: 12px;
    color: #666;
    margin-top: 4px;
  }
  
  .stock-badge {
    background: #4CAF50;
    color: white;
    padding: 2px 6px;
    border-radius: 3px;
    margin-left: 8px;
    font-size: 10px;
  }
  
  .readonly-field {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
  
  .toast-notification {
    position: fixed;
    top: 20px;
    right: 20px;
    background: #4CAF50;
    color: white;
    padding: 12px 20px;
    border-radius: 4px;
    z-index: 2000;
    animation: slideIn 0.3s ease;
  }
  
  @keyframes slideIn {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;

// Inject styles (add this once in your component or in a CSS file)
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement("style");
  styleSheet.textContent = styles;
  document.head.appendChild(styleSheet);
}













//////////////////////////////////////////// view stock - out/////////////////////////////////////////////////////

// Add state for stock-out data
const [stockOutRecords, setStockOutRecords] = useState([]);
const [filteredStockOut, setFilteredStockOut] = useState([]);
const [stockOutSearchTerm, setStockOutSearchTerm] = useState('');
const [stockOutFilterType, setStockOutFilterType] = useState('all');
const [stockOutDateRange, setStockOutDateRange] = useState({
  start: '',
  end: ''
});
const [isLoadingStockOut, setIsLoadingStockOut] = useState(false);

// Fetch stock-out history
const fetchStockOutHistory = async () => {
  try {
    setIsLoadingStockOut(true);
    const stockOutQuery = query(
      collection(db, 'stock_out'),
      orderBy('date', 'desc')
    );
    const stockOutSnapshot = await getDocs(stockOutQuery);
    const records = stockOutSnapshot.docs.map(doc => ({ 
      id: doc.id, 
      ...doc.data(),
      dateFormatted: new Date(doc.data().date).toLocaleDateString(),
      timeFormatted: new Date(doc.data().date).toLocaleTimeString()
    }));
    
    setStockOutRecords(records);
    setFilteredStockOut(records);
    setIsLoadingStockOut(false);
  } catch (error) {
    console.error('Error fetching stock-out history:', error);
    setIsLoadingStockOut(false);
    alert('Error fetching stock-out history: ' + error.message);
  }
};

// Filter stock-out records
const filterStockOut = () => {
  let filtered = [...stockOutRecords];
  
  // Filter by search term
  if (stockOutSearchTerm) {
    const searchLower = stockOutSearchTerm.toLowerCase();
    filtered = filtered.filter(record => 
      record.productModel?.toLowerCase().includes(searchLower) ||
      record.brand?.toLowerCase().includes(searchLower) ||
      record.customerName?.toLowerCase().includes(searchLower) ||
      record.invoiceNumber?.toLowerCase().includes(searchLower) ||
      record.colour?.toLowerCase().includes(searchLower)
    );
  }
  
  // Filter by product type
  if (stockOutFilterType !== 'all') {
    filtered = filtered.filter(record => record.productType === stockOutFilterType);
  }
  
  // Filter by date range
  if (stockOutDateRange.start) {
    const startDate = new Date(stockOutDateRange.start);
    startDate.setHours(0, 0, 0, 0);
    filtered = filtered.filter(record => new Date(record.date) >= startDate);
  }
  
  if (stockOutDateRange.end) {
    const endDate = new Date(stockOutDateRange.end);
    endDate.setHours(23, 59, 59, 999);
    filtered = filtered.filter(record => new Date(record.date) <= endDate);
  }
  
  setFilteredStockOut(filtered);
};

// Generate stock-out report PDF
const generateStockOutReportPDF = async () => {
  const pdf = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: 'a4'
  });

  const pageWidth = pdf.internal.pageSize.getWidth();
  const primaryColor = [41, 128, 185];

  // Header
  pdf.setFillColor(...primaryColor);
  pdf.rect(0, 0, pageWidth, 25, "F");

  pdf.setFontSize(20);
  pdf.setTextColor(255, 255, 255);
  pdf.text("STOCK OUT HISTORY REPORT", pageWidth / 2, 10, { align: "center" });

  pdf.setFontSize(10);
  pdf.text(`Generated: ${new Date().toLocaleString()}`, pageWidth / 2, 18, { align: "center" });

  let y = 35;

  // Summary stats
  const totalItems = filteredStockOut.reduce((sum, record) => sum + (record.quantity || 0), 0);
  const totalValue = filteredStockOut.reduce((sum, record) => sum + ((record.price || 0) * (record.quantity || 0)), 0);
  const frameCount = filteredStockOut.filter(r => r.productType === 'frame').length;
  const lensCount = filteredStockOut.filter(r => r.productType === 'lens').length;

  pdf.setFontSize(12);
  pdf.setTextColor(...primaryColor);
  pdf.text("SUMMARY", 10, y);

  y += 7;
  pdf.setFontSize(10);
  pdf.setTextColor(0, 0, 0);
  pdf.text(`Total Items Sold: ${totalItems}`, 10, y);
  pdf.text(`Total Value: Rs. ${totalValue.toFixed(2)}`, 80, y);
  pdf.text(`Frames: ${frameCount}`, 150, y);
  pdf.text(`Lenses: ${lensCount}`, 200, y);

  y += 15;

  // Table headers
  pdf.setFillColor(...primaryColor);
  pdf.rect(10, y, 20, 8, 'F');
  pdf.rect(30, y, 40, 8, 'F');
  pdf.rect(70, y, 30, 8, 'F');
  pdf.rect(100, y, 40, 8, 'F');
  pdf.rect(140, y, 30, 8, 'F');
  pdf.rect(170, y, 20, 8, 'F');
  pdf.rect(190, y, 30, 8, 'F');

  pdf.setTextColor(255, 255, 255);
  pdf.setFontSize(9);
  pdf.text("Type", 12, y + 5);
  pdf.text("Model", 32, y + 5);
  pdf.text("Customer", 72, y + 5);
  pdf.text("Invoice No", 102, y + 5);
  pdf.text("Date", 142, y + 5);
  pdf.text("Qty", 172, y + 5);
  pdf.text("Price", 192, y + 5);

  y += 8;

  // Table rows
  pdf.setTextColor(0, 0, 0);
  for (let record of filteredStockOut.slice(0, 20)) { // Limit to 20 records per page
    if (y > 250) {
      pdf.addPage();
      y = 20;
    }
    
    pdf.rect(10, y, 20, 7);
    pdf.rect(30, y, 40, 7);
    pdf.rect(70, y, 30, 7);
    pdf.rect(100, y, 40, 7);
    pdf.rect(140, y, 30, 7);
    pdf.rect(170, y, 20, 7);
    pdf.rect(190, y, 30, 7);
    
    pdf.text(record.productType || 'N/A', 12, y + 5);
    pdf.text(record.productModel || 'N/A', 32, y + 5);
    pdf.text((record.customerName || 'N/A').substring(0, 15), 72, y + 5);
    pdf.text(record.invoiceNumber || 'N/A', 102, y + 5);
    pdf.text(record.dateFormatted || 'N/A', 142, y + 5);
    pdf.text(record.quantity?.toString() || '0', 172, y + 5);
    pdf.text(`Rs. ${(record.price || 0).toFixed(2)}`, 192, y + 5);
    
    y += 7;
  }

  pdf.save(`STOCK_OUT_REPORT_${Date.now()}.pdf`);
};

// Calculate summary statistics
const getStockOutSummary = () => {
  const totalItems = filteredStockOut.reduce((sum, record) => sum + (record.quantity || 0), 0);
  const totalValue = filteredStockOut.reduce((sum, record) => sum + ((record.price || 0) * (record.quantity || 0)), 0);
  const frameTotal = filteredStockOut.filter(r => r.productType === 'frame').reduce((sum, r) => sum + (r.quantity || 0), 0);
  const lensTotal = filteredStockOut.filter(r => r.productType === 'lens').reduce((sum, r) => sum + (r.quantity || 0), 0);
  
  return { totalItems, totalValue, frameTotal, lensTotal };
};

// Fetch stock-out on component mount
useEffect(() => {
  if (selectedOption === "viewStockOut") {
    fetchStockOutHistory();
  }
}, [selectedOption]);

// Apply filters when filter criteria change
useEffect(() => {
  filterStockOut();
}, [stockOutSearchTerm, stockOutFilterType, stockOutDateRange.start, stockOutDateRange.end, stockOutRecords]);

// Reset filters
const resetStockOutFilters = () => {
  setStockOutSearchTerm('');
  setStockOutFilterType('all');
  setStockOutDateRange({ start: '', end: '' });
  setFilteredStockOut(stockOutRecords);
};

// Delete stock-out record (admin only)
const deleteStockOutRecord = async (recordId) => {
  if (window.confirm('Are you sure you want to delete this record?')) {
    try {
      await deleteDoc(doc(db, 'stock_out', recordId));
      await fetchStockOutHistory();
      alert('Record deleted successfully');
    } catch (error) {
      console.error('Error deleting record:', error);
      alert('Error deleting record: ' + error.message);
    }
  }
};




/////////////////////////////////////////////////// create balance invoice /////////////////////////////////////////////////////////////////

// // Add state for balance invoice
// const [showBalanceModal, setShowBalanceModal] = useState(false);
// const [selectedInvoice, setSelectedInvoice] = useState(null);
// const [balanceAmount, setBalanceAmount] = useState(0);
// const [balancePaymentMethod, setBalancePaymentMethod] = useState('Cash');
// const [balancePaidAmount, setBalancePaidAmount] = useState('');
// const [balanceInvoices, setBalanceInvoices] = useState([]);
// const [searchInvoiceNo, setSearchInvoiceNo] = useState('');
// const [filteredInvoices, setFilteredInvoices] = useState([]);
// const [isLoadingInvoices, setIsLoadingInvoices] = useState(false);

// // Fetch all invoices with pending balance
// const fetchPendingBalanceInvoices = async () => {
//   try {
//     setIsLoadingInvoices(true);
//     const invoicesQuery = query(
//       collection(db, 'invoices'),
//       where('status', '==', 'pending'),
//       orderBy('createdAt', 'desc')
//     );
//     const invoicesSnapshot = await getDocs(invoicesQuery);
//     const invoicesList = [];
    
//     for (const doc of invoicesSnapshot.docs) {
//       const invoiceData = { id: doc.id, ...doc.data() };
//       const balanceDue = invoiceData.financial?.balanceDue || 0;
      
//       // Only include invoices with balance due > 0
//       if (balanceDue > 0) {
//         // Check if balance invoice already exists
//         const balanceInvoiceQuery = query(
//           collection(db, 'balance_invoices'),
//           where('originalInvoiceId', '==', doc.id)
//         );
//         const balanceSnapshot = await getDocs(balanceInvoiceQuery);
        
//         invoicesList.push({
//           ...invoiceData,
//           docId: doc.id,
//           balanceDue: balanceDue,
//           hasBalanceInvoice: !balanceSnapshot.empty,
//           balanceInvoiceId: balanceSnapshot.empty ? null : balanceSnapshot.docs[0].id
//         });
//       }
//     }
    
//     setBalanceInvoices(invoicesList);
//     setFilteredInvoices(invoicesList);
//     setIsLoadingInvoices(false);
//   } catch (error) {
//     console.error('Error fetching invoices:', error);
//     setIsLoadingInvoices(false);
//     alert('Error fetching invoices: ' + error.message);
//   }
// };

// // Search/filter invoices
// const handleInvoiceSearch = () => {
//   if (!searchInvoiceNo.trim()) {
//     setFilteredInvoices(balanceInvoices);
//   } else {
//     const filtered = balanceInvoices.filter(invoice => 
//       invoice.invoiceNumber?.toLowerCase().includes(searchInvoiceNo.toLowerCase())
//     );
//     setFilteredInvoices(filtered);
//   }
// };

// // Open balance invoice modal
// const openBalanceModal = (invoice) => {
//   setSelectedInvoice(invoice);
//   setBalanceAmount(invoice.balanceDue);
//   setBalancePaidAmount(invoice.balanceDue.toString());
//   setBalancePaymentMethod('Cash');
//   setShowBalanceModal(true);
// };

// // Create balance invoice
// const handleCreateBalanceInvoice = async () => {
//   if (!selectedInvoice) return;
  
//   const paidAmount = parseFloat(balancePaidAmount);
  
//   if (isNaN(paidAmount) || paidAmount <= 0) {
//     alert('Please enter a valid amount');
//     return;
//   }
  
//   if (paidAmount > selectedInvoice.balanceDue) {
//     alert(`Amount cannot exceed balance due of Rs. ${selectedInvoice.balanceDue.toFixed(2)}`);
//     return;
//   }
  
//   setIsLoading(true);
  
//   try {
//     const newBalanceDue = selectedInvoice.balanceDue - paidAmount;
//     const balanceInvoiceNumber = `BAL-${Date.now()}`;
    
//     // Create balance invoice record
//     const balanceInvoiceData = {
//       originalInvoiceId: selectedInvoice.docId,
//       originalInvoiceNumber: selectedInvoice.invoiceNumber,
//       customerName: selectedInvoice.customer?.fullName,
//       customerPhone: selectedInvoice.customer?.tpNo,
//       originalAmount: selectedInvoice.financial?.totalAmount || 0,
//       originalAdvance: selectedInvoice.financial?.advancePayment || 0,
//       originalBalance: selectedInvoice.balanceDue,
//       paidAmount: paidAmount,
//       remainingBalance: newBalanceDue,
//       paymentMethod: balancePaymentMethod,
//       paymentDate: new Date().toISOString(),
//       balanceInvoiceNumber: balanceInvoiceNumber,
//       status: newBalanceDue <= 0 ? 'settled' : 'partial',
//       createdAt: new Date().toISOString()
//     };
    
//     // Save balance invoice to Firestore
//     await addDoc(collection(db, 'balance_invoices'), balanceInvoiceData);
    
//     // Update original invoice
//     const invoiceRef = doc(db, 'invoices', selectedInvoice.docId);
//     const updatedAdvancePayment = (selectedInvoice.financial?.advancePayment || 0) + paidAmount;
//     const updatedBalanceDue = selectedInvoice.financial?.totalAmount - updatedAdvancePayment;
    
//     await updateDoc(invoiceRef, {
//       'financial.advancePayment': updatedAdvancePayment,
//       'financial.balanceDue': updatedBalanceDue,
//       status: updatedBalanceDue <= 0 ? 'paid' : 'pending',
//       balancePayments: arrayUnion({
//         amount: paidAmount,
//         date: new Date().toISOString(),
//         method: balancePaymentMethod,
//         invoiceNumber: balanceInvoiceNumber
//       })
//     });
    
//     // Generate balance invoice PDF
//     await generateBalanceInvoicePDF(balanceInvoiceData, selectedInvoice);
    
//     alert(`Balance invoice created successfully!\nPaid: Rs. ${paidAmount.toFixed(2)}\nRemaining: Rs. ${newBalanceDue.toFixed(2)}`);
    
//     setShowBalanceModal(false);
//     setSelectedInvoice(null);
//     setBalancePaidAmount('');
    
//     // Refresh the list
//     await fetchPendingBalanceInvoices();
    
//   } catch (error) {
//     console.error('Error creating balance invoice:', error);
//     alert('Error creating balance invoice: ' + error.message);
//   } finally {
//     setIsLoading(false);
//   }
// };

// // Generate balance invoice PDF
// const generateBalanceInvoicePDF = async (balanceData, originalInvoice) => {
//   const pdf = new jsPDF({
//     orientation: 'portrait',
//     unit: 'mm',
//     format: 'a5'
//   });

//   const pageWidth = pdf.internal.pageSize.getWidth();
//   const primaryColor = [41, 128, 185];

//   // Header
//   pdf.setFillColor(...primaryColor);
//   pdf.rect(0, 0, pageWidth, 25, "F");

//   pdf.setFontSize(16);
//   pdf.setTextColor(255, 255, 255);
//   pdf.text("BALANCE INVOICE", pageWidth / 2, 10, { align: "center" });

//   pdf.setFontSize(9);
//   pdf.text(`Invoice No: ${balanceData.balanceInvoiceNumber}`, pageWidth / 2, 18, { align: "center" });

//   let y = 35;

//   // Customer Info
//   pdf.setFontSize(12);
//   pdf.setTextColor(...primaryColor);
//   pdf.text("CUSTOMER INFORMATION", 10, y);

//   y += 8;
//   pdf.setTextColor(0, 0, 0);
//   pdf.setFontSize(10);

//   pdf.text(`Name: ${balanceData.customerName}`, 10, y);
//   pdf.text(`Phone: ${balanceData.customerPhone || 'N/A'}`, pageWidth - 50, y);

//   y += 7;
//   pdf.text(`Original Invoice: ${balanceData.originalInvoiceNumber}`, 10, y);

//   // Payment Details
//   y += 15;
//   pdf.setFontSize(12);
//   pdf.setTextColor(...primaryColor);
//   pdf.text("PAYMENT DETAILS", 10, y);

//   pdf.setFontSize(10);
//   pdf.setTextColor(0, 0, 0);

//   y += 8;
//   pdf.text(`Original Amount: Rs. ${balanceData.originalAmount.toFixed(2)}`, 10, y);
//   pdf.text(`Advance Paid: Rs. ${balanceData.originalAdvance.toFixed(2)}`, pageWidth - 50, y);

//   y += 7;
//   pdf.text(`Previous Balance: Rs. ${balanceData.originalBalance.toFixed(2)}`, 10, y);

//   y += 7;
//   pdf.setFontSize(11);
//   pdf.setTextColor(primaryColor[0], primaryColor[1], primaryColor[2]);
//   pdf.text(`Amount Paid Now: Rs. ${balanceData.paidAmount.toFixed(2)}`, 10, y);

//   y += 7;
//   pdf.setTextColor(0, 0, 0);
//   pdf.text(`Payment Method: ${balanceData.paymentMethod}`, 10, y);
//   pdf.text(`Payment Date: ${new Date(balanceData.paymentDate).toLocaleDateString()}`, pageWidth - 55, y);

//   y += 10;
//   if (balanceData.remainingBalance > 0) {
//     pdf.setTextColor(255, 0, 0);
//     pdf.text(`Remaining Balance: Rs. ${balanceData.remainingBalance.toFixed(2)}`, 10, y);
//   } else {
//     pdf.setTextColor(0, 128, 0);
//     pdf.text(`FULLY PAID - Thank you!`, 10, y);
//   }

//   // Products summary
//   y += 15;
//   pdf.setTextColor(...primaryColor);
//   pdf.setFontSize(10);
//   pdf.text("Products:", 10, y);
  
//   y += 6;
//   pdf.setTextColor(0, 0, 0);
//   pdf.setFontSize(9);
//   pdf.text(`Lens: ${originalInvoice.products?.lensModel || 'N/A'}`, 10, y);
//   pdf.text(`Frame: ${originalInvoice.products?.frameModel || 'N/A'}`, pageWidth - 55, y);

//   pdf.save(`${balanceData.balanceInvoiceNumber}_BALANCE.pdf`);
// };

// // Fetch invoices when component mounts
// useEffect(() => {
//   if (selectedOption === "createBalanceInvoice") {
//     fetchPendingBalanceInvoices();
//   }
// }, [selectedOption]); 

   // State for balance invoice
  const [showBalanceModal, setShowBalanceModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [balanceAmount, setBalanceAmount] = useState(0);
  const [balancePaymentMethod, setBalancePaymentMethod] = useState('Cash');
  const [balancePaidAmount, setBalancePaidAmount] = useState('');
  const [balanceInvoices, setBalanceInvoices] = useState([]);
  const [searchInvoiceNo, setSearchInvoiceNo] = useState('');
  const [filteredInvoices, setFilteredInvoices] = useState([]);
  const [isLoadingInvoices, setIsLoadingInvoices] = useState(false);
  const [paymentDate, setPaymentDate] = useState(new Date().toISOString().split('T')[0]);

  // Function to generate balance invoice number (INV-001-1, INV-001-2, INV-001-3)
  const generateBalanceInvoiceNumber = async (originalInvoiceNumber) => {
    try {
      // Query all balance invoices for this original invoice
      const balanceInvoicesQuery = query(
        collection(db, 'balance_invoices'),
        where('originalInvoiceNumber', '==', originalInvoiceNumber),
        orderBy('balanceNumber', 'desc'),
        limit(1)
      );
      
      const balanceSnapshot = await getDocs(balanceInvoicesQuery);
      let lastBalanceNumber = 0;
      
      if (!balanceSnapshot.empty) {
        const lastBalance = balanceSnapshot.docs[0].data();
        lastBalanceNumber = lastBalance.balanceNumber || 0;
      }
      
      const nextBalanceNumber = lastBalanceNumber + 1;
      const balanceInvoiceNumber = `${originalInvoiceNumber}-${nextBalanceNumber}`;
      
      return { balanceInvoiceNumber, balanceNumber: nextBalanceNumber };
    } catch (error) {
      console.error('Error generating balance invoice number:', error);
      const fallbackNumber = 1;
      const balanceInvoiceNumber = `${originalInvoiceNumber}-${fallbackNumber}`;
      return { balanceInvoiceNumber, balanceNumber: fallbackNumber };
    }
  };

  // Fetch all invoices with pending balance
  const fetchPendingBalanceInvoices = async () => {
    try {
      setIsLoadingInvoices(true);
      const invoicesQuery = query(
        collection(db, 'invoices'),
        orderBy('createdAt', 'desc')
      );
      const invoicesSnapshot = await getDocs(invoicesQuery);
      const invoicesList = [];
      
      for (const docSnap of invoicesSnapshot.docs) {
        const invoiceData = { id: docSnap.id, ...docSnap.data() };
        const balanceDue = invoiceData.financial?.balanceDue || 0;
        
        // Get all balance invoices for this original invoice
        const balanceInvoiceQuery = query(
          collection(db, 'balance_invoices'),
          where('originalInvoiceId', '==', docSnap.id),
          orderBy('balanceNumber', 'asc')
        );
        const balanceSnapshot = await getDocs(balanceInvoiceQuery);
        const balanceRecords = balanceSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        
        invoicesList.push({
          ...invoiceData,
          docId: docSnap.id,
          balanceDue: balanceDue,
          hasBalanceInvoices: balanceRecords.length > 0,
          balanceRecords: balanceRecords,
          totalPaidBalance: balanceRecords.reduce((sum, record) => sum + (record.paidAmount || 0), 0)
        });
      }
      
      setBalanceInvoices(invoicesList);
      setFilteredInvoices(invoicesList);
      setIsLoadingInvoices(false);
    } catch (error) {
      console.error('Error fetching invoices:', error);
      setIsLoadingInvoices(false);
      alert('Error fetching invoices: ' + error.message);
    }
  };

  // Search/filter invoices
  const handleInvoiceSearch = () => {
    if (!searchInvoiceNo.trim()) {
      setFilteredInvoices(balanceInvoices);
    } else {
      const filtered = balanceInvoices.filter(invoice => 
        invoice.invoiceNumber?.toLowerCase().includes(searchInvoiceNo.toLowerCase())
      );
      setFilteredInvoices(filtered);
    }
  };

  // Open balance invoice modal
  const openBalanceModal = (invoice) => {
    const nextBalanceNumber = (invoice.balanceRecords?.length || 0) + 1;
    setSelectedInvoice(invoice);
    setBalanceAmount(invoice.balanceDue);
    setBalancePaidAmount(invoice.balanceDue.toString());
    setBalancePaymentMethod('Cash');
    setPaymentDate(new Date().toISOString().split('T')[0]);
    setShowBalanceModal(true);
  };

  // Create balance invoice
  const handleCreateBalanceInvoice = async () => {
    if (!selectedInvoice) return;
    
    const paidAmount = parseFloat(balancePaidAmount);
    
    if (isNaN(paidAmount) || paidAmount <= 0) {
      alert('Please enter a valid amount');
      return;
    }
    
    if (paidAmount > selectedInvoice.balanceDue) {
      alert(`Amount cannot exceed balance due of Rs. ${selectedInvoice.balanceDue.toFixed(2)}`);
      return;
    }
    
    setIsLoading(true);
    
    try {
      // Generate balance invoice number
      const { balanceInvoiceNumber, balanceNumber } = await generateBalanceInvoiceNumber(selectedInvoice.invoiceNumber);
      
      const newBalanceDue = selectedInvoice.balanceDue - paidAmount;
      const paymentDateTime = new Date(paymentDate).toISOString();
      
      // Create balance invoice record
      const balanceInvoiceData = {
        originalInvoiceId: selectedInvoice.docId,
        originalInvoiceNumber: selectedInvoice.invoiceNumber,
        balanceNumber: balanceNumber,
        balanceInvoiceNumber: balanceInvoiceNumber,
        customerName: selectedInvoice.customer?.fullName,
        customerPhone: selectedInvoice.customer?.tpNo,
        customerAddress: selectedInvoice.customer?.address,
        originalAmount: selectedInvoice.financial?.totalAmount || 0,
        originalAdvance: selectedInvoice.financial?.advancePayment || 0,
        previousBalance: selectedInvoice.balanceDue,
        paidAmount: paidAmount,
        remainingBalance: newBalanceDue,
        paymentMethod: balancePaymentMethod,
        paymentDate: paymentDateTime,
        paymentDateOnly: paymentDate,
        status: newBalanceDue <= 0 ? 'settled' : 'partial',
        createdAt: new Date().toISOString()
      };
      
      // Save balance invoice to Firestore
      await addDoc(collection(db, 'balance_invoices'), balanceInvoiceData);
      
      // Update original invoice
      const invoiceRef = doc(db, 'invoices', selectedInvoice.docId);
      const updatedAdvancePayment = (selectedInvoice.financial?.advancePayment || 0) + paidAmount;
      const updatedBalanceDue = selectedInvoice.financial?.totalAmount - updatedAdvancePayment;
      
      await updateDoc(invoiceRef, {
        'financial.advancePayment': updatedAdvancePayment,
        'financial.balanceDue': updatedBalanceDue,
        status: updatedBalanceDue <= 0 ? 'paid' : 'pending',
        balancePayments: arrayUnion({
          amount: paidAmount,
          date: paymentDateTime,
          dateOnly: paymentDate,
          method: balancePaymentMethod,
          invoiceNumber: balanceInvoiceNumber,
          balanceNumber: balanceNumber
        })
      });
      
      // Generate balance invoice PDF
      await generateBalanceInvoicePDF(balanceInvoiceData, selectedInvoice);
      
      alert(`Balance invoice created successfully!\nInvoice: ${balanceInvoiceNumber}\nDate: ${paymentDate}\nPaid: Rs. ${paidAmount.toFixed(2)}\nRemaining: Rs. ${newBalanceDue.toFixed(2)}`);
      
      setShowBalanceModal(false);
      setSelectedInvoice(null);
      setBalancePaidAmount('');
      setPaymentDate(new Date().toISOString().split('T')[0]);
      
      // Refresh the list
      await fetchPendingBalanceInvoices();
      
    } catch (error) {
      console.error('Error creating balance invoice:', error);
      alert('Error creating balance invoice: ' + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  // Generate balance invoice PDF
  // const generateBalanceInvoicePDF = async (balanceData, originalInvoice) => {
  //   const pdf = new jsPDF({
  //     orientation: 'portrait',
  //     unit: 'mm',
  //     format: 'a5'
  //   });

  //   const pageWidth = pdf.internal.pageSize.getWidth();
  //   const primaryColor = [41, 128, 185];

  //   // Header
  //   pdf.setFillColor(...primaryColor);
  //   pdf.rect(0, 0, pageWidth, 25, "F");

  //   pdf.setFontSize(14);
  //   pdf.setTextColor(255, 255, 255);
  //   pdf.text("BALANCE INVOICE", pageWidth / 2, 10, { align: "center" });

  //   pdf.setFontSize(9);
  //   pdf.text(`Invoice No: ${balanceData.balanceInvoiceNumber}`, pageWidth / 2, 18, { align: "center" });
  //   pdf.text(`(Balance Payment ${balanceData.balanceNumber} of ${balanceData.originalInvoiceNumber})`, pageWidth / 2, 23, { align: "center" });

  //   let y = 35;

  //   // Customer Info
  //   pdf.setFontSize(12);
  //   pdf.setTextColor(...primaryColor);
  //   pdf.text("CUSTOMER INFORMATION", 10, y);

  //   y += 8;
  //   pdf.setTextColor(0, 0, 0);
  //   pdf.setFontSize(10);

  //   pdf.text(`Name: ${balanceData.customerName}`, 10, y);
  //   pdf.text(`Phone: ${balanceData.customerPhone || 'N/A'}`, pageWidth - 50, y);

  //   y += 7;
  //   pdf.text(`Address: ${balanceData.customerAddress || 'N/A'}`, 10, y);

  //   y += 7;
  //   pdf.text(`Original Invoice: ${balanceData.originalInvoiceNumber}`, 10, y);

  //   // Payment Details
  //   y += 15;
  //   pdf.setFontSize(12);
  //   pdf.setTextColor(...primaryColor);
  //   pdf.text("PAYMENT DETAILS", 10, y);

  //   pdf.setFontSize(10);
  //   pdf.setTextColor(0, 0, 0);

  //   y += 8;
  //   pdf.text(`Original Amount: Rs. ${balanceData.originalAmount.toFixed(2)}`, 10, y);
  //   pdf.text(`Previous Advance: Rs. ${balanceData.originalAdvance.toFixed(2)}`, pageWidth - 55, y);

  //   y += 7;
  //   pdf.text(`Previous Balance: Rs. ${balanceData.previousBalance.toFixed(2)}`, 10, y);

  //   y += 7;
  //   pdf.setFontSize(11);
  //   pdf.setTextColor(primaryColor[0], primaryColor[1], primaryColor[2]);
  //   pdf.text(`Amount Paid Now: Rs. ${balanceData.paidAmount.toFixed(2)}`, 10, y);

  //   y += 7;
  //   pdf.setTextColor(0, 0, 0);
  //   pdf.text(`Payment Method: ${balanceData.paymentMethod}`, 10, y);
  //   pdf.text(`Payment Date: ${new Date(balanceData.paymentDate).toLocaleDateString()}`, pageWidth - 55, y);

  //   y += 10;
  //   if (balanceData.remainingBalance > 0) {
  //     pdf.setTextColor(255, 0, 0);
  //     pdf.setFontSize(11);
  //     pdf.text(`Remaining Balance: Rs. ${balanceData.remainingBalance.toFixed(2)}`, 10, y);
  //     pdf.setFontSize(9);
  //     pdf.text(`Next Balance Invoice: ${balanceData.originalInvoiceNumber}-${balanceData.balanceNumber + 1}`, 10, y + 6);
  //   } else {
  //     pdf.setTextColor(0, 128, 0);
  //     pdf.setFontSize(12);
  //     pdf.text(`✓ FULLY PAID - Thank you!`, 10, y);
  //   }

  //   // Products summary
  //   y += 20;
  //   pdf.setTextColor(...primaryColor);
  //   pdf.setFontSize(10);
  //   pdf.text("Products:", 10, y);
    
  //   y += 6;
  //   pdf.setTextColor(0, 0, 0);
  //   pdf.setFontSize(9);
  //   pdf.text(`Lens: ${originalInvoice.products?.lensModel || 'N/A'}`, 10, y);
  //   pdf.text(`Frame: ${originalInvoice.products?.frameModel || 'N/A'}`, pageWidth - 55, y);

  //   // Footer
  //   y += 15;
  //   pdf.setDrawColor(200, 200, 200);
  //   pdf.line(10, y, pageWidth - 10, y);
  //   y += 5;
  //   pdf.setFontSize(8);
  //   pdf.setTextColor(100, 100, 100);
  //   pdf.text("Thank you for your business!", pageWidth / 2, y, { align: "center" });

  //   pdf.save(`${balanceData.balanceInvoiceNumber}_BALANCE.pdf`);
  // };


const generateBalanceInvoicePDF = async (balanceData, originalInvoice) => {
  const pdf = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: [80, 200] // 80mm thermal
  });

  let y = 6;
  const centerX = 40;

  // ===== HEADER =====
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(12);

  y += 4;
  pdf.setFontSize(9);
  pdf.setFont("helvetica", "bold");
  pdf.text("Eye Care Clinic & Optical", centerX, y, { align: "center" });
  y += 4;
  pdf.setFont("helvetica", "normal");
  pdf.text("932, Galle Road, Colombo 03", centerX, y, { align: "center" });
  y += 4;
  pdf.text("Tel: 011 268 2277 / 076 136 0944", centerX, y, { align: "center"});
  y += 4;
  pdf.text("www.eyecareclinicandoptical.com", centerX, y, { align: "center"});
  y += 4;
  pdf.setFont("helvetica", "bold");
  pdf.text("Member of Optica", centerX, y, { align: "center" });

  y += 5;
  pdf.line(5, y, 75, y);

  // ===== TITLE =====
  y += 5;
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(10);
  pdf.text("BALANCE INVOICE", centerX, y, { align: "center" });

  y += 5;
  pdf.setFont("helvetica", "normal");
  pdf.setFontSize(8);
  pdf.text(`Bill No: ${balanceData.balanceInvoiceNumber}`, 5, y);

  y += 6;
  pdf.text(`Ref: ${balanceData.originalInvoiceNumber}`, 5, y);
  y += 6;

  // pdf.text(`Part: ${balanceData.balanceNumber}`, 5, y);
  // ===== CUSTOMER =====
  // y += 6;

  pdf.line(5, y, 75, y);

  y += 7;
  pdf.setFont("helvetica", "bold");
  pdf.text("Patient Details", 5, y);

  y += 4;
  pdf.setFont("helvetica", "normal");

  const name = pdf.splitTextToSize(balanceData.customerName, 65);
  pdf.text(name, 5, y);
  y += name.length * 4;

  pdf.text(`Tel: ${balanceData.customerPhone || "N/A"}`, 5, y);
  y += 4;

  const address = pdf.splitTextToSize(balanceData.customerAddress || "N/A", 65);
  pdf.text(address, 5, y);
  y += address.length * 4;





    // ===== PRODUCTS =====
  y += 6;
  pdf.line(5, y, 75, y);

  y += 5;
  pdf.setFont("helvetica", "bold");
  pdf.text("Products", 5, y);

  pdf.setFont("helvetica", "normal");
  y += 4;
  pdf.text(
    pdf.splitTextToSize(`Lens: ${originalInvoice.products?.lensModel || "N/A"}`, 65),
    5,
    y
  );

  y += 5;
  pdf.text(
    pdf.splitTextToSize(`Frame: ${originalInvoice.products?.frameModel || "N/A"}`, 65),
    5,
    y
  );





  // ===== PAYMENT =====
  y += 3;
  pdf.line(5, y, 75, y);

  y += 5;
  pdf.setFont("helvetica", "bold");
  pdf.text("Payment Details", 5, y);

  pdf.setFont("helvetica", "normal");

  y += 5;
  pdf.text(`Original: Rs.${balanceData.originalAmount.toFixed(2)}`, 5, y);

  y += 4;
  pdf.text(`Advance: Rs.${balanceData.originalAdvance.toFixed(2)}`, 5, y);

  y += 4;
  pdf.text(`Prev Balance: Rs.${balanceData.previousBalance.toFixed(2)}`, 5, y);

  y += 5;
  pdf.setFont("helvetica", "bold");
  pdf.text(`Paid Now: Rs.${balanceData.paidAmount.toFixed(2)}`, 5, y);

  pdf.setFont("helvetica", "normal");

  y += 4;
  pdf.text(`Payment Type: ${balanceData.paymentMethod}`, 5, y);

  y += 4;
  pdf.text(`Paid Date: ${new Date(balanceData.paymentDate).toLocaleDateString()}`, 5, y);

  // ===== BALANCE =====
  y += 5;
  pdf.line(5, y, 75, y);

  y += 5;

  if (balanceData.remainingBalance > 0) {
    pdf.setFont("helvetica", "bold");
    pdf.text(`Balance Amount: Rs.${balanceData.remainingBalance.toFixed(2)}`, 5, y);

    y += 4;
    pdf.setFont("helvetica", "normal");
    // pdf.text(
    //   `Next: ${balanceData.originalInvoiceNumber}-${balanceData.balanceNumber + 1}`,
    //   5,
    //   y
    // );
  } else {
    pdf.setFont("helvetica", "bold");
    pdf.text("FULLY PAID ✓", centerX, y, { align: "center" });
  }


  // ===== FOOTER =====
  y += 8;
  pdf.line(5, y, 75, y);

  y += 5;
  pdf.setFontSize(8);
  pdf.text("Thank You For Your Purchase!", centerX, y, { align: "center" });

  y += 4;

  // SAVE
  pdf.save(`${balanceData.balanceInvoiceNumber}_BALANCE.pdf`);
};







  // Fetch invoices when component mounts or when selectedOption changes
  useEffect(() => {
    if (selectedOption === "createBalanceInvoice") {
      fetchPendingBalanceInvoices();
    }
  }, [selectedOption]);






/////////////////////////////////////////////////////// view all balance invoices ////////////////////////////////////////////////////////////
// Add state for balance invoices list
const [allBalanceInvoices, setAllBalanceInvoices] = useState([]);
const [filteredBalanceInvoices, setFilteredBalanceInvoices] = useState([]);
const [balanceInvoiceSearchTerm, setBalanceInvoiceSearchTerm] = useState('');
const [balanceInvoiceFilterStatus, setBalanceInvoiceFilterStatus] = useState('all');
const [isLoadingBalanceInvoices, setIsLoadingBalanceInvoices] = useState(false);
const [selectedBalanceInvoice, setSelectedBalanceInvoice] = useState(null);
const [showBalanceInvoiceDetails, setShowBalanceInvoiceDetails] = useState(false);

// Fetch all balance invoices
const fetchAllBalanceInvoices = async () => {
  try {
    setIsLoadingBalanceInvoices(true);
    const balanceInvoicesQuery = query(
      collection(db, 'balance_invoices'),
      orderBy('createdAt', 'desc')
    );
    const balanceSnapshot = await getDocs(balanceInvoicesQuery);
    const balanceList = [];
    
    for (const doc of balanceSnapshot.docs) {
      const data = doc.data();
      balanceList.push({
        id: doc.id,
        ...data,
        formattedDate: new Date(data.createdAt).toLocaleDateString(),
        formattedTime: new Date(data.createdAt).toLocaleTimeString(),
        statusText: data.remainingBalance <= 0 ? 'Settled' : 'Partial',
        statusColor: data.remainingBalance <= 0 ? '#4CAF50' : '#ff9800'
      });
    }
    
    setAllBalanceInvoices(balanceList);
    setFilteredBalanceInvoices(balanceList);
    setIsLoadingBalanceInvoices(false);
  } catch (error) {
    console.error('Error fetching balance invoices:', error);
    setIsLoadingBalanceInvoices(false);
    alert('Error fetching balance invoices: ' + error.message);
  }
};

// Filter balance invoices
const filterBalanceInvoices = () => {
  let filtered = [...allBalanceInvoices];
  
  // Search filter
  if (balanceInvoiceSearchTerm) {
    const searchLower = balanceInvoiceSearchTerm.toLowerCase();
    filtered = filtered.filter(invoice => 
      invoice.balanceInvoiceNumber?.toLowerCase().includes(searchLower) ||
      invoice.originalInvoiceNumber?.toLowerCase().includes(searchLower) ||
      invoice.customerName?.toLowerCase().includes(searchLower) ||
      invoice.customerPhone?.toLowerCase().includes(searchLower)
    );
  }
  
  // Status filter
  if (balanceInvoiceFilterStatus !== 'all') {
    filtered = filtered.filter(invoice => 
      balanceInvoiceFilterStatus === 'settled' ? invoice.remainingBalance <= 0 : invoice.remainingBalance > 0
    );
  }
  
  setFilteredBalanceInvoices(filtered);
};

// Download balance invoice PDF
const downloadBalanceInvoicePDF = async (balanceInvoice) => {
  try {
    // Fetch original invoice details
    const originalInvoiceQuery = query(
      collection(db, 'invoices'),
      where('invoiceNumber', '==', balanceInvoice.originalInvoiceNumber)
    );
    const originalSnapshot = await getDocs(originalInvoiceQuery);
    let originalInvoice = null;
    
    if (!originalSnapshot.empty) {
      originalInvoice = { id: originalSnapshot.docs[0].id, ...originalSnapshot.docs[0].data() };
    }
    
    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a5'
    });

    const pageWidth = pdf.internal.pageSize.getWidth();
    const primaryColor = [41, 128, 185];

    // Header
    pdf.setFillColor(...primaryColor);
    pdf.rect(0, 0, pageWidth, 25, "F");

    pdf.setFontSize(16);
    pdf.setTextColor(255, 255, 255);
    pdf.text("BALANCE INVOICE", pageWidth / 2, 10, { align: "center" });

    pdf.setFontSize(9);
    pdf.text(`Invoice No: ${balanceInvoice.balanceInvoiceNumber}`, pageWidth / 2, 18, { align: "center" });

    let y = 35;

    // Customer Info
    pdf.setFontSize(12);
    pdf.setTextColor(...primaryColor);
    pdf.text("CUSTOMER INFORMATION", 10, y);

    y += 8;
    pdf.setTextColor(0, 0, 0);
    pdf.setFontSize(10);

    pdf.text(`Name: ${balanceInvoice.customerName || 'N/A'}`, 10, y);
    pdf.text(`Phone: ${balanceInvoice.customerPhone || 'N/A'}`, pageWidth - 50, y);

    y += 7;
    pdf.text(`Original Invoice: ${balanceInvoice.originalInvoiceNumber}`, 10, y);
    pdf.text(`Date: ${balanceInvoice.formattedDate}`, pageWidth - 55, y);

    // Payment Details
    y += 15;
    pdf.setFontSize(12);
    pdf.setTextColor(...primaryColor);
    pdf.text("PAYMENT DETAILS", 10, y);

    pdf.setFontSize(10);
    pdf.setTextColor(0, 0, 0);

    y += 8;
    pdf.text(`Original Amount: Rs. ${balanceInvoice.originalAmount.toFixed(2)}`, 10, y);
    
    y += 7;
    pdf.text(`Previous Advance: Rs. ${balanceInvoice.originalAdvance.toFixed(2)}`, 10, y);
    
    y += 7;
    pdf.text(`Previous Balance: Rs. ${balanceInvoice.originalBalance.toFixed(2)}`, 10, y);

    y += 7;
    pdf.setFontSize(11);
    pdf.setTextColor(0, 128, 0);
    pdf.text(`Amount Paid Now: Rs. ${balanceInvoice.paidAmount.toFixed(2)}`, 10, y);

    y += 7;
    pdf.setTextColor(0, 0, 0);
    pdf.text(`Payment Method: ${balanceInvoice.paymentMethod}`, 10, y);
    pdf.text(`Payment Date: ${balanceInvoice.formattedDate}`, pageWidth - 55, y);

    y += 10;
    if (balanceInvoice.remainingBalance > 0) {
      pdf.setTextColor(255, 0, 0);
      pdf.setFontSize(12);
      pdf.text(`Remaining Balance: Rs. ${balanceInvoice.remainingBalance.toFixed(2)}`, 10, y);
    } else {
      pdf.setTextColor(0, 128, 0);
      pdf.setFontSize(12);
      pdf.text(`FULLY PAID - Thank you!`, 10, y);
    }

    // Products summary
    if (originalInvoice) {
      y += 15;
      pdf.setTextColor(...primaryColor);
      pdf.setFontSize(10);
      pdf.text("Products:", 10, y);
      
      y += 6;
      pdf.setTextColor(0, 0, 0);
      pdf.setFontSize(9);
      pdf.text(`Lens: ${originalInvoice.products?.lensModel || 'N/A'}`, 10, y);
      pdf.text(`Frame: ${originalInvoice.products?.frameModel || 'N/A'}`, pageWidth - 55, y);
    }

    pdf.save(`${balanceInvoice.balanceInvoiceNumber}_BALANCE.pdf`);
    alert('PDF downloaded successfully!');
    
  } catch (error) {
    console.error('Error downloading PDF:', error);
    alert('Error downloading PDF: ' + error.message);
  }
};

// Delete balance invoice
const deleteBalanceInvoice = async (balanceInvoiceId, balanceInvoiceNumber) => {
  if (window.confirm(`Are you sure you want to delete balance invoice ${balanceInvoiceNumber}?\n\nThis action cannot be undone!`)) {
    try {
      // Get the balance invoice data first
      const balanceInvoiceRef = doc(db, 'balance_invoices', balanceInvoiceId);
      const balanceDoc = await getDoc(balanceInvoiceRef);
      const balanceData = balanceDoc.data();
      
      // Update the original invoice to remove this payment
      if (balanceData && balanceData.originalInvoiceId) {
        const originalInvoiceRef = doc(db, 'invoices', balanceData.originalInvoiceId);
        const originalDoc = await getDoc(originalInvoiceRef);
        
        if (originalDoc.exists()) {
          const originalData = originalDoc.data();
          const currentAdvance = originalData.financial?.advancePayment || 0;
          const updatedAdvance = currentAdvance - balanceData.paidAmount;
          const totalAmount = originalData.financial?.totalAmount || 0;
          const updatedBalanceDue = totalAmount - updatedAdvance;
          
          // Update original invoice
          await updateDoc(originalInvoiceRef, {
            'financial.advancePayment': updatedAdvance,
            'financial.balanceDue': updatedBalanceDue,
            status: updatedBalanceDue <= 0 ? 'paid' : 'pending'
          });
        }
      }
      
      // Delete balance invoice
      await deleteDoc(balanceInvoiceRef);
      
      alert(`Balance invoice ${balanceInvoiceNumber} deleted successfully!`);
      await fetchAllBalanceInvoices(); // Refresh the list
      
    } catch (error) {
      console.error('Error deleting balance invoice:', error);
      alert('Error deleting balance invoice: ' + error.message);
    }
  }
};

// View balance invoice details
const viewBalanceInvoiceDetails = (invoice) => {
  setSelectedBalanceInvoice(invoice);
  setShowBalanceInvoiceDetails(true);
};

// Generate summary report
const generateBalanceSummaryReport = async () => {
  const pdf = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: 'a4'
  });

  const pageWidth = pdf.internal.pageSize.getWidth();
  const primaryColor = [41, 128, 185];

  // Header
  pdf.setFillColor(...primaryColor);
  pdf.rect(0, 0, pageWidth, 25, "F");

  pdf.setFontSize(18);
  pdf.setTextColor(255, 255, 255);
  pdf.text("BALANCE INVOICES SUMMARY REPORT", pageWidth / 2, 10, { align: "center" });

  pdf.setFontSize(10);
  pdf.text(`Generated: ${new Date().toLocaleString()}`, pageWidth / 2, 18, { align: "center" });

  let y = 35;

  // Summary stats
  const totalPaid = filteredBalanceInvoices.reduce((sum, inv) => sum + (inv.paidAmount || 0), 0);
  const totalRemaining = filteredBalanceInvoices.reduce((sum, inv) => sum + (inv.remainingBalance || 0), 0);
  const settledCount = filteredBalanceInvoices.filter(inv => inv.remainingBalance <= 0).length;
  const partialCount = filteredBalanceInvoices.filter(inv => inv.remainingBalance > 0).length;

  pdf.setFontSize(12);
  pdf.setTextColor(...primaryColor);
  pdf.text("SUMMARY", 10, y);

  y += 7;
  pdf.setFontSize(10);
  pdf.setTextColor(0, 0, 0);
  pdf.text(`Total Balance Invoices: ${filteredBalanceInvoices.length}`, 10, y);
  pdf.text(`Settled: ${settledCount}`, 80, y);
  pdf.text(`Partial: ${partialCount}`, 150, y);

  y += 7;
  pdf.text(`Total Amount Paid: Rs. ${totalPaid.toFixed(2)}`, 10, y);
  pdf.text(`Total Remaining: Rs. ${totalRemaining.toFixed(2)}`, 80, y);

  y += 15;

  // Table headers
  pdf.setFillColor(...primaryColor);
  pdf.rect(10, y, 35, 8, 'F');
  pdf.rect(45, y, 45, 8, 'F');
  pdf.rect(90, y, 35, 8, 'F');
  pdf.rect(125, y, 30, 8, 'F');
  pdf.rect(155, y, 30, 8, 'F');
  pdf.rect(185, y, 30, 8, 'F');

  pdf.setTextColor(255, 255, 255);
  pdf.setFontSize(9);
  pdf.text("Balance Invoice", 12, y + 5);
  pdf.text("Original Invoice", 47, y + 5);
  pdf.text("Customer", 92, y + 5);
  pdf.text("Paid Amount", 127, y + 5);
  pdf.text("Remaining", 157, y + 5);
  pdf.text("Date", 187, y + 5);

  y += 8;

  // Table rows
  pdf.setTextColor(0, 0, 0);
  for (let invoice of filteredBalanceInvoices.slice(0, 20)) {
    if (y > 250) {
      pdf.addPage();
      y = 20;
    }
    
    pdf.rect(10, y, 35, 7);
    pdf.rect(45, y, 45, 7);
    pdf.rect(90, y, 35, 7);
    pdf.rect(125, y, 30, 7);
    pdf.rect(155, y, 30, 7);
    pdf.rect(185, y, 30, 7);
    
    pdf.text(invoice.balanceInvoiceNumber || 'N/A', 12, y + 5);
    pdf.text(invoice.originalInvoiceNumber || 'N/A', 47, y + 5);
    pdf.text((invoice.customerName || 'N/A').substring(0, 15), 92, y + 5);
    pdf.text(`Rs. ${(invoice.paidAmount || 0).toFixed(2)}`, 127, y + 5);
    pdf.text(`Rs. ${(invoice.remainingBalance || 0).toFixed(2)}`, 157, y + 5);
    pdf.text(invoice.formattedDate || 'N/A', 187, y + 5);
    
    y += 7;
  }

  pdf.save(`BALANCE_INVOICES_SUMMARY_${Date.now()}.pdf`);
};

// Fetch balance invoices when component mounts
useEffect(() => {
  if (selectedOption === "viewBalanceInvoice") {
    fetchAllBalanceInvoices();
  }
}, [selectedOption]);

// Apply filters when filter criteria change
useEffect(() => {
  filterBalanceInvoices();
}, [balanceInvoiceSearchTerm, balanceInvoiceFilterStatus, allBalanceInvoices]);

// Reset filters
const resetBalanceFilters = () => {
  setBalanceInvoiceSearchTerm('');
  setBalanceInvoiceFilterStatus('all');
  setFilteredBalanceInvoices(allBalanceInvoices);
};






 



////////////////////////////////////////////////////// view all invoice /////////////////////////////////////////////////////////////////////////
// Add state for original invoices
const [allInvoices, setAllInvoices] = useState([]);
const [invoiceSearchTerm, setInvoiceSearchTerm] = useState('');
const [invoiceFilterStatus, setInvoiceFilterStatus] = useState('all');
const [invoiceFilterPaymentMethod, setInvoiceFilterPaymentMethod] = useState('all');
const [invoiceDateRange, setInvoiceDateRange] = useState({ start: '', end: '' });
const [selectedInvoiceDetails, setSelectedInvoiceDetails] = useState(null);
const [showInvoiceDetails, setShowInvoiceDetails] = useState(false);

// Fetch all original invoices
const fetchAllInvoices = async () => {
  try {
    setIsLoadingInvoices(true);
    const invoicesQuery = query(
      collection(db, 'invoices'),
      orderBy('createdAt', 'desc')
    );
    const invoicesSnapshot = await getDocs(invoicesQuery);
    const invoicesList = [];
    
    for (const doc of invoicesSnapshot.docs) {
      const data = doc.data();
      
      // Fetch balance invoices for this original invoice
      const balanceQuery = query(
        collection(db, 'balance_invoices'),
        where('originalInvoiceNumber', '==', data.invoiceNumber)
      );
      const balanceSnapshot = await getDocs(balanceQuery);
      const balancePayments = [];
      let totalBalancePaid = 0;
      
      balanceSnapshot.forEach(balanceDoc => {
        const balanceData = balanceDoc.data();
        balancePayments.push({
          id: balanceDoc.id,
          amount: balanceData.paidAmount,
          date: balanceData.createdAt,
          method: balanceData.paymentMethod,
          invoiceNumber: balanceData.balanceInvoiceNumber
        });
        totalBalancePaid += balanceData.paidAmount || 0;
      });
      
      invoicesList.push({
        id: doc.id,
        ...data,
        formattedDate: new Date(data.createdAt).toLocaleDateString(),
        formattedTime: new Date(data.createdAt).toLocaleTimeString(),
        balancePayments: balancePayments,
        totalBalancePaid: totalBalancePaid,
        status: data.status || (data.financial?.balanceDue <= 0 ? 'paid' : 'pending'),
        statusColor: data.financial?.balanceDue <= 0 ? '#4CAF50' : '#ff9800'
      });
    }
    
    setAllInvoices(invoicesList);
    setFilteredInvoices(invoicesList);
    setIsLoadingInvoices(false);
  } catch (error) {
    console.error('Error fetching invoices:', error);
    setIsLoadingInvoices(false);
    alert('Error fetching invoices: ' + error.message);
  }
};

// Filter invoices
const filterInvoices = () => {
  let filtered = [...allInvoices];
  
  // Search filter
  if (invoiceSearchTerm) {
    const searchLower = invoiceSearchTerm.toLowerCase();
    filtered = filtered.filter(invoice => 
      invoice.invoiceNumber?.toLowerCase().includes(searchLower) ||
      invoice.customer?.fullName?.toLowerCase().includes(searchLower) ||
      invoice.customer?.tpNo?.toLowerCase().includes(searchLower) ||
      invoice.customer?.email?.toLowerCase().includes(searchLower)
    );
  }
  
  // Status filter
  if (invoiceFilterStatus !== 'all') {
    filtered = filtered.filter(invoice => 
      invoiceFilterStatus === 'paid' ? invoice.financial?.balanceDue <= 0 : invoice.financial?.balanceDue > 0
    );
  }
  
  // Payment method filter
  if (invoiceFilterPaymentMethod !== 'all') {
    filtered = filtered.filter(invoice => 
      invoice.financial?.paymentMethod === invoiceFilterPaymentMethod
    );
  }
  
  // Date range filter
  if (invoiceDateRange.start) {
    const startDate = new Date(invoiceDateRange.start);
    startDate.setHours(0, 0, 0, 0);
    filtered = filtered.filter(invoice => new Date(invoice.createdAt) >= startDate);
  }
  
  if (invoiceDateRange.end) {
    const endDate = new Date(invoiceDateRange.end);
    endDate.setHours(23, 59, 59, 999);
    filtered = filtered.filter(invoice => new Date(invoice.createdAt) <= endDate);
  }
  
  setFilteredInvoices(filtered);
};

// Download original invoice PDF
const downloadOriginalInvoicePDF = async (invoice) => {
  try {
    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a5'
    });

    const pageWidth = pdf.internal.pageSize.getWidth();
    const primaryColor = [41, 128, 185];

    // Header
    pdf.setFillColor(...primaryColor);
    pdf.rect(0, 0, pageWidth, 25, "F");

    pdf.setFontSize(16);
    pdf.setTextColor(255, 255, 255);
    pdf.text("OPTICAL INVOICE", pageWidth / 2, 10, { align: "center" });

    pdf.setFontSize(10);
    pdf.text(`Invoice No: ${invoice.invoiceNumber}`, pageWidth / 2, 18, { align: "center" });

    let y = 35;

    // Customer Info
    pdf.setFontSize(12);
    pdf.setTextColor(...primaryColor);
    pdf.text("CUSTOMER INFORMATION", 10, y);

    y += 8;
    pdf.setTextColor(0, 0, 0);
    pdf.setFontSize(10);

    pdf.text(`Name: ${invoice.customer?.fullName || 'N/A'}`, 10, y);
    pdf.text(`Age: ${invoice.customer?.age || 'N/A'}`, pageWidth - 40, y);

    y += 7;
    pdf.text(`Telephone: ${invoice.customer?.tpNo || 'N/A'}`, 10, y);

    y += 7;
    pdf.text(`Email: ${invoice.customer?.email || 'N/A'}`, 10, y);

    y += 7;
    pdf.text(`Address: ${invoice.customer?.address || 'N/A'}`, 10, y);

    // Prescription
    y += 15;
    pdf.setFontSize(12);
    pdf.setTextColor(...primaryColor);
    pdf.text("OPTICAL PRESCRIPTION", 10, y);

    y += 8;
    pdf.setFontSize(9);
    pdf.setTextColor(0, 0, 0);
    
    // Right Eye
    pdf.text("Right Eye (OD):", 10, y);
    pdf.text(`VA: ${invoice.prescription?.rightEye?.visualAcuity || 'N/A'}`, 10, y + 5);
    pdf.text(`SPH: ${invoice.prescription?.rightEye?.sph || 'N/A'}`, 10, y + 10);
    pdf.text(`CYL: ${invoice.prescription?.rightEye?.cyl || 'N/A'}`, 10, y + 15);
    pdf.text(`AXIS: ${invoice.prescription?.rightEye?.axis || 'N/A'}`, 10, y + 20);
    pdf.text(`ADD: ${invoice.prescription?.rightEye?.add || 'N/A'}`, 10, y + 25);
    
    // Left Eye
    pdf.text("Left Eye (OS):", pageWidth / 2, y);
    pdf.text(`VA: ${invoice.prescription?.leftEye?.visualAcuity || 'N/A'}`, pageWidth / 2, y + 5);
    pdf.text(`SPH: ${invoice.prescription?.leftEye?.sph || 'N/A'}`, pageWidth / 2, y + 10);
    pdf.text(`CYL: ${invoice.prescription?.leftEye?.cyl || 'N/A'}`, pageWidth / 2, y + 15);
    pdf.text(`AXIS: ${invoice.prescription?.leftEye?.axis || 'N/A'}`, pageWidth / 2, y + 20);
    pdf.text(`ADD: ${invoice.prescription?.leftEye?.add || 'N/A'}`, pageWidth / 2, y + 25);

    y += 35;

    // Product Details
    pdf.setFontSize(12);
    pdf.setTextColor(...primaryColor);
    pdf.text("LENS & FRAME DETAILS", 10, y);

    y += 8;
    pdf.setFontSize(10);
    pdf.setTextColor(0, 0, 0);

    pdf.text(`Lens Model: ${invoice.products?.lensModel || 'N/A'}`, 10, y);
    pdf.text(`Rs. ${(invoice.products?.lensPrice || 0).toFixed(2)}`, pageWidth - 40, y);

    y += 6;
    pdf.text(`Frame Model: ${invoice.products?.frameModel || 'N/A'}`, 10, y);
    pdf.text(`Rs. ${(invoice.products?.framePrice || 0).toFixed(2)}`, pageWidth - 40, y);

    // Payment Section
    y += 15;
    pdf.setFontSize(12);
    pdf.setTextColor(...primaryColor);
    pdf.text("PAYMENT SUMMARY", 10, y);

    pdf.setFontSize(10);
    pdf.setTextColor(0, 0, 0);

    y += 8;
    pdf.text(`Subtotal: Rs. ${(invoice.financial?.subtotal || 0).toFixed(2)}`, 10, y);

    y += 6;
    pdf.text(`Discount: Rs. ${(invoice.financial?.discount || 0).toFixed(2)}`, 10, y);

    y += 6;
    pdf.text(`Total Amount: Rs. ${(invoice.financial?.totalAmount || 0).toFixed(2)}`, 10, y);

    y += 6;
    pdf.text(`Advance Paid: Rs. ${(invoice.financial?.advancePayment || 0).toFixed(2)}`, 10, y);
    
    y += 6;
    if (invoice.totalBalancePaid > 0) {
      pdf.text(`Balance Payments: Rs. ${invoice.totalBalancePaid.toFixed(2)}`, 10, y);
      y += 6;
    }
    
    y += 6;
    pdf.setFontSize(11);
    pdf.setTextColor(primaryColor[0], primaryColor[1], primaryColor[2]);
    pdf.text(`Balance Due: Rs. ${(invoice.financial?.balanceDue || 0).toFixed(2)}`, 10, y);

    pdf.save(`${invoice.invoiceNumber}_INVOICE.pdf`);
    alert('PDF downloaded successfully!');
    
  } catch (error) {
    console.error('Error downloading PDF:', error);
    alert('Error downloading PDF: ' + error.message);
  }
};

// Delete invoice
const deleteInvoice = async (invoiceId, invoiceNumber) => {
  if (window.confirm(`Are you sure you want to delete invoice ${invoiceNumber}?\n\nThis will also delete all related balance invoices!\nThis action cannot be undone!`)) {
    try {
      // First, delete all related balance invoices
      const balanceQuery = query(
        collection(db, 'balance_invoices'),
        where('originalInvoiceNumber', '==', invoiceNumber)
      );
      const balanceSnapshot = await getDocs(balanceQuery);
      
      for (const balanceDoc of balanceSnapshot.docs) {
        await deleteDoc(doc(db, 'balance_invoices', balanceDoc.id));
      }
      
      // Then delete the original invoice
      await deleteDoc(doc(db, 'invoices', invoiceId));
      
      alert(`Invoice ${invoiceNumber} and all related balance invoices deleted successfully!`);
      await fetchAllInvoices(); // Refresh the list
      
    } catch (error) {
      console.error('Error deleting invoice:', error);
      alert('Error deleting invoice: ' + error.message);
    }
  }
};

// View invoice details
const viewInvoiceDetails = (invoice) => {
  setSelectedInvoiceDetails(invoice);
  setShowInvoiceDetails(true);
};

// Generate invoice summary report
const generateInvoiceSummaryReport = async () => {
  const pdf = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: 'a4'
  });

  const pageWidth = pdf.internal.pageSize.getWidth();
  const primaryColor = [41, 128, 185];

  // Header
  pdf.setFillColor(...primaryColor);
  pdf.rect(0, 0, pageWidth, 25, "F");

  pdf.setFontSize(18);
  pdf.setTextColor(255, 255, 255);
  pdf.text("INVOICES SUMMARY REPORT", pageWidth / 2, 10, { align: "center" });

  pdf.setFontSize(10);
  pdf.text(`Generated: ${new Date().toLocaleString()}`, pageWidth / 2, 18, { align: "center" });

  let y = 35;

  // Summary stats
  const totalAmount = filteredInvoices.reduce((sum, inv) => sum + (inv.financial?.totalAmount || 0), 0);
  const totalPaid = filteredInvoices.reduce((sum, inv) => sum + (inv.financial?.advancePayment || 0) + (inv.totalBalancePaid || 0), 0);
  const totalDue = filteredInvoices.reduce((sum, inv) => sum + (inv.financial?.balanceDue || 0), 0);
  const paidCount = filteredInvoices.filter(inv => inv.financial?.balanceDue <= 0).length;
  const pendingCount = filteredInvoices.filter(inv => inv.financial?.balanceDue > 0).length;

  pdf.setFontSize(12);
  pdf.setTextColor(...primaryColor);
  pdf.text("SUMMARY", 10, y);

  y += 7;
  pdf.setFontSize(10);
  pdf.setTextColor(0, 0, 0);
  pdf.text(`Total Invoices: ${filteredInvoices.length}`, 10, y);
  pdf.text(`Paid: ${paidCount}`, 80, y);
  pdf.text(`Pending: ${pendingCount}`, 140, y);

  y += 7;
  pdf.text(`Total Amount: Rs. ${totalAmount.toFixed(2)}`, 10, y);
  pdf.text(`Total Paid: Rs. ${totalPaid.toFixed(2)}`, 80, y);
  pdf.text(`Total Due: Rs. ${totalDue.toFixed(2)}`, 140, y);

  y += 15;

  // Table headers
  pdf.setFillColor(...primaryColor);
  pdf.rect(10, y, 35, 8, 'F');
  pdf.rect(45, y, 40, 8, 'F');
  pdf.rect(85, y, 40, 8, 'F');
  pdf.rect(125, y, 30, 8, 'F');
  pdf.rect(155, y, 30, 8, 'F');
  pdf.rect(185, y, 30, 8, 'F');

  pdf.setTextColor(255, 255, 255);
  pdf.setFontSize(9);
  pdf.text("Invoice #", 12, y + 5);
  pdf.text("Customer", 47, y + 5);
  pdf.text("Products", 87, y + 5);
  pdf.text("Total", 127, y + 5);
  pdf.text("Paid", 157, y + 5);
  pdf.text("Due", 187, y + 5);

  y += 8;

  // Table rows
  pdf.setTextColor(0, 0, 0);
  for (let invoice of filteredInvoices.slice(0, 20)) {
    if (y > 250) {
      pdf.addPage();
      y = 20;
    }
    
    pdf.rect(10, y, 35, 7);
    pdf.rect(45, y, 40, 7);
    pdf.rect(85, y, 40, 7);
    pdf.rect(125, y, 30, 7);
    pdf.rect(155, y, 30, 7);
    pdf.rect(185, y, 30, 7);
    
    pdf.text(invoice.invoiceNumber || 'N/A', 12, y + 5);
    pdf.text((invoice.customer?.fullName || 'N/A').substring(0, 15), 47, y + 5);
    pdf.text(`${invoice.products?.frameModel || 'N/A'} / ${invoice.products?.lensModel || 'N/A'}`, 87, y + 5);
    pdf.text(`Rs. ${(invoice.financial?.totalAmount || 0).toFixed(2)}`, 127, y + 5);
    pdf.text(`Rs. ${((invoice.financial?.advancePayment || 0) + (invoice.totalBalancePaid || 0)).toFixed(2)}`, 157, y + 5);
    pdf.text(`Rs. ${(invoice.financial?.balanceDue || 0).toFixed(2)}`, 187, y + 5);
    
    y += 7;
  }

  pdf.save(`INVOICES_SUMMARY_${Date.now()}.pdf`);
};

// Reset filters
const resetInvoiceFilters = () => {
  setInvoiceSearchTerm('');
  setInvoiceFilterStatus('all');
  setInvoiceFilterPaymentMethod('all');
  setInvoiceDateRange({ start: '', end: '' });
  setFilteredInvoices(allInvoices);
};

// Fetch invoices when component mounts
useEffect(() => {
  if (selectedOption === "viewInvoice") {
    fetchAllInvoices();
  }
}, [selectedOption]);

// Apply filters when filter criteria change
useEffect(() => {
  filterInvoices();
}, [invoiceSearchTerm, invoiceFilterStatus, invoiceFilterPaymentMethod, invoiceDateRange.start, invoiceDateRange.end, allInvoices]);







////////////////////////////////////////////////////// view all patient //////////////////////////////////////////////////////////////////////////

// Add state for patient directory
const [patients, setPatients] = useState([]);
const [filteredPatients, setFilteredPatients] = useState([]);
const [patientSearchTerm, setPatientSearchTerm] = useState('');
const [patientFilterAge, setPatientFilterAge] = useState('all');
const [patientFilterGender, setPatientFilterGender] = useState('all');
const [selectedPatient, setSelectedPatient] = useState(null);
const [showPatientDetails, setShowPatientDetails] = useState(false);
const [isLoadingPatients, setIsLoadingPatients] = useState(false);
const [patientDateRange, setPatientDateRange] = useState({ start: '', end: '' });

// Fetch all patients from invoices
const fetchAllPatients = async () => {
  try {
    setIsLoadingPatients(true);
    const invoicesQuery = query(
      collection(db, 'invoices'),
      orderBy('createdAt', 'desc')
    );
    const invoicesSnapshot = await getDocs(invoicesQuery);
    const patientsMap = new Map(); // Use Map to avoid duplicates
    
    for (const doc of invoicesSnapshot.docs) {
      const data = doc.data();
      const customer = data.customer;
      
      if (customer && customer.firstName) {
        const patientKey = `${customer.firstName}_${customer.lastName}_${customer.tpNo}`;
        
        if (!patientsMap.has(patientKey)) {
          // Fetch all invoices for this patient
          const patientInvoices = [];
          for (const invoiceDoc of invoicesSnapshot.docs) {
            const invoiceData = invoiceDoc.data();
            if (invoiceData.customer && 
                invoiceData.customer.firstName === customer.firstName && 
                invoiceData.customer.lastName === customer.lastName &&
                invoiceData.customer.tpNo === customer.tpNo) {
              patientInvoices.push({
                id: invoiceDoc.id,
                invoiceNumber: invoiceData.invoiceNumber,
                date: invoiceData.createdAt,
                totalAmount: invoiceData.financial?.totalAmount || 0,
                paidAmount: (invoiceData.financial?.advancePayment || 0) + (invoiceData.totalBalancePaid || 0),
                balanceDue: invoiceData.financial?.balanceDue || 0,
                status: invoiceData.financial?.balanceDue <= 0 ? 'paid' : 'pending',
                products: invoiceData.products
              });
            }
          }
          
          patientsMap.set(patientKey, {
            id: patientKey,
            title: customer.title || '',
            firstName: customer.firstName,
            lastName: customer.lastName,
            fullName: `${customer.title || ''} ${customer.firstName} ${customer.lastName}`.trim(),
            address: customer.address || '',
            tpNo: customer.tpNo || '',
            email: customer.email || '',
            age: customer.age || '',
            gender: customer.gender || 'Not specified',
            lastVisit: data.createdAt,
            firstVisit: patientInvoices[patientInvoices.length - 1]?.date || data.createdAt,
            totalInvoices: patientInvoices.length,
            totalSpent: patientInvoices.reduce((sum, inv) => sum + inv.totalAmount, 0),
            totalPaid: patientInvoices.reduce((sum, inv) => sum + inv.paidAmount, 0),
            totalDue: patientInvoices.reduce((sum, inv) => sum + inv.balanceDue, 0),
            invoices: patientInvoices,
            prescriptions: [data.prescription] // Store latest prescription
          });
        } else {
          // Update existing patient with additional data
          const existingPatient = patientsMap.get(patientKey);
          existingPatient.totalInvoices += 1;
          existingPatient.totalSpent += data.financial?.totalAmount || 0;
          existingPatient.totalPaid += (data.financial?.advancePayment || 0) + (data.totalBalancePaid || 0);
          existingPatient.totalDue += data.financial?.balanceDue || 0;
          if (new Date(data.createdAt) > new Date(existingPatient.lastVisit)) {
            existingPatient.lastVisit = data.createdAt;
          }
          if (new Date(data.createdAt) < new Date(existingPatient.firstVisit)) {
            existingPatient.firstVisit = data.createdAt;
          }
          existingPatient.invoices.push({
            id: doc.id,
            invoiceNumber: data.invoiceNumber,
            date: data.createdAt,
            totalAmount: data.financial?.totalAmount || 0,
            paidAmount: (data.financial?.advancePayment || 0) + (data.totalBalancePaid || 0),
            balanceDue: data.financial?.balanceDue || 0,
            status: data.financial?.balanceDue <= 0 ? 'paid' : 'pending',
            products: data.products
          });
          existingPatient.prescriptions.push(data.prescription);
        }
      }
    }
    
    const patientsList = Array.from(patientsMap.values());
    setPatients(patientsList);
    setFilteredPatients(patientsList);
    setIsLoadingPatients(false);
  } catch (error) {
    console.error('Error fetching patients:', error);
    setIsLoadingPatients(false);
    alert('Error fetching patients: ' + error.message);
  }
};

// Filter patients
const filterPatients = () => {
  let filtered = [...patients];
  
  // Search filter
  if (patientSearchTerm) {
    const searchLower = patientSearchTerm.toLowerCase();
    filtered = filtered.filter(patient => 
      patient.fullName?.toLowerCase().includes(searchLower) ||
      patient.tpNo?.toLowerCase().includes(searchLower) ||
      patient.email?.toLowerCase().includes(searchLower) ||
      patient.address?.toLowerCase().includes(searchLower)
    );
  }
  
  // Age filter
  if (patientFilterAge !== 'all') {
    filtered = filtered.filter(patient => {
      const age = parseInt(patient.age);
      if (patientFilterAge === 'child') return age < 18;
      if (patientFilterAge === 'adult') return age >= 18 && age < 60;
      if (patientFilterAge === 'senior') return age >= 60;
      return true;
    });
  }
  
  // Gender filter
  if (patientFilterGender !== 'all') {
    filtered = filtered.filter(patient => 
      patient.gender?.toLowerCase() === patientFilterGender.toLowerCase()
    );
  }
  
  // Date range filter (last visit)
  if (patientDateRange.start) {
    const startDate = new Date(patientDateRange.start);
    startDate.setHours(0, 0, 0, 0);
    filtered = filtered.filter(patient => new Date(patient.lastVisit) >= startDate);
  }
  
  if (patientDateRange.end) {
    const endDate = new Date(patientDateRange.end);
    endDate.setHours(23, 59, 59, 999);
    filtered = filtered.filter(patient => new Date(patient.lastVisit) <= endDate);
  }
  
  setFilteredPatients(filtered);
};

// View patient details
const viewPatientDetails = (patient) => {
  setSelectedPatient(patient);
  setShowPatientDetails(true);
};

// Generate patient report PDF
const generatePatientReportPDF = async () => {
  const pdf = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: 'a4'
  });

  const pageWidth = pdf.internal.pageSize.getWidth();
  const primaryColor = [41, 128, 185];

  // Header
  pdf.setFillColor(...primaryColor);
  pdf.rect(0, 0, pageWidth, 25, "F");

  pdf.setFontSize(18);
  pdf.setTextColor(255, 255, 255);
  pdf.text("PATIENT DIRECTORY REPORT", pageWidth / 2, 10, { align: "center" });

  pdf.setFontSize(10);
  pdf.text(`Generated: ${new Date().toLocaleString()}`, pageWidth / 2, 18, { align: "center" });

  let y = 35;

  // Summary stats
  const totalPatients = filteredPatients.length;
  const totalRevenue = filteredPatients.reduce((sum, p) => sum + p.totalSpent, 0);
  const totalDue = filteredPatients.reduce((sum, p) => sum + p.totalDue, 0);
  const avgSpent = totalPatients > 0 ? totalRevenue / totalPatients : 0;

  pdf.setFontSize(12);
  pdf.setTextColor(...primaryColor);
  pdf.text("SUMMARY", 10, y);

  y += 7;
  pdf.setFontSize(10);
  pdf.setTextColor(0, 0, 0);
  pdf.text(`Total Patients: ${totalPatients}`, 10, y);
  pdf.text(`Total Revenue: Rs. ${totalRevenue.toFixed(2)}`, 80, y);
  pdf.text(`Total Due: Rs. ${totalDue.toFixed(2)}`, 160, y);

  y += 7;
  pdf.text(`Average Spent: Rs. ${avgSpent.toFixed(2)}`, 10, y);

  y += 15;

  // Table headers
  pdf.setFillColor(...primaryColor);
  pdf.rect(10, y, 40, 8, 'F');
  pdf.rect(50, y, 35, 8, 'F');
  pdf.rect(85, y, 25, 8, 'F');
  pdf.rect(110, y, 25, 8, 'F');
  pdf.rect(135, y, 30, 8, 'F');
  pdf.rect(165, y, 30, 8, 'F');
  pdf.rect(195, y, 25, 8, 'F');

  pdf.setTextColor(255, 255, 255);
  pdf.setFontSize(9);
  pdf.text("Patient Name", 12, y + 5);
  pdf.text("Phone", 52, y + 5);
  pdf.text("Age", 87, y + 5);
  pdf.text("Invoices", 112, y + 5);
  pdf.text("Total Spent", 137, y + 5);
  pdf.text("Balance Due", 167, y + 5);
  pdf.text("Last Visit", 197, y + 5);

  y += 8;

  // Table rows
  pdf.setTextColor(0, 0, 0);
  for (let patient of filteredPatients.slice(0, 20)) {
    if (y > 250) {
      pdf.addPage();
      y = 20;
    }
    
    pdf.rect(10, y, 40, 7);
    pdf.rect(50, y, 35, 7);
    pdf.rect(85, y, 25, 7);
    pdf.rect(110, y, 25, 7);
    pdf.rect(135, y, 30, 7);
    pdf.rect(165, y, 30, 7);
    pdf.rect(195, y, 25, 7);
    
    pdf.text(patient.fullName.substring(0, 20), 12, y + 5);
    pdf.text(patient.tpNo || 'N/A', 52, y + 5);
    pdf.text(patient.age || 'N/A', 87, y + 5);
    pdf.text(patient.totalInvoices.toString(), 112, y + 5);
    pdf.text(`Rs. ${patient.totalSpent.toFixed(2)}`, 137, y + 5);
    pdf.text(`Rs. ${patient.totalDue.toFixed(2)}`, 167, y + 5);
    pdf.text(new Date(patient.lastVisit).toLocaleDateString(), 197, y + 5);
    
    y += 7;
  }

  pdf.save(`PATIENT_REPORT_${Date.now()}.pdf`);
};

// Reset filters
const resetPatientFilters = () => {
  setPatientSearchTerm('');
  setPatientFilterAge('all');
  setPatientFilterGender('all');
  setPatientDateRange({ start: '', end: '' });
  setFilteredPatients(patients);
};

// Fetch patients when component mounts
useEffect(() => {
  if (selectedOption === "viewPatient") {
    fetchAllPatients();
  }
}, [selectedOption]);

// Apply filters when filter criteria change
useEffect(() => {
  filterPatients();
}, [patientSearchTerm, patientFilterAge, patientFilterGender, patientDateRange.start, patientDateRange.end, patients]);

// Get age group label
const getAgeGroup = (age) => {
  const ageNum = parseInt(age);
  if (ageNum < 18) return 'Child';
  if (ageNum >= 18 && ageNum < 60) return 'Adult';
  if (ageNum >= 60) return 'Senior';
  return 'Unknown';
};




//////////////////////////////////////////////   dashboard     /////////////////////////////////////////////////////////////////////////

// Add state for dashboard data
const [dashboardStats, setDashboardStats] = useState({
  totalRevenue: 0,
  totalInvoices: 0,
  totalPatients: 0,
  pendingBalance: 0,
  monthlyRevenue: [],
  topProducts: [],
  recentInvoices: [],
  paymentMethods: [],
  dailySales: [],
  framesSold: 0,
  lensesSold: 0,
  averageInvoiceValue: 0
});
const [isLoadingDashboard, setIsLoadingDashboard] = useState(false);
const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);

// Fetch dashboard data
const fetchDashboardData = async () => {
  try {
    setIsLoadingDashboard(true);
    
    // Fetch all invoices
    const invoicesQuery = query(collection(db, 'invoices'));
    const invoicesSnapshot = await getDocs(invoicesQuery);
    const invoices = [];
    
    for (const doc of invoicesSnapshot.docs) {
      const data = doc.data();
      
      // Fetch balance payments for this invoice
      const balanceQuery = query(
        collection(db, 'balance_invoices'),
        where('originalInvoiceNumber', '==', data.invoiceNumber)
      );
      const balanceSnapshot = await getDocs(balanceQuery);
      let totalBalancePaid = 0;
      
      balanceSnapshot.forEach(balanceDoc => {
        totalBalancePaid += balanceDoc.data().paidAmount || 0;
      });
      
      invoices.push({
        ...data,
        id: doc.id,
        totalPaid: (data.financial?.advancePayment || 0) + totalBalancePaid,
        totalBalancePaid: totalBalancePaid,
        createdAt: data.createdAt ? new Date(data.createdAt) : new Date()
      });
    }
    
    // Calculate total revenue (all paid amounts)
    const totalRevenue = invoices.reduce((sum, inv) => sum + (inv.totalPaid || 0), 0);
    
    // Calculate pending balance
    const pendingBalance = invoices.reduce((sum, inv) => sum + (inv.financial?.balanceDue || 0), 0);
    
    // Get unique patients
    const uniquePatients = new Map();
    invoices.forEach(inv => {
      if (inv.customer && inv.customer.firstName) {
        const key = `${inv.customer.firstName}_${inv.customer.lastName}_${inv.customer.tpNo}`;
        if (!uniquePatients.has(key)) {
          uniquePatients.set(key, inv.customer);
        }
      }
    });
    
    // Calculate monthly revenue for current year
    const monthlyRevenue = Array(12).fill(0);
    invoices.forEach(inv => {
      const year = inv.createdAt.getFullYear();
      const month = inv.createdAt.getMonth();
      if (year === selectedYear) {
        monthlyRevenue[month] += inv.totalPaid || 0;
      }
    });
    
    // Calculate daily sales for current month
    const daysInMonth = new Date(selectedYear, selectedMonth, 0).getDate();
    const dailySales = Array(daysInMonth).fill(0);
    invoices.forEach(inv => {
      const year = inv.createdAt.getFullYear();
      const month = inv.createdAt.getMonth() + 1;
      const day = inv.createdAt.getDate();
      if (year === selectedYear && month === selectedMonth) {
        dailySales[day - 1] += inv.totalPaid || 0;
      }
    });
    
    // Calculate top products
    const productSales = new Map();
    invoices.forEach(inv => {
      const frame = inv.products?.frameModel;
      const lens = inv.products?.lensModel;
      
      if (frame) {
        productSales.set(frame, (productSales.get(frame) || 0) + 1);
      }
      if (lens) {
        productSales.set(lens, (productSales.get(lens) || 0) + 1);
      }
    });
    
    const topProducts = Array.from(productSales.entries())
      .map(([name, count]) => ({ name, count }))
      .sort((a, b) => b.count - a.count)
      .slice(0, 5);
    
    // Calculate payment methods distribution
    const paymentMethods = new Map();
    invoices.forEach(inv => {
      const method = inv.financial?.paymentMethod || 'Cash';
      paymentMethods.set(method, (paymentMethods.get(method) || 0) + (inv.totalPaid || 0));
    });
    
    const paymentMethodsData = Array.from(paymentMethods.entries()).map(([name, value]) => ({
      name,
      value
    }));
    
    // Calculate frames and lenses sold
    let framesSold = 0;
    let lensesSold = 0;
    invoices.forEach(inv => {
      if (inv.products?.frameModel) framesSold++;
      if (inv.products?.lensModel) lensesSold++;
    });
    
    // Get recent invoices
    const recentInvoices = invoices
      .sort((a, b) => b.createdAt - a.createdAt)
      .slice(0, 5)
      .map(inv => ({
        invoiceNumber: inv.invoiceNumber,
        customerName: inv.customer?.fullName || 'N/A',
        totalAmount: inv.financial?.totalAmount || 0,
        paidAmount: inv.totalPaid || 0,
        balanceDue: inv.financial?.balanceDue || 0,
        date: inv.createdAt
      }));
    
    setDashboardStats({
      totalRevenue,
      totalInvoices: invoices.length,
      totalPatients: uniquePatients.size,
      pendingBalance,
      monthlyRevenue,
      topProducts,
      recentInvoices,
      paymentMethods: paymentMethodsData,
      dailySales,
      framesSold,
      lensesSold,
      averageInvoiceValue: invoices.length > 0 ? totalRevenue / invoices.length : 0
    });
    
    setIsLoadingDashboard(false);
  } catch (error) {
    console.error('Error fetching dashboard data:', error);
    setIsLoadingDashboard(false);
  }
};

// Chart configurations
const revenueChartData = {
  labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  datasets: [
    {
      label: 'Monthly Revenue (Rs.)',
      data: dashboardStats.monthlyRevenue,
      backgroundColor: 'rgba(41, 128, 185, 0.8)',
      borderColor: 'rgba(41, 128, 185, 1)',
      borderWidth: 2,
      borderRadius: 5,
    },
  ],
};

const revenueChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: true,
      text: `Monthly Revenue - ${selectedYear}`,
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      ticks: {
        callback: (value) => `Rs. ${value.toLocaleString()}`,
      },
    },
  },
};

const paymentMethodChartData = {
  labels: dashboardStats.paymentMethods.map(m => m.name),
  datasets: [
    {
      data: dashboardStats.paymentMethods.map(m => m.value),
      backgroundColor: [
        '#4CAF50',
        '#2196F3',
        '#FF9800',
        '#9C27B0',
        '#F44336',
      ],
      borderWidth: 0,
    },
  ],
};

const paymentMethodOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'bottom',
    },
    title: {
      display: true,
      text: 'Payment Methods Distribution',
    },
  },
};

const dailySalesChartData = {
  labels: Array.from({ length: dashboardStats.dailySales.length }, (_, i) => i + 1),
  datasets: [
    {
      label: `Daily Sales - ${selectedMonth}/${selectedYear}`,
      data: dashboardStats.dailySales,
      backgroundColor: 'rgba(76, 175, 80, 0.6)',
      borderColor: 'rgba(76, 175, 80, 1)',
      borderWidth: 1,
      fill: true,
    },
  ],
};

const dailySalesOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: true,
      text: `Daily Sales Performance`,
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      ticks: {
        callback: (value) => `Rs. ${value.toLocaleString()}`,
      },
    },
  },
};

// Fetch data on component mount and when year/month changes
useEffect(() => {
  if (selectedOption === "dashboard") {
    fetchDashboardData();
  }
}, [selectedOption, selectedYear, selectedMonth]);

// Format currency
const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'LKR',
    minimumFractionDigits: 2
  }).format(amount);
};



///////////////////////////////////////////////////////// view consultation ////////////////////////////////////////////////////////////////////

// Add state for consultations
const [consultations, setConsultations] = useState([]);
const [filteredConsultations, setFilteredConsultations] = useState([]);
const [consultationSearchTerm, setConsultationSearchTerm] = useState('');
const [consultationFilterStatus, setConsultationFilterStatus] = useState('all');
const [consultationDateRange, setConsultationDateRange] = useState({ start: '', end: '' });
const [isLoadingConsultations, setIsLoadingConsultations] = useState(false);
const [selectedConsultation, setSelectedConsultation] = useState(null);
const [showConsultationDetails, setShowConsultationDetails] = useState(false);
const [showUpdateStatusModal, setShowUpdateStatusModal] = useState(false);
const [selectedItemForStatus, setSelectedItemForStatus] = useState(null);
const [newStatus, setNewStatus] = useState('');

// Fetch all consultations
const fetchAllConsultations = async () => {
  try {
    setIsLoadingConsultations(true);
    const consultationsQuery = query(
      collection(db, 'consultations'),
      orderBy('createdAt', 'desc')
    );
    const consultationsSnapshot = await getDocs(consultationsQuery);
    const consultationsList = [];
    
    for (const doc of consultationsSnapshot.docs) {
      const data = doc.data();
      const items = data.items || [];
      
      // Calculate totals
      const totalAmount = items.reduce((sum, item) => sum + (item.price || 0), 0);
      const completedItems = items.filter(item => item.status === 'completed').length;
      const pendingItems = items.filter(item => item.status === 'pending').length;
      const cancelledItems = items.filter(item => item.status === 'cancelled').length;
      
      consultationsList.push({
        id: doc.id,
        ...data,
        items: items,
        totalAmount: totalAmount,
        completedItems: completedItems,
        pendingItems: pendingItems,
        cancelledItems: cancelledItems,
        formattedDate: data.createdAt ? new Date(data.createdAt.toDate()).toLocaleDateString() : 'N/A',
        formattedTime: data.createdAt ? new Date(data.createdAt.toDate()).toLocaleTimeString() : 'N/A',
        fullDate: data.createdAt ? new Date(data.createdAt.toDate()) : new Date()
      });
    }
    
    setConsultations(consultationsList);
    setFilteredConsultations(consultationsList);
    setIsLoadingConsultations(false);
  } catch (error) {
    console.error('Error fetching consultations:', error);
    setIsLoadingConsultations(false);
    alert('Error fetching consultations: ' + error.message);
  }
};

// Filter consultations
const filterConsultations = () => {
  let filtered = [...consultations];
  
  // Search filter
  if (consultationSearchTerm) {
    const searchLower = consultationSearchTerm.toLowerCase();
    filtered = filtered.filter(consultation => 
      consultation.customerName?.toLowerCase().includes(searchLower) ||
      consultation.id?.toLowerCase().includes(searchLower)
    );
  }
  
  // Status filter
  if (consultationFilterStatus !== 'all') {
    filtered = filtered.filter(consultation => {
      if (consultationFilterStatus === 'completed') {
        return consultation.pendingItems === 0 && consultation.cancelledItems === 0;
      } else if (consultationFilterStatus === 'pending') {
        return consultation.pendingItems > 0;
      } else if (consultationFilterStatus === 'cancelled') {
        return consultation.cancelledItems > 0;
      }
      return true;
    });
  }
  
  // Date range filter
  if (consultationDateRange.start) {
    const startDate = new Date(consultationDateRange.start);
    startDate.setHours(0, 0, 0, 0);
    filtered = filtered.filter(consultation => consultation.fullDate >= startDate);
  }
  
  if (consultationDateRange.end) {
    const endDate = new Date(consultationDateRange.end);
    endDate.setHours(23, 59, 59, 999);
    filtered = filtered.filter(consultation => consultation.fullDate <= endDate);
  }
  
  setFilteredConsultations(filtered);
};

// Update consultation item status
const updateConsultationItemStatus = async (consultationId, itemId, status) => {
  try {
    const consultationRef = doc(db, 'consultations', consultationId);
    const consultationDoc = await getDoc(consultationRef);
    
    if (consultationDoc.exists()) {
      const data = consultationDoc.data();
      const updatedItems = data.items.map(item => 
        item.id === itemId ? { ...item, status: status } : item
      );
      
      await updateDoc(consultationRef, { items: updatedItems });
      alert(`Item status updated to ${status}`);
      await fetchAllConsultations(); // Refresh the list
      setShowUpdateStatusModal(false);
      setSelectedItemForStatus(null);
    }
  } catch (error) {
    console.error('Error updating item status:', error);
    alert('Error updating item status: ' + error.message);
  }
};

// Delete consultation
const deleteConsultation = async (consultationId, customerName) => {
  if (window.confirm(`Are you sure you want to delete consultation for ${customerName}?\n\nThis action cannot be undone!`)) {
    try {
      await deleteDoc(doc(db, 'consultations', consultationId));
      alert('Consultation deleted successfully!');
      await fetchAllConsultations();
    } catch (error) {
      console.error('Error deleting consultation:', error);
      alert('Error deleting consultation: ' + error.message);
    }
  }
};

// Generate consultation report PDF
const generateConsultationReportPDF = async () => {
  const pdf = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: 'a4'
  });

  const pageWidth = pdf.internal.pageSize.getWidth();
  const primaryColor = [41, 128, 185];

  // Header
  pdf.setFillColor(...primaryColor);
  pdf.rect(0, 0, pageWidth, 25, "F");

  pdf.setFontSize(18);
  pdf.setTextColor(255, 255, 255);
  pdf.text("CONSULTATIONS REPORT", pageWidth / 2, 10, { align: "center" });

  pdf.setFontSize(10);
  pdf.text(`Generated: ${new Date().toLocaleString()}`, pageWidth / 2, 18, { align: "center" });

  let y = 35;

  // Summary stats
  const totalConsultations = filteredConsultations.length;
  const totalRevenue = filteredConsultations.reduce((sum, c) => sum + c.totalAmount, 0);
  const completedCount = filteredConsultations.filter(c => c.pendingItems === 0 && c.cancelledItems === 0).length;
  const pendingCount = filteredConsultations.filter(c => c.pendingItems > 0).length;

  pdf.setFontSize(12);
  pdf.setTextColor(...primaryColor);
  pdf.text("SUMMARY", 10, y);

  y += 7;
  pdf.setFontSize(10);
  pdf.setTextColor(0, 0, 0);
  pdf.text(`Total Consultations: ${totalConsultations}`, 10, y);
  pdf.text(`Total Revenue: Rs. ${totalRevenue.toFixed(2)}`, 80, y);
  pdf.text(`Completed: ${completedCount}`, 150, y);
  pdf.text(`Pending: ${pendingCount}`, 200, y);

  y += 15;

  // Table headers
  pdf.setFillColor(...primaryColor);
  pdf.rect(10, y, 30, 8, 'F');
  pdf.rect(40, y, 40, 8, 'F');
  pdf.rect(80, y, 30, 8, 'F');
  pdf.rect(110, y, 25, 8, 'F');
  pdf.rect(135, y, 25, 8, 'F');
  pdf.rect(160, y, 25, 8, 'F');
  pdf.rect(185, y, 30, 8, 'F');

  pdf.setTextColor(255, 255, 255);
  pdf.setFontSize(9);
  pdf.text("Date", 12, y + 5);
  pdf.text("Customer", 42, y + 5);
  pdf.text("Delivery Date", 82, y + 5);
  pdf.text("Items", 112, y + 5);
  pdf.text("Total", 137, y + 5);
  pdf.text("Completed", 162, y + 5);
  pdf.text("Status", 187, y + 5);

  y += 8;

  // Table rows
  pdf.setTextColor(0, 0, 0);
  for (let consultation of filteredConsultations.slice(0, 20)) {
    if (y > 250) {
      pdf.addPage();
      y = 20;
    }
    
    pdf.rect(10, y, 30, 7);
    pdf.rect(40, y, 40, 7);
    pdf.rect(80, y, 30, 7);
    pdf.rect(110, y, 25, 7);
    pdf.rect(135, y, 25, 7);
    pdf.rect(160, y, 25, 7);
    pdf.rect(185, y, 30, 7);
    
    pdf.text(consultation.formattedDate, 12, y + 5);
    pdf.text(consultation.customerName.substring(0, 20), 42, y + 5);
    pdf.text(consultation.deliveryDate || 'N/A', 82, y + 5);
    pdf.text(consultation.items.length.toString(), 112, y + 5);
    pdf.text(`Rs. ${consultation.totalAmount.toFixed(2)}`, 137, y + 5);
    pdf.text(consultation.completedItems.toString(), 162, y + 5);
    
    const status = consultation.pendingItems === 0 && consultation.cancelledItems === 0 ? 'Completed' : 
                   consultation.cancelledItems > 0 ? 'Cancelled' : 'Pending';
    pdf.text(status, 187, y + 5);
    
    y += 7;
  }

  pdf.save(`CONSULTATIONS_REPORT_${Date.now()}.pdf`);
};

// Reset filters
const resetConsultationFilters = () => {
  setConsultationSearchTerm('');
  setConsultationFilterStatus('all');
  setConsultationDateRange({ start: '', end: '' });
  setFilteredConsultations(consultations);
};

// Fetch consultations when component mounts
useEffect(() => {
  if (selectedOption === "viewConsultation") {
    fetchAllConsultations();
  }
}, [selectedOption]);

// Apply filters when filter criteria change
useEffect(() => {
  filterConsultations();
}, [consultationSearchTerm, consultationFilterStatus, consultationDateRange.start, consultationDateRange.end, consultations]);

// Get status badge color
const getStatusBadge = (consultation) => {
  if (consultation.pendingItems === 0 && consultation.cancelledItems === 0) {
    return { text: 'Completed', color: '#4CAF50' };
  } else if (consultation.cancelledItems > 0) {
    return { text: 'Partially Cancelled', color: '#f44336' };
  } else {
    return { text: 'Pending', color: '#ff9800' };
  }
};



/////////////////////////////////////////// customer card - optica membership /////////////////////////////////////////////////////////

const [membershipData, setMembershipData] = useState({
  customerName: '',
  telephone: '',
  issueDate: '',
  expireDate: '',
  discount: 15, // 15% discount
  status: 'active',
  cardNumber: ''
});

const [membershipErrors, setMembershipErrors] = useState({});
const [isSavingCard, setIsSavingCard] = useState(false);
const [cardSuccess, setCardSuccess] = useState(false);

// Function to generate unique card number
const generateCardNumber = () => {
  const prefix = 'OPT';
  const timestamp = Date.now().toString().slice(-8);
  const random = Math.floor(Math.random() * 1000).toString().padStart(3, '0');
  return `${prefix}-${timestamp}-${random}`;
};
// Handle membership form input changes
const handleMembershipInputChange = (e) => {
  const { name, value } = e.target;
  
  setMembershipData(prev => ({
    ...prev,
    [name]: value
  }));
  
  // Auto-calculate expire date when issue date is selected
  if (name === 'issueDate' && value) {
    const issueDateObj = new Date(value);
    const expireDateObj = new Date(issueDateObj);
    expireDateObj.setFullYear(expireDateObj.getFullYear() + 1);
    
    const expireDateStr = expireDateObj.toISOString().split('T')[0];
    
    setMembershipData(prev => ({
      ...prev,
      issueDate: value,
      expireDate: expireDateStr
    }));
  }
  
  // Clear error when user starts typing
  if (membershipErrors[name]) {
    setMembershipErrors(prev => ({
      ...prev,
      [name]: ''
    }));
  }
};

// Validate membership form
const validateMembershipForm = () => {
  const errors = {};
  
  if (!membershipData.customerName.trim()) {
    errors.customerName = 'Customer name is required';
  }
  
  if (!membershipData.telephone.trim()) {
    errors.telephone = 'Telephone number is required';
  } else if (!/^[0-9+\-\s]{10,15}$/.test(membershipData.telephone)) {
    errors.telephone = 'Valid phone number is required';
  }
  
  if (!membershipData.issueDate) {
    errors.issueDate = 'Issue date is required';
  }
  
  if (!membershipData.expireDate) {
    errors.expireDate = 'Expire date is required';
  } else {
    const expireDateObj = new Date(membershipData.expireDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    if (expireDateObj < today) {
      errors.expireDate = 'Expire date cannot be in the past';
    }
  }
  
  return errors;
};

// Reset membership form
const handleResetMembershipForm = () => {
  setMembershipData({
    customerName: '',
    telephone: '',
    issueDate: '',
    expireDate: '',
    discount: 15,
    status: 'active',
    cardNumber: ''
  });
  setMembershipErrors({});
};

// Save membership card to Firestore
const handleSaveMembershipCard = async () => {
  // Validate form
  const errors = validateMembershipForm();
  if (Object.keys(errors).length > 0) {
    setMembershipErrors(errors);
    return;
  }
  
  setIsSavingCard(true);
  
  try {
    // Check if customer already has an active card
    const cardsRef = collection(db, 'customer-cards');
    const q = query(
      cardsRef,
      where('telephone', '==', membershipData.telephone),
      where('status', '==', 'active')
    );
    const existingCards = await getDocs(q);
    
    if (!existingCards.empty) {
      const confirmReplace = window.confirm(
        'This customer already has an active membership card. Do you want to deactivate the old card and create a new one?'
      );
      
      if (confirmReplace) {
        // Deactivate old cards
        const updatePromises = [];
        existingCards.forEach(doc => {
          updatePromises.push(updateDoc(doc.ref, { status: 'inactive' }));
        });
        await Promise.all(updatePromises);
      } else {
        setIsSavingCard(false);
        return;
      }
    }
    
    // Generate unique card number
    const cardNumber = generateCardNumber();
    
    // Prepare card data
    const cardData = {
      cardNumber: cardNumber,
      customerName: membershipData.customerName.trim(),
      telephone: membershipData.telephone.trim(),
      issueDate: membershipData.issueDate,
      expireDate: membershipData.expireDate,
      discount: 15, // 15% discount
      status: 'active',
      createdAt: new Date(),
      updatedAt: new Date(),
      isActive: true
    };
    
    // Save to Firestore
    await addDoc(collection(db, 'customer-cards'), cardData);
    
    // Show success message
    setCardSuccess(true);
    setTimeout(() => setCardSuccess(false), 3000);
    
    // Reset form
    handleResetMembershipForm();
    
    // Show alert with card number
    alert(`✅ Membership card created successfully!\n\nCard Number: ${cardNumber}\nCustomer: ${cardData.customerName}\nValid until: ${cardData.expireDate}\nDiscount: 15%`);
    
  } catch (error) {
    console.error('Error saving membership card:', error);
    alert('❌ Error saving membership card: ' + error.message);
  } finally {
    setIsSavingCard(false);
  }
};

// CSS Styles
const membershipCardStyles = `
  .membership-card-container {
    max-width: 600px;
    margin: 0 auto;
    padding: 20px;
    background: #f5f5f5;
    border-radius: 10px;
  }
  
  .membership-card-container h1 {
    text-align: center;
    color: #2c3e50;
    margin-bottom: 30px;
  }
  
  .info-text {
    background: #e8f4f8;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 20px;
    font-size: 14px;
    color: #2980b9;
  }
  
  .membership-form {
    background: white;
    padding: 20px;
    border-radius: 8px;
  }
  
  .membership-form-group {
    margin-bottom: 20px;
  }
  
  .membership-form-group label {
    display: block;
    margin-bottom: 8px;
    font-weight: bold;
    color: #333;
  }
  
  .membership-form-group input {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 14px;
  }
  
  .membership-form-group input:focus {
    outline: none;
    border-color: #27ae60;
  }
  
  .membership-form-group input.error-input {
    border-color: #e74c3c;
  }
  
  .membership-error-message {
    color: #e74c3c;
    font-size: 12px;
    margin-top: 5px;
    display: block;
  }
  
  .membership-card-actions {
    display: flex;
    gap: 10px;
    margin-top: 20px;
  }
  
  .btn-save-card {
    background: #27ae60;
    color: white;
    padding: 12px 24px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    flex: 1;
  }
  
  .btn-save-card:hover:not(:disabled) {
    background: #229954;
  }
  
  .btn-save-card:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  
  .btn-reset-card {
    background: #95a5a6;
    color: white;
    padding: 12px 24px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    flex: 1;
  }
  
  .btn-reset-card:hover {
    background: #7f8c8d;
  }
  
  .card-success-toast {
    position: fixed;
    top: 20px;
    right: 20px;
    background: #27ae60;
    color: white;
    padding: 15px 20px;
    border-radius: 5px;
    z-index: 1000;
    animation: slideIn 0.3s ease;
  }
  
  @keyframes slideIn {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }
`;




////////////////////////// view customer card ////////////////////////////////////////////////////////
// Add these state declarations with your other states
const [allMembershipCards, setAllMembershipCards] = useState([]);
const [filteredCards, setFilteredCards] = useState([]);
const [isLoadingCards, setIsLoadingCards] = useState(false);
const [searchFilters, setSearchFilters] = useState({
  customerName: '',
  telephone: '',
  issueYear: ''
});
const [selectedCard, setSelectedCard] = useState(null);
const [showCardDetails, setShowCardDetails] = useState(false);

// Fetch all membership cards from Firestore
const fetchMembershipCards = async () => {
  setIsLoadingCards(true);
  try {
    const cardsRef = collection(db, 'customer-cards');
    const q = query(cardsRef, orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);
    
    const cards = [];
    querySnapshot.forEach(doc => {
      cards.push({
        id: doc.id,
        ...doc.data()
      });
    });
    
    setAllMembershipCards(cards);
    setFilteredCards(cards);
  } catch (error) {
    console.error('Error fetching membership cards:', error);
    alert('Error loading membership cards: ' + error.message);
  } finally {
    setIsLoadingCards(false);
  }
};

// Load cards when component mounts
useEffect(() => {
  if (selectedOption === "viewMembershipCard") {
    fetchMembershipCards();
  }
}, [selectedOption]);

// Handle search filter changes
const handleSearchFilterChange = (e) => {
  const { name, value } = e.target;
  setSearchFilters(prev => ({
    ...prev,
    [name]: value
  }));
};

// Apply filters to cards
const applyFilters = () => {
  let filtered = [...allMembershipCards];
  
  // Filter by customer name
  if (searchFilters.customerName) {
    filtered = filtered.filter(card => 
      card.customerName.toLowerCase().includes(searchFilters.customerName.toLowerCase())
    );
  }
  
  // Filter by telephone
  if (searchFilters.telephone) {
    filtered = filtered.filter(card => 
      card.telephone.includes(searchFilters.telephone)
    );
  }
  
  // Filter by issue year
  if (searchFilters.issueYear) {
    filtered = filtered.filter(card => {
      const issueYear = card.issueDate ? new Date(card.issueDate).getFullYear().toString() : '';
      return issueYear === searchFilters.issueYear;
    });
  }
  
  setFilteredCards(filtered);
};

// Reset filters
const resetFilters = () => {
  setSearchFilters({
    customerName: '',
    telephone: '',
    issueYear: ''
  });
  setFilteredCards(allMembershipCards);
};

// Get unique years from cards for year filter dropdown
const getAvailableYears = () => {
  const years = new Set();
  allMembershipCards.forEach(card => {
    if (card.issueDate) {
      const year = new Date(card.issueDate).getFullYear();
      years.add(year);
    }
  });
  return Array.from(years).sort().reverse();
};

// Format date for display
const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return date.toLocaleDateString();
};

// Check if card is expired
const isCardExpired = (expireDate) => {
  if (!expireDate) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const expire = new Date(expireDate);
  return expire < today;
};

// Get days until expiry
const getDaysUntilExpiry = (expireDate) => {
  if (!expireDate) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const expire = new Date(expireDate);
  const diffTime = expire - today;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};

// View card details
const viewCardDetails = (card) => {
  setSelectedCard(card);
  setShowCardDetails(true);
};

// Close card details modal
const closeCardDetails = () => {
  setShowCardDetails(false);
  setSelectedCard(null);
};

// Deactivate card
const deactivateCard = async (cardId, cardNumber) => {
  const confirm = window.confirm(`Are you sure you want to deactivate card ${cardNumber}?`);
  if (!confirm) return;
  
  try {
    const cardRef = doc(db, 'customer-cards', cardId);
    await updateDoc(cardRef, {
      status: 'inactive',
      isActive: false,
      updatedAt: new Date()
    });
    
    alert('Card deactivated successfully!');
    fetchMembershipCards(); // Refresh the list
  } catch (error) {
    console.error('Error deactivating card:', error);
    alert('Error deactivating card: ' + error.message);
  }
};

// Reactivate card
// const reactivateCard = async (cardId, cardNumber) => {
//   const confirm = window.confirm(`Are you sure you want to reactivate card ${cardNumber}?`);
//   if (!confirm) return;
  
//   try {
//     const cardRef = doc(db, 'customer-cards', cardId);
//     await updateDoc(cardRef, {
//       status: 'active',
//       isActive: true,
//       updatedAt: new Date()
//     });
    
//     alert('Card reactivated successfully!');
//     fetchMembershipCards(); // Refresh the list
//   } catch (error) {
//     console.error('Error reactivating card:', error);
//     alert('Error reactivating card: ' + error.message);
//   }
// };
const reactivateCard = async (cardId, cardNumber) => {
  const confirm = window.confirm(`Reactivate card ${cardNumber} and extend expiry?`);
  if (!confirm) return;

  try {
    const cardRef = doc(db, 'customer-cards', cardId);

    // 🔑 Set NEW expiry date (1 year from today)
    const newExpireDate = new Date();
    newExpireDate.setFullYear(newExpireDate.getFullYear() + 1);

    await updateDoc(cardRef, {
      status: 'active',
      isActive: true,
      expireDate: newExpireDate.toISOString(), // ✅ update expiry
      updatedAt: new Date()
    });

    alert('Card reactivated and renewed successfully!');
    fetchMembershipCards();
  } catch (error) {
    console.error('Error reactivating card:', error);
    alert('Error reactivating card: ' + error.message);
  }
};







// Delete card permanently
const deleteCard = async (cardId, cardNumber) => {
  const confirm = window.confirm(`⚠️ WARNING: This will permanently delete card ${cardNumber}. This action cannot be undone. Are you sure?`);
  if (!confirm) return;
  
  try {
    const cardRef = doc(db, 'customer-cards', cardId);
    await deleteDoc(cardRef);
    
    alert('Card deleted permanently!');
    fetchMembershipCards(); // Refresh the list
  } catch (error) {
    console.error('Error deleting card:', error);
    alert('Error deleting card: ' + error.message);
  }
}; 

const viewMembershipCardStyles = `
  .view-membership-card-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
  }
  
  .view-membership-card-container h1 {
    color: #2c3e50;
    margin-bottom: 10px;
  }
  
  .filters-section {
    background: white;
    padding: 20px;
    border-radius: 10px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }
  
  .filters-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
    color: #333;
  }
  
  .filters-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 15px;
    margin-bottom: 15px;
  }
  
  .filter-group {
    display: flex;
    flex-direction: column;
  }
  
  .filter-group label {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 5px;
    color: #555;
  }
  
  .filter-group input,
  .filter-group select {
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 14px;
  }
  
  .filter-group input:focus,
  .filter-group select:focus {
    outline: none;
    border-color: #27ae60;
  }
  
  .filter-buttons {
    display: flex;
    gap: 10px;
    margin-top: 10px;
  }
  
  .btn-apply-filters {
    background: #27ae60;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .btn-reset-filters {
    background: #95a5a6;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .stats-badge {
    background: #ecf0f1;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 20px;
    font-size: 14px;
  }
  
  .cards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    gap: 20px;
  }
  
  .card-item {
    background: white;
    border-radius: 10px;
    padding: 15px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    transition: transform 0.2s;
    cursor: pointer;
  }
  
  .card-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  }
  
  .card-item.expired {
    background: #fef5f5;
    border-left: 4px solid #e74c3c;
  }
  
  .card-item.active {
    border-left: 4px solid #27ae60;
  }
  
  .card-item.inactive {
    background: #f5f5f5;
    opacity: 0.7;
  }
  
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }
  
  .card-number {
    font-weight: bold;
    color: #2c3e50;
    font-size: 14px;
  }
  
  .card-status {
    padding: 3px 8px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: bold;
  }
  
  .status-active {
    background: #27ae60;
    color: white;
  }
  
  .status-inactive {
    background: #95a5a6;
    color: white;
  }
  
  .status-expired {
    background: #e74c3c;
    color: white;
  }
  
  .card-name {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 8px;
    color: #333;
  }
  
  .card-details {
    font-size: 13px;
    color: #666;
    margin-top: 8px;
  }
  
  .card-details div {
    margin-bottom: 5px;
  }
  
  .expiry-warning {
    color: #e74c3c;
    font-weight: bold;
    margin-top: 8px;
    font-size: 12px;
  }
  
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .modal-content {
    background: white;
    padding: 25px;
    border-radius: 10px;
    max-width: 500px;
    width: 90%;
    max-height: 80vh;
    overflow-y: auto;
  }
  
  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
  
  .modal-close {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #999;
  }
  
  .modal-actions {
    display: flex;
    gap: 10px;
    margin-top: 20px;
    justify-content: flex-end;
  }
  
  .loading-spinner {
    text-align: center;
    padding: 40px;
    font-size: 18px;
    color: #666;
  }
  
  .no-results {
    text-align: center;
    padding: 40px;
    color: #999;
  }
`;

//////////////////////////////////////////////////// sales report //////////////////////////////////////////////////////////

const [report, setReport] = useState([]);

useEffect(() => {
  fetchData();
}, []);

const fetchData = async () => {
  try {
    const invoiceSnap = await getDocs(collection(db, "invoices"));
    const balanceSnap = await getDocs(collection(db, "balance_invoices"));

    const invoices = invoiceSnap.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    const balances = balanceSnap.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    generateReport(invoices, balances);
    setLoading(false);
  } catch (err) {
    console.error("Error fetching data:", err);
    setLoading(false);
  }
};

const generateReport = (invoices, balances) => {
  const rows = invoices.map(inv => {

    // ✅ HANDLE BOTH CASES (root OR financial)
    const invoiceNumber =
      inv.invoiceNumber || inv.financial?.invoiceNumber || "";

    const customer = inv.customer?.fullName || "-";

    const totalAmount = inv.financial?.totalAmount || 0;
    const advancePaid = inv.financial?.advancePayment || 0;

    // ✅ SAFE MATCHING
    const related = balances.filter(
      b =>
        (b.originalInvoiceNumber || "").trim() ===
        invoiceNumber.trim()
    );

    const laterPayments = related.reduce(
      (sum, b) => sum + (b.paidAmount || 0),
      0
    );

    const totalPaid = advancePaid + laterPayments;
    const remaining = totalAmount - totalPaid;

return {
  invoiceNumber,
  customer,
  totalAmount,
  advancePaid,
  laterPayments,
  totalPaid,
  remaining,
  status: remaining <= 0 ? "Settled" : "Pending",

  // ✅ ADD THIS (VERY IMPORTANT)
  date: inv.createdAt || inv.paymentDate || ""
};
  });

  // ✅ DESCENDING ORDER (IMPORTANT)
  rows.sort((a, b) => {
    const numA = parseInt(a.invoiceNumber.match(/\d+/)?.[0] || 0);
    const numB = parseInt(b.invoiceNumber.match(/\d+/)?.[0] || 0);
    return numB - numA;
  });

  setReport(rows);
};

const downloadExcel = () => {
  const worksheet = XLSX.utils.json_to_sheet(report);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sales Report");
  XLSX.writeFile(workbook, "Sales_Report.xlsx");
};

const downloadPDF = () => {
  const doc = new jsPDF();

  doc.text("Sales Report", 14, 15);

  const columns = [
    "Invoice",
    "Customer",
    "Total",
    "Advance",
    "Later Payments",
    "Total Paid",
    "Remaining",
    "Status"
  ];

  const rows = report.map(r => [
    r.invoiceNumber,
    r.customer,
    r.totalAmount,
    r.advancePaid,
    r.laterPayments,
    r.totalPaid,
    r.remaining,
    r.status
  ]);

  autoTable(doc, {
    head: [columns],
    body: rows,
    startY: 20
  });

  doc.save("Sales_Report.pdf");
};

const filteredReport = report.filter(r => {
  if (!r.date) return false;

  const d = new Date(r.date);
  if (isNaN(d)) return false;

  const month = d.getMonth() + 1;
  const year = d.getFullYear();

  const matchMonth =
    selectedMonth === "all" || month === parseInt(selectedMonth);

  const matchYear =
    selectedYear === "all" || year === parseInt(selectedYear);

  return matchMonth && matchYear;
});










  return (
    <>
      {/* 🔵 TOP NAVIGATION BAR */}
<nav className="top-nav">
  <div className="logo">Powered By Optica International</div>

  <ul className="nav-links">

    {/* Normal Tabs */}
    <li
      className={selectedOption === "dashboard" ? "active" : ""}
      onClick={() => {
        setOpenMenu(null);
        handleSelect("dashboard");
      }}
    >
      Dashboard
    </li>

    <li
      className={selectedOption === "viewPatient" ? "active" : ""}
      onClick={() => {
        setOpenMenu(null);
        handleSelect("viewPatient");
      }}
    >
      View Patients
    </li>

    {/* Invoice Dropdown */}
    <li
      className="dropdown"
      onClick={(e) => {
        e.stopPropagation();
        setOpenMenu(openMenu === "invoice" ? null : "invoice");
      }}
    >
      Invoice ▾

      {openMenu === "invoice" && (
        <div className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
          <p onClick={() => handleSelectInvoice("createInvoice")}>Create Invoice</p>
          <p onClick={() => handleSelectInvoice("viewInvoice")}>View Invoice</p>
          <p onClick={() => handleSelectInvoice("createBalanceInvoice")}>Create Balance Invoice</p>
          <p onClick={() => handleSelectInvoice("viewBalanceInvoice")}>View Balance Invoice</p>
          <p onClick={() => handleSelectInvoice("createConsultation")}>Create Consultation</p>
          <p onClick={() => handleSelectInvoice("viewConsultation")}>View Consultation</p>
          <p onClick={() => handleSelectInvoice("addItems")}>Add Items</p>
        </div>
      )}
    </li>

    {/* Supplier Dropdown */}
    <li
      className="dropdown"
      onClick={(e) => {
        e.stopPropagation();
        setOpenMenu(openMenu === "supplier" ? null : "supplier");
      }}
    >
      Supplier ▾

      {openMenu === "supplier" && (
        <div className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
          <p onClick={() => handleSelectSupplier("addSupplier")}>Add Supplier</p>
          <p onClick={() => handleSelectSupplier("viewSupplier")}>View Supplier</p>
        </div>
      )}
    </li>

    {/* Stock Dropdown */}
    <li
      className="dropdown"
      onClick={(e) => {
        e.stopPropagation();
        setOpenMenu(openMenu === "stock" ? null : "stock");
      }}
    >
      Stock ▾

      {openMenu === "stock" && (
        <div className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
          <p onClick={() => handleSelectStock("purchasingOrder")}>Purchasing Order</p>
          <p onClick={() => handleSelectStock("quickAdd")}>Quick Add</p>
          <p onClick={() => handleSelectStock("addStock")}>Add Stock</p>
        </div>
      )}
    </li>

    {/* Reports Dropdown */}
    <li
      className="dropdown"
      onClick={(e) => {
        e.stopPropagation();
        setOpenMenu(openMenu === "report" ? null : "report");
      }}
    >
      Reports ▾

      {openMenu === "report" && (
        <div className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
          <p onClick={() => handleSelectReport("StockHistory")}>Stock Report</p>
          <p onClick={() => handleSelectReport("viewStockOut")}>View Stock-Out Report</p>
          <p onClick={() => handleSelectReport("salesReport")}>Sales Report</p>
        </div>
      )}
    </li>



    <li
      className={selectedOption === "membershipCard" ? "active" : ""}
      onClick={() => {
        setOpenMenu(null);
        handleSelect("membershipCard");
      }}
    >
      Customer Card
    </li>



    <li
      className={selectedOption === "viewMembershipCard" ? "active" : ""}
      onClick={() => {
        setOpenMenu(null);
        handleSelect("viewMembershipCard");
      }}
    >
      View Customer Card
    </li>



    {/* Logout */}
    <li
      onClick={(e) => {
        e.stopPropagation();
        setOpenMenu(null);
        handleLogout();
      }}
    >
      Logout
    </li>
  </ul>
</nav>

      {/* 🔵 PAGE BODY */}
      <div className="page-body">


{/********************************************************  view Membership Card  ******************************************************************/}
{selectedOption === "viewMembershipCard" && (
  <>
    <style>{viewMembershipCardStyles}</style>
    <div className="view-membership-card-container">
      <h1>📇 Customer Membership Cards</h1>
      
      {/* Filters Section */}
      <div className="filters-section">
        <div className="filters-title">🔍 Search Filters</div>
        <div className="filters-grid">
          <div className="filter-group">
            <label>Customer Name</label>
            <input
              type="text"
              name="customerName"
              value={searchFilters.customerName}
              onChange={handleSearchFilterChange}
              placeholder="Search by name..."
            />
          </div>
          
          <div className="filter-group">
            <label>Telephone Number</label>
            <input
              type="text"
              name="telephone"
              value={searchFilters.telephone}
              onChange={handleSearchFilterChange}
              placeholder="Search by phone..."
            />
          </div>
          
          <div className="filter-group">
            <label>Issue Year</label>
            <select
              name="issueYear"
              value={searchFilters.issueYear}
              onChange={handleSearchFilterChange}
            >
              <option value="">All Years</option>
              {getAvailableYears().map(year => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
          </div>
        </div>
        
        <div className="filter-buttons">
          <button className="btn-apply-filters" onClick={applyFilters}>
            Apply Filters
          </button>
          <button className="btn-reset-filters" onClick={resetFilters}>
            Reset Filters
          </button>
        </div>
      </div>
      
      {/* Stats */}
      <div className="stats-badge">
        📊 Total Cards: {filteredCards.length} | 
        Active: {filteredCards.filter(c => c.status === 'active' && !isCardExpired(c.expireDate)).length} |
        Expired: {filteredCards.filter(c => isCardExpired(c.expireDate)).length} |
        Inactive: {filteredCards.filter(c => c.status === 'inactive').length}
      </div>
      
      {/* Cards Grid */}
      {isLoadingCards ? (
        <div className="loading-spinner">Loading cards...</div>
      ) : filteredCards.length === 0 ? (
        <div className="no-results">No membership cards found</div>
      ) : (
        <div className="cards-grid">
          {filteredCards.map(card => {
            const expired = isCardExpired(card.expireDate);
            const daysUntilExpiry = getDaysUntilExpiry(card.expireDate);
            
            return (
              <div 
                key={card.id} 
                className={`card-item ${expired ? 'expired' : card.status === 'active' ? 'active' : 'inactive'}`}
                onClick={() => viewCardDetails(card)}
              >
                <div className="card-header">
                  <span className="card-number">{card.cardNumber}</span>
                  <span className={`card-status ${
                    expired ? 'status-expired' : 
                    card.status === 'active' ? 'status-active' : 'status-inactive'
                  }`}>
                    {expired ? 'EXPIRED' : card.status.toUpperCase()}
                  </span>
                </div>
                
                <div className="card-name">{card.customerName}</div>
                
                <div className="card-details">
                  <div>📞 {card.telephone}</div>
                  <div>📅 Issue: {formatDate(card.issueDate)}</div>
                  <div>⏰ Expiry: {formatDate(card.expireDate)}</div>
                  <div>💰 Discount: {card.discount}%</div>
                </div>
                
                {!expired && card.status === 'active' && daysUntilExpiry <= 30 && (
                  <div className="expiry-warning">
                    ⚠️ Expires in {daysUntilExpiry} days!
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
      
      {/* Card Details Modal */}
      {showCardDetails && selectedCard && (
        <div className="modal-overlay" onClick={closeCardDetails}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Card Details</h2>
              <button className="modal-close" onClick={closeCardDetails}>×</button>
            </div>
            
            <div className="card-details-modal">
              <p><strong>Card Number:</strong> {selectedCard.cardNumber}</p>
              <p><strong>Customer Name:</strong> {selectedCard.customerName}</p>
              <p><strong>Telephone:</strong> {selectedCard.telephone}</p>
              <p><strong>Issue Date:</strong> {formatDate(selectedCard.issueDate)}</p>
              <p><strong>Expire Date:</strong> {formatDate(selectedCard.expireDate)}</p>
              <p><strong>Discount:</strong> {selectedCard.discount}%</p>
              <p><strong>Status:</strong> {selectedCard.status}</p>
              <p><strong>Created:</strong> {formatDate(selectedCard.createdAt?.toDate?.() || selectedCard.createdAt)}</p>
              <p><strong>Last Updated:</strong> {formatDate(selectedCard.updatedAt?.toDate?.() || selectedCard.updatedAt)}</p>
            </div>
            
            <div className="modal-actions">
              {selectedCard.status === 'active' && !isCardExpired(selectedCard.expireDate) && (
                <button 
                  className="btn-reset-filters" 
                  onClick={() => deactivateCard(selectedCard.id, selectedCard.cardNumber)}
                  style={{ background: '#e74c3c' }}
                >
                  Deactivate Card
                </button>
              )}
              
             {(selectedCard.status === 'inactive' || isCardExpired(selectedCard.expireDate)) && (
                <button 
                  className="btn-apply-filters" 
                  onClick={() => reactivateCard(selectedCard.id, selectedCard.cardNumber)}
                >
                  Reactivate Card
                </button>
              )}
              
              <button 
                className="btn-reset-filters" 
                onClick={() => deleteCard(selectedCard.id, selectedCard.cardNumber)}
                style={{ background: '#c0392b' }}
              >
                Delete Permanently
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  </>
)}






{/**************************************************** Membership Card **************************************************************/}

{selectedOption === "membershipCard" && (
  <>
    <style>{membershipCardStyles}</style>
    <div className="membership-card-container">
      <h1>Customer Membership Card</h1>
      <p className="info-text">
        💳 Create a 1-year membership card for customers. Card holders get 15% discount on all purchases.
      </p>
      
      {cardSuccess && (
        <div className="card-success-toast">
          ✅ Membership card created successfully!
        </div>
      )}
      
      <div className="membership-form">
        <div className="membership-form-group">
          <label>Customer Name *</label>
          <input
            type="text"
            name="customerName"
            value={membershipData.customerName}
            onChange={handleMembershipInputChange}
            placeholder="Enter customer full name"
            className={membershipErrors.customerName ? 'error-input' : ''}
          />
          {membershipErrors.customerName && (
            <span className="membership-error-message">{membershipErrors.customerName}</span>
          )}
        </div>
        
        <div className="membership-form-group">
          <label>Telephone Number *</label>
          <input
            type="tel"
            name="telephone"
            value={membershipData.telephone}
            onChange={handleMembershipInputChange}
            placeholder="Enter phone number"
            className={membershipErrors.telephone ? 'error-input' : ''}
          />
          {membershipErrors.telephone && (
            <span className="membership-error-message">{membershipErrors.telephone}</span>
          )}
        </div>
        
        <div className="membership-form-group">
          <label>Issue Date *</label>
          <input
            type="date"
            name="issueDate"
            value={membershipData.issueDate}
            onChange={handleMembershipInputChange}
            className={membershipErrors.issueDate ? 'error-input' : ''}
          />
          {membershipErrors.issueDate && (
            <span className="membership-error-message">{membershipErrors.issueDate}</span>
          )}
        </div>
        
        <div className="membership-form-group">
          <label>Expire Date *</label>
          <input
            type="date"
            name="expireDate"
            value={membershipData.expireDate}
            readOnly
            style={{ backgroundColor: '#f0f0f0' }}
            className={membershipErrors.expireDate ? 'error-input' : ''}
          />
          <small style={{ color: '#666', fontSize: '12px', display: 'block', marginTop: '5px' }}>
            📅 Automatically set to 1 year from issue date
          </small>
          {membershipErrors.expireDate && (
            <span className="membership-error-message">{membershipErrors.expireDate}</span>
          )}
        </div>
        
        <div className="membership-form-group">
          <label>Discount Rate</label>
          <input
            type="text"
            value="15%"
            readOnly
            style={{ backgroundColor: '#f0f0f0', fontWeight: 'bold', color: '#27ae60' }}
          />
          <small style={{ color: '#666', fontSize: '12px', display: 'block', marginTop: '5px' }}>
            🎁 Card holders get 15% discount on all optical products
          </small>
        </div>
        
        <div className="membership-card-actions">
          <button 
            className="btn-save-card" 
            onClick={handleSaveMembershipCard}
            disabled={isSavingCard}
          >
            {isSavingCard ? '⏳ Creating Card...' : '💳 Create Membership Card'}
          </button>
          <button 
            className="btn-reset-card" 
            onClick={handleResetMembershipForm}
          >
            🗑️ Clear Form
          </button>
        </div>
      </div>
    </div>
  </>
)}




{/************************************************ view all invoices*************************************************************/}

{selectedOption === "viewInvoice" && (
  <div className="view-invoice-container">
    <div className="view-invoice-header">
      <div>
        <h2>All Invoices</h2>
        <p className="subtitle">View, download, and manage all customer invoices</p>
      </div>
      <button className="btn-export-report" onClick={generateInvoiceSummaryReport}>
        📊 Export Summary Report
      </button>
    </div>

    {/* Filters Section */}
    <div className="filters-section">
      <div className="filter-row">
        <div className="filter-group">
          <label>Search:</label>
          <input
            type="text"
            placeholder="Search by invoice #, customer, phone..."
            value={invoiceSearchTerm}
            onChange={(e) => setInvoiceSearchTerm(e.target.value)}
            className="filter-input"
          />
        </div>

        <div className="filter-group">
          <label>Status:</label>
          <select
            value={invoiceFilterStatus}
            onChange={(e) => setInvoiceFilterStatus(e.target.value)}
            className="filter-select"
          >
            <option value="all">All</option>
            <option value="paid">Paid</option>
            <option value="pending">Pending</option>
          </select>
        </div>

        <div className="filter-group">
          <label>Payment Method:</label>
          <select
            value={invoiceFilterPaymentMethod}
            onChange={(e) => setInvoiceFilterPaymentMethod(e.target.value)}
            className="filter-select"
          >
            <option value="all">All</option>
            <option value="Cash">Cash</option>
            <option value="Card">Card</option>
            <option value="Bank Transfer">Bank Transfer</option>
            <option value="Deposit">Deposit</option>
          </select>
        </div>

        <div className="filter-group">
          <label>Date Range:</label>
          <input
            type="date"
            value={invoiceDateRange.start}
            onChange={(e) => setInvoiceDateRange(prev => ({ ...prev, start: e.target.value }))}
            className="filter-date"
          />
          <span>to</span>
          <input
            type="date"
            value={invoiceDateRange.end}
            onChange={(e) => setInvoiceDateRange(prev => ({ ...prev, end: e.target.value }))}
            className="filter-date"
          />
        </div>

        <button className="btn-reset" onClick={resetInvoiceFilters}>
          🔄 Reset
        </button>
        <button className="btn-refresh" onClick={fetchAllInvoices}>
          🔄 Refresh
        </button>
      </div>
    </div>

    {/* Summary Cards */}
    <div className="summary-cards">
      <div className="summary-card">
        <div className="summary-title">Total Invoices</div>
        <div className="summary-value">{filteredInvoices.length}</div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Total Amount</div>
        <div className="summary-value">
          Rs. {filteredInvoices.reduce((sum, inv) => sum + (inv.financial?.totalAmount || 0), 0).toFixed(2)}
        </div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Total Paid</div>
        <div className="summary-value">
          Rs. {filteredInvoices.reduce((sum, inv) => sum + (inv.financial?.advancePayment || 0) + (inv.totalBalancePaid || 0), 0).toFixed(2)}
        </div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Total Due</div>
        <div className="summary-value">
          Rs. {filteredInvoices.reduce((sum, inv) => sum + (inv.financial?.balanceDue || 0), 0).toFixed(2)}
        </div>
      </div>
    </div>

    {/* Invoices Table */}
    {isLoadingInvoices ? (
      <div className="loading-spinner">Loading invoices...</div>
    ) : (
      <div className="invoice-table-container">
        <table className="invoice-table">
          <thead>
            <tr>
              <th>Invoice #</th>
              <th>Customer Name</th>
              <th>Phone</th>
              <th>Products</th>
              <th>Total Amount</th>
              <th>Paid</th>
              <th>Balance Due</th>
              <th>Payment Method</th>
              <th>Date</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredInvoices.length === 0 ? (
              <tr>
                <td colSpan="11" style={{ textAlign: 'center', padding: '40px' }}>
                  No invoices found
                </td>
              </tr>
            ) : (
              filteredInvoices.map((invoice) => (
                <tr key={invoice.id}>
                  <td className="invoice-link" onClick={() => viewInvoiceDetails(invoice)}>
                    {invoice.invoiceNumber}
                  </td>
                  <td>{invoice.customer?.fullName || 'N/A'}</td>
                  <td>{invoice.customer?.tpNo || 'N/A'}</td>
                  <td>
                    <div className="products-cell">
                      <small>Frame: {invoice.products?.frameModel || 'N/A'}</small>
                      <small>Lens: {invoice.products?.lensModel || 'N/A'}</small>
                    </div>
                  </td>
                  <td className="amount">Rs. {(invoice.financial?.totalAmount || 0).toFixed(2)}</td>
                  <td className="paid-amount">
                    Rs. {((invoice.financial?.advancePayment || 0) + (invoice.totalBalancePaid || 0)).toFixed(2)}
                    {invoice.balancePayments?.length > 0 && (
                      <small className="balance-payments-count">(+{invoice.balancePayments.length} balance payments)</small>
                    )}
                  </td>
                  <td className={`balance-due ${invoice.financial?.balanceDue <= 0 ? 'settled' : ''}`}>
                    Rs. {(invoice.financial?.balanceDue || 0).toFixed(2)}
                  </td>
                  <td>
                    <span className="payment-method-badge">{invoice.financial?.paymentMethod || 'N/A'}</span>
                  </td>
                  <td>
                    <div className="date-cell">
                      <div>{invoice.formattedDate}</div>
                      <small>{invoice.formattedTime}</small>
                    </div>
                  </td>
                  <td>
                    <span 
                      className="status-badge" 
                      style={{ backgroundColor: invoice.statusColor }}
                    >
                      {invoice.financial?.balanceDue <= 0 ? 'Paid' : 'Pending'}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button
                        className="btn-view"
                        onClick={() => viewInvoiceDetails(invoice)}
                        title="View Details"
                      >
                        👁️
                      </button>
                      <button
                        className="btn-download"
                        onClick={() => downloadOriginalInvoicePDF(invoice)}
                        title="Download PDF"
                      >
                        📄
                      </button>
                      <button
                        className="btn-delete"
                        onClick={() => deleteInvoice(invoice.id, invoice.invoiceNumber)}
                        title="Delete"
                      >
                        🗑️
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    )}

    {/* Invoice Details Modal */}
    {showInvoiceDetails && selectedInvoiceDetails && (
      <div className="modal-overlay" onClick={() => setShowInvoiceDetails(false)}>
        <div className="modal-content large" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h3>Invoice Details</h3>
            <button className="modal-close" onClick={() => setShowInvoiceDetails(false)}>×</button>
          </div>
          
          <div className="modal-body">
            <div className="details-grid">
              <div className="details-section">
                <h4>Invoice Information</h4>
                <div className="detail-item">
                  <label>Invoice #:</label>
                  <span className="value">{selectedInvoiceDetails.invoiceNumber}</span>
                </div>
                <div className="detail-item">
                  <label>Date Created:</label>
                  <span>{selectedInvoiceDetails.formattedDate} at {selectedInvoiceDetails.formattedTime}</span>
                </div>
                <div className="detail-item">
                  <label>Delivery Date:</label>
                  <span>{selectedInvoiceDetails.delivery?.date || 'N/A'}</span>
                </div>
                <div className="detail-item">
                  <label>Status:</label>
                  <span className="status-badge" style={{ backgroundColor: selectedInvoiceDetails.statusColor }}>
                    {selectedInvoiceDetails.financial?.balanceDue <= 0 ? 'Paid' : 'Pending'}
                  </span>
                </div>
              </div>

              <div className="details-section">
                <h4>Customer Information</h4>
                <div className="detail-item">
                  <label>Name:</label>
                  <span>{selectedInvoiceDetails.customer?.fullName || 'N/A'}</span>
                </div>
                <div className="detail-item">
                  <label>Phone:</label>
                  <span>{selectedInvoiceDetails.customer?.tpNo || 'N/A'}</span>
                </div>
                <div className="detail-item">
                  <label>Email:</label>
                  <span>{selectedInvoiceDetails.customer?.email || 'N/A'}</span>
                </div>
                <div className="detail-item">
                  <label>Address:</label>
                  <span>{selectedInvoiceDetails.customer?.address || 'N/A'}</span>
                </div>
                <div className="detail-item">
                  <label>Age:</label>
                  <span>{selectedInvoiceDetails.customer?.age || 'N/A'}</span>
                </div>
              </div>

              <div className="details-section">
                <h4>Products</h4>
                <div className="detail-item">
                  <label>Frame Model:</label>
                  <span>{selectedInvoiceDetails.products?.frameModel || 'N/A'}</span>
                </div>
                <div className="detail-item">
                  <label>Frame Price:</label>
                  <span>Rs. {(selectedInvoiceDetails.products?.framePrice || 0).toFixed(2)}</span>
                </div>
                <div className="detail-item">
                  <label>Lens Model:</label>
                  <span>{selectedInvoiceDetails.products?.lensModel || 'N/A'}</span>
                </div>
                <div className="detail-item">
                  <label>Lens Price:</label>
                  <span>Rs. {(selectedInvoiceDetails.products?.lensPrice || 0).toFixed(2)}</span>
                </div>
                <div className="detail-item">
                  <label>Brand:</label>
                  <span>{selectedInvoiceDetails.products?.brand || 'N/A'}</span>
                </div>
                <div className="detail-item">
                  <label>Colour:</label>
                  <span>{selectedInvoiceDetails.products?.colour || 'N/A'}</span>
                </div>
              </div>

              <div className="details-section">
                <h4>Payment Details</h4>
                <div className="detail-item">
                  <label>Subtotal:</label>
                  <span>Rs. {(selectedInvoiceDetails.financial?.subtotal || 0).toFixed(2)}</span>
                </div>
                <div className="detail-item">
                  <label>Discount:</label>
                  <span>Rs. {(selectedInvoiceDetails.financial?.discount || 0).toFixed(2)}</span>
                </div>
                <div className="detail-item highlight">
                  <label>Total Amount:</label>
                  <span className="paid-amount">Rs. {(selectedInvoiceDetails.financial?.totalAmount || 0).toFixed(2)}</span>
                </div>
                <div className="detail-item">
                  <label>Advance Payment:</label>
                  <span>Rs. {(selectedInvoiceDetails.financial?.advancePayment || 0).toFixed(2)}</span>
                </div>
                {selectedInvoiceDetails.balancePayments?.length > 0 && (
                  <>
                    <div className="detail-item">
                      <label>Balance Payments:</label>
                      <span>Rs. {selectedInvoiceDetails.totalBalancePaid.toFixed(2)}</span>
                    </div>
                    <div className="balance-payments-list">
                      <label>Payment History:</label>
                      {selectedInvoiceDetails.balancePayments.map((payment, idx) => (
                        <div key={idx} className="payment-history-item">
                          <small>{new Date(payment.date).toLocaleDateString()}</small>
                          <small>{payment.method}</small>
                          <small>Rs. {payment.amount.toFixed(2)}</small>
                          <small className="payment-invoice">{payment.invoiceNumber}</small>
                        </div>
                      ))}
                    </div>
                  </>
                )}
                <div className="detail-item">
                  <label>Balance Due:</label>
                  <span className={`remaining ${selectedInvoiceDetails.financial?.balanceDue <= 0 ? 'settled' : ''}`}>
                    Rs. {(selectedInvoiceDetails.financial?.balanceDue || 0).toFixed(2)}
                  </span>
                </div>
                <div className="detail-item">
                  <label>Payment Method:</label>
                  <span>{selectedInvoiceDetails.financial?.paymentMethod || 'N/A'}</span>
                </div>
              </div>

              <div className="details-section">
                <h4>Prescription</h4>
                <div className="prescription-details">
                  <div className="eye-details">
                    <strong>Right Eye (OD)</strong>
                    <div>VA: {selectedInvoiceDetails.prescription?.rightEye?.visualAcuity || 'N/A'}</div>
                    <div>SPH: {selectedInvoiceDetails.prescription?.rightEye?.sph || 'N/A'}</div>
                    <div>CYL: {selectedInvoiceDetails.prescription?.rightEye?.cyl || 'N/A'}</div>
                    <div>AXIS: {selectedInvoiceDetails.prescription?.rightEye?.axis || 'N/A'}</div>
                    <div>ADD: {selectedInvoiceDetails.prescription?.rightEye?.add || 'N/A'}</div>
                  </div>
                  <div className="eye-details">
                    <strong>Left Eye (OS)</strong>
                    <div>VA: {selectedInvoiceDetails.prescription?.leftEye?.visualAcuity || 'N/A'}</div>
                    <div>SPH: {selectedInvoiceDetails.prescription?.leftEye?.sph || 'N/A'}</div>
                    <div>CYL: {selectedInvoiceDetails.prescription?.leftEye?.cyl || 'N/A'}</div>
                    <div>AXIS: {selectedInvoiceDetails.prescription?.leftEye?.axis || 'N/A'}</div>
                    <div>ADD: {selectedInvoiceDetails.prescription?.leftEye?.add || 'N/A'}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button 
              className="btn-download" 
              onClick={() => downloadOriginalInvoicePDF(selectedInvoiceDetails)}
            >
              📄 Download PDF
            </button>
            <button 
              className="btn-delete" 
              onClick={() => {
                deleteInvoice(selectedInvoiceDetails.id, selectedInvoiceDetails.invoiceNumber);
                setShowInvoiceDetails(false);
              }}
            >
              🗑️ Delete
            </button>
            <button className="btn-close" onClick={() => setShowInvoiceDetails(false)}>
              Close
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
)}




{/******************************************************* View All Balance Invoices ********************************************************/}

{selectedOption === "viewBalanceInvoice" && (
  <div className="view-balance-container">
    <div className="view-balance-header">
      <div>
        <h2>Balance Invoices</h2>
        <p className="subtitle">View, download, and manage all balance invoices</p>
      </div>
      <button className="btn-export-report" onClick={generateBalanceSummaryReport}>
        📊 Export Summary Report
      </button>
    </div>

    {/* Filters Section */}
    <div className="filters-section">
      <div className="filter-row">
        <div className="filter-group">
          <label>Search:</label>
          <input
            type="text"
            placeholder="Search by invoice #, customer..."
            value={balanceInvoiceSearchTerm}
            onChange={(e) => setBalanceInvoiceSearchTerm(e.target.value)}
            className="filter-input"
          />
        </div>

        <div className="filter-group">
          <label>Status:</label>
          <select
            value={balanceInvoiceFilterStatus}
            onChange={(e) => setBalanceInvoiceFilterStatus(e.target.value)}
            className="filter-select"
          >
            <option value="all">All</option>
            <option value="settled">Settled</option>
            <option value="partial">Partial Payment</option>
          </select>
        </div>

        <button className="btn-reset" onClick={resetBalanceFilters}>
          🔄 Reset
        </button>
        <button className="btn-refresh" onClick={fetchAllBalanceInvoices}>
          🔄 Refresh
        </button>
      </div>
    </div>

    {/* Summary Cards */}
    <div className="summary-cards">
      <div className="summary-card">
        <div className="summary-title">Total Balance Invoices</div>
        <div className="summary-value">{filteredBalanceInvoices.length}</div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Total Amount Paid</div>
        <div className="summary-value">
          Rs. {filteredBalanceInvoices.reduce((sum, inv) => sum + (inv.paidAmount || 0), 0).toFixed(2)}
        </div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Total Remaining</div>
        <div className="summary-value">
          Rs. {filteredBalanceInvoices.reduce((sum, inv) => sum + (inv.remainingBalance || 0), 0).toFixed(2)}
        </div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Settled</div>
        <div className="summary-value">
          {filteredBalanceInvoices.filter(inv => inv.remainingBalance <= 0).length}
        </div>
      </div>
    </div>

    {/* Balance Invoices Table */}
    {isLoadingBalanceInvoices ? (
      <div className="loading-spinner">Loading balance invoices...</div>
    ) : (
      <div className="balance-table-container">
        <table className="balance-table">
          <thead>
            <tr>
              <th>Balance Invoice #</th>
              <th>Original Invoice #</th>
              <th>Customer Name</th>
              <th>Phone</th>
              <th>Paid Amount</th>
              <th>Remaining Balance</th>
              <th>Payment Method</th>
              <th>Date</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredBalanceInvoices.length === 0 ? (
              <tr>
                <td colSpan="10" style={{ textAlign: 'center', padding: '40px' }}>
                  No balance invoices found
                </td>
              </tr>
            ) : (
              filteredBalanceInvoices.map((invoice) => (
                <tr key={invoice.id}>
                  <td className="invoice-link" onClick={() => viewBalanceInvoiceDetails(invoice)}>
                    {invoice.balanceInvoiceNumber}
                  </td>
                  <td>{invoice.originalInvoiceNumber}</td>
                  <td>{invoice.customerName || 'N/A'}</td>
                  <td>{invoice.customerPhone || 'N/A'}</td>
                  <td className="amount-paid">Rs. {(invoice.paidAmount || 0).toFixed(2)}</td>
                  <td className={`remaining-amount ${invoice.remainingBalance <= 0 ? 'settled' : ''}`}>
                    Rs. {(invoice.remainingBalance || 0).toFixed(2)}
                  </td>
                  <td>
                    <span className="payment-method-badge">{invoice.paymentMethod}</span>
                  </td>
                  <td>
                    <div className="date-cell">
                      <div>{invoice.formattedDate}</div>
                      <small>{invoice.formattedTime}</small>
                    </div>
                  </td>
                  <td>
                    <span 
                      className="status-badge" 
                      style={{ backgroundColor: invoice.statusColor }}
                    >
                      {invoice.statusText}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button
                        className="btn-view"
                        onClick={() => viewBalanceInvoiceDetails(invoice)}
                        title="View Details"
                      >
                        👁️
                      </button>
                      <button
                        className="btn-download"
                        onClick={() => downloadBalanceInvoicePDF(invoice)}
                        title="Download PDF"
                      >
                        📄
                      </button>
                      <button
                        className="btn-delete"
                        onClick={() => deleteBalanceInvoice(invoice.id, invoice.balanceInvoiceNumber)}
                        title="Delete"
                      >
                        🗑️
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    )}

    {/* Balance Invoice Details Modal */}
    {showBalanceInvoiceDetails && selectedBalanceInvoice && (
      <div className="modal-overlay" onClick={() => setShowBalanceInvoiceDetails(false)}>
        <div className="modal-content large" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h3>Balance Invoice Details</h3>
            <button className="modal-close" onClick={() => setShowBalanceInvoiceDetails(false)}>×</button>
          </div>
          
          <div className="modal-body">
            <div className="details-grid">
              <div className="details-section">
                <h4>Invoice Information</h4>
                <div className="detail-item">
                  <label>Balance Invoice #:</label>
                  <span className="value">{selectedBalanceInvoice.balanceInvoiceNumber}</span>
                </div>
                <div className="detail-item">
                  <label>Original Invoice #:</label>
                  <span>{selectedBalanceInvoice.originalInvoiceNumber}</span>
                </div>
                <div className="detail-item">
                  <label>Date Created:</label>
                  <span>{selectedBalanceInvoice.formattedDate} at {selectedBalanceInvoice.formattedTime}</span>
                </div>
                <div className="detail-item">
                  <label>Status:</label>
                  <span className="status-badge" style={{ backgroundColor: selectedBalanceInvoice.statusColor }}>
                    {selectedBalanceInvoice.statusText}
                  </span>
                </div>
              </div>

              <div className="details-section">
                <h4>Customer Information</h4>
                <div className="detail-item">
                  <label>Customer Name:</label>
                  <span>{selectedBalanceInvoice.customerName || 'N/A'}</span>
                </div>
                <div className="detail-item">
                  <label>Phone Number:</label>
                  <span>{selectedBalanceInvoice.customerPhone || 'N/A'}</span>
                </div>
              </div>

              <div className="details-section">
                <h4>Payment Details</h4>
                <div className="detail-item">
                  <label>Original Amount:</label>
                  <span>Rs. {(selectedBalanceInvoice.originalAmount || 0).toFixed(2)}</span>
                </div>
                <div className="detail-item">
                  <label>Previous Advance:</label>
                  <span>Rs. {(selectedBalanceInvoice.originalAdvance || 0).toFixed(2)}</span>
                </div>
                <div className="detail-item">
                  <label>Previous Balance:</label>
                  <span>Rs. {(selectedBalanceInvoice.originalBalance || 0).toFixed(2)}</span>
                </div>
                <div className="detail-item highlight">
                  <label>Amount Paid:</label>
                  <span className="paid-amount">Rs. {(selectedBalanceInvoice.paidAmount || 0).toFixed(2)}</span>
                </div>
                <div className="detail-item">
                  <label>Payment Method:</label>
                  <span>{selectedBalanceInvoice.paymentMethod}</span>
                </div>
                <div className="detail-item">
                  <label>Remaining Balance:</label>
                  <span className={`remaining ${selectedBalanceInvoice.remainingBalance <= 0 ? 'settled' : ''}`}>
                    Rs. {(selectedBalanceInvoice.remainingBalance || 0).toFixed(2)}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button 
              className="btn-download" 
              onClick={() => downloadBalanceInvoicePDF(selectedBalanceInvoice)}
            >
              📄 Download PDF
            </button>
            <button 
              className="btn-delete" 
              onClick={() => {
                deleteBalanceInvoice(selectedBalanceInvoice.id, selectedBalanceInvoice.balanceInvoiceNumber);
                setShowBalanceInvoiceDetails(false);
              }}
            >
              🗑️ Delete
            </button>
            <button className="btn-close" onClick={() => setShowBalanceInvoiceDetails(false)}>
              Close
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
)}









{/***********************************************  view all consultation ********************************************/}


{selectedOption === "viewConsultation" && (
  <div className="consultation-container">
    <div className="consultation-header">
      <div>
        <h2>Consultations</h2>
        <p className="subtitle">View and manage all patient consultations</p>
      </div>
      <button className="btn-export-report" onClick={generateConsultationReportPDF}>
        📊 Export Report
      </button>
    </div>

    {/* Filters Section */}
    <div className="filters-section">
      <div className="filter-row">
        <div className="filter-group">
          <label>Search:</label>
          <input
            type="text"
            placeholder="Search by customer name..."
            value={consultationSearchTerm}
            onChange={(e) => setConsultationSearchTerm(e.target.value)}
            className="filter-input"
          />
        </div>

        <div className="filter-group">
          <label>Status:</label>
          <select
            value={consultationFilterStatus}
            onChange={(e) => setConsultationFilterStatus(e.target.value)}
            className="filter-select"
          >
            <option value="all">All</option>
            <option value="completed">Completed</option>
            <option value="pending">Pending</option>
            <option value="cancelled">Cancelled</option>
          </select>
        </div>

        <div className="filter-group">
          <label>Date Range:</label>
          <input
            type="date"
            value={consultationDateRange.start}
            onChange={(e) => setConsultationDateRange(prev => ({ ...prev, start: e.target.value }))}
            className="filter-date"
          />
          <span>to</span>
          <input
            type="date"
            value={consultationDateRange.end}
            onChange={(e) => setConsultationDateRange(prev => ({ ...prev, end: e.target.value }))}
            className="filter-date"
          />
        </div>

        <button className="btn-reset" onClick={resetConsultationFilters}>
          🔄 Reset
        </button>
        <button className="btn-refresh" onClick={fetchAllConsultations}>
          🔄 Refresh
        </button>
      </div>
    </div>

    {/* Summary Cards */}
    <div className="summary-cards">
      <div className="summary-card">
        <div className="summary-title">Total Consultations</div>
        <div className="summary-value">{filteredConsultations.length}</div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Total Revenue</div>
        <div className="summary-value">
          Rs. {filteredConsultations.reduce((sum, c) => sum + c.totalAmount, 0).toFixed(2)}
        </div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Completed</div>
        <div className="summary-value">
          {filteredConsultations.filter(c => c.pendingItems === 0 && c.cancelledItems === 0).length}
        </div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Pending</div>
        <div className="summary-value">
          {filteredConsultations.filter(c => c.pendingItems > 0).length}
        </div>
      </div>
    </div>

    {/* Consultations Table */}
    {isLoadingConsultations ? (
      <div className="loading-spinner">Loading consultations...</div>
    ) : (
      <div className="consultation-table-container">
        <table className="consultation-table">
          <thead>
            <tr>
              <th>Date & Time</th>
              <th>Customer Name</th>
              <th>Delivery Date</th>
              <th>Items</th>
              <th>Total Amount</th>
              <th>Completed</th>
              <th>Pending</th>
              <th>Cancelled</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredConsultations.length === 0 ? (
              <tr>
                <td colSpan="10" style={{ textAlign: 'center', padding: '40px' }}>
                  No consultations found
                </td>
              </tr>
            ) : (
              filteredConsultations.map((consultation) => {
                const status = getStatusBadge(consultation);
                return (
                  <tr key={consultation.id}>
                    <td>
                      <div className="date-cell">
                        <div>{consultation.formattedDate}</div>
                        <small>{consultation.formattedTime}</small>
                      </div>
                    </td>
                    <td className="customer-name">{consultation.customerName}</td>
                    <td>{consultation.deliveryDate || 'N/A'}</td>
                    <td className="text-center">{consultation.items.length}</td>
                    <td className="amount">Rs. {consultation.totalAmount.toFixed(2)}</td>
                    <td className="text-center completed">{consultation.completedItems}</td>
                    <td className="text-center pending">{consultation.pendingItems}</td>
                    <td className="text-center cancelled">{consultation.cancelledItems}</td>
                    <td>
                      <span className="status-badge" style={{ backgroundColor: status.color }}>
                        {status.text}
                      </span>
                    </td>
                    <td>
                      <div className="action-buttons">
                        <button
                          className="btn-view"
                          onClick={() => {
                            setSelectedConsultation(consultation);
                            setShowConsultationDetails(true);
                          }}
                          title="View Details"
                        >
                          👁️
                        </button>
                        <button
                          className="btn-delete"
                          onClick={() => deleteConsultation(consultation.id, consultation.customerName)}
                          title="Delete"
                        >
                          🗑️
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    )}

    {/* Consultation Details Modal */}
    {showConsultationDetails && selectedConsultation && (
      <div className="modal-overlay" onClick={() => setShowConsultationDetails(false)}>
        <div className="modal-content large" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h3>Consultation Details</h3>
            <button className="modal-close" onClick={() => setShowConsultationDetails(false)}>×</button>
          </div>
          
          <div className="modal-body">
            <div className="details-grid">
              <div className="details-section">
                <h4>Consultation Information</h4>
                <div className="detail-item">
                  <label>Customer Name:</label>
                  <span className="value">{selectedConsultation.customerName}</span>
                </div>
                <div className="detail-item">
                  <label>Date:</label>
                  <span>{selectedConsultation.formattedDate}</span>
                </div>
                <div className="detail-item">
                  <label>Time:</label>
                  <span>{selectedConsultation.formattedTime}</span>
                </div>
                <div className="detail-item">
                  <label>Delivery Date:</label>
                  <span>{selectedConsultation.deliveryDate || 'Not specified'}</span>
                </div>
              </div>

              <div className="details-section">
                <h4>Summary</h4>
                <div className="detail-item">
                  <label>Total Items:</label>
                  <span>{selectedConsultation.items.length}</span>
                </div>
                <div className="detail-item">
                  <label>Total Amount:</label>
                  <span className="amount">Rs. {selectedConsultation.totalAmount.toFixed(2)}</span>
                </div>
                <div className="detail-item">
                  <label>Completed:</label>
                  <span className="completed">{selectedConsultation.completedItems}</span>
                </div>
                <div className="detail-item">
                  <label>Pending:</label>
                  <span className="pending">{selectedConsultation.pendingItems}</span>
                </div>
                <div className="detail-item">
                  <label>Cancelled:</label>
                  <span className="cancelled">{selectedConsultation.cancelledItems}</span>
                </div>
              </div>

              <div className="details-section full-width">
                <h4>Consultation Items</h4>
                <div className="items-table-container">
                  <table className="items-table">
                    <thead>
                      <tr>
                        <th>Item Name</th>
                        <th>Price (Rs.)</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedConsultation.items.map((item) => (
                        <tr key={item.id}>
                          <td>{item.name}</td>
                          <td>Rs. {item.price.toFixed(2)}</td>
                          <td>
                            <span className={`status-badge-small ${item.status}`}>
                              {item.status}
                            </span>
                          </td>
                          <td>
                            {item.status === 'pending' && (
                              <div className="status-update-buttons">
                                <button
                                  className="btn-complete"
                                  onClick={() => {
                                    setSelectedItemForStatus(item);
                                    setNewStatus('completed');
                                    setShowUpdateStatusModal(true);
                                  }}
                                >
                                  ✓ Complete
                                </button>
                                <button
                                  className="btn-cancel"
                                  onClick={() => {
                                    setSelectedItemForStatus(item);
                                    setNewStatus('cancelled');
                                    setShowUpdateStatusModal(true);
                                  }}
                                >
                                  ✗ Cancel
                                </button>
                              </div>
                            )}
                            {item.status === 'completed' && (
                              <span className="completed-badge">✓ Completed</span>
                            )}
                            {item.status === 'cancelled' && (
                              <span className="cancelled-badge">✗ Cancelled</span>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button className="btn-close" onClick={() => setShowConsultationDetails(false)}>
              Close
            </button>
          </div>
        </div>
      </div>
    )}

    {/* Update Status Modal */}
    {showUpdateStatusModal && selectedItemForStatus && (
      <div className="modal-overlay" onClick={() => setShowUpdateStatusModal(false)}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h3>Update Item Status</h3>
            <button className="modal-close" onClick={() => setShowUpdateStatusModal(false)}>×</button>
          </div>
          
          <div className="modal-body">
            <div className="detail-item">
              <label>Item:</label>
              <span>{selectedItemForStatus.name}</span>
            </div>
            <div className="detail-item">
              <label>Current Status:</label>
              <span className={`status-badge-small ${selectedItemForStatus.status}`}>
                {selectedItemForStatus.status}
              </span>
            </div>
            <div className="detail-item">
              <label>New Status:</label>
              <span className={`status-badge-small ${newStatus}`}>
                {newStatus}
              </span>
            </div>
            <p className="confirmation-message">
              Are you sure you want to mark this item as {newStatus}?
            </p>
          </div>

          <div className="modal-footer">
            <button className="btn-cancel" onClick={() => setShowUpdateStatusModal(false)}>
              No, Cancel
            </button>
            <button 
              className="btn-confirm"
              onClick={() => updateConsultationItemStatus(
                selectedConsultation.id,
                selectedItemForStatus.id,
                newStatus
              )}
            >
              Yes, Update Status
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
)}







{/*************************************************************** Add Supplier******************************************************/}
 
 
   {selectedOption === "addSupplier" && (
  <div className="add-supplier-container">
    <div className="add-supplier-card">
      <h2>Add Supplier</h2>

      {/* Supplier Name */}
      <label>Supplier Name *</label>
      <input
        type="text"
        value={supplierName}
        onChange={(e) => setSupplierName(e.target.value)}
        placeholder="Enter supplier name"
      />

      {/* Email */}
      <label>Email</label>
      <input
        type="email"
        value={supplierEmail}
        onChange={(e) => setSupplierEmail(e.target.value)}
        placeholder="Enter email"
      />

      {/* Phone */}
      <label>Phone *</label>
      <input
        type="tel"
        value={supplierPhone}
        onChange={(e) => setSupplierPhone(e.target.value)}
        placeholder="Enter phone number"
      />

      {/* Company */}
      <label>Company *</label>
      <input
        type="text"
        value={supplierCompany}
        onChange={(e) => setSupplierCompany(e.target.value)}
        placeholder="Enter company name"
      />

      {/* Address */}
      <label>Address *</label>
      <textarea
        value={supplierAddress}
        onChange={(e) => setSupplierAddress(e.target.value)}
        placeholder="Enter address"
        rows="3"
      />

      {/* Buttons */}
      <button onClick={handleClearSupplier}>Clear</button>
      <button onClick={handleAddSupplier}>Add Supplier</button>
    </div>
  </div>
)}




{/******************************************************* DashBoard  *****************************************************************/}

        {selectedOption === "dashboard" && (
  <div className="dashboard-container">
    {isLoadingDashboard ? (
      <div className="loading-spinner">Loading dashboard data...</div>
    ) : (
      <>
        {/* Header with date filters */}
        <div className="dashboard-header">
          <div>
            <h2>Dashboard</h2>
            <p className="subtitle">Welcome back! Here's your business overview</p>
          </div>
          <div className="date-filters">
            <select 
              value={selectedYear} 
              onChange={(e) => setSelectedYear(parseInt(e.target.value))}
              className="filter-select"
            >
              {[2023, 2024, 2025, 2026].map(year => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
            <select 
              value={selectedMonth} 
              onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
              className="filter-select"
            >
              {Array.from({ length: 12 }, (_, i) => i + 1).map(month => (
                <option key={month} value={month}>
                  {new Date(2000, month - 1, 1).toLocaleString('default', { month: 'long' })}
                </option>
              ))}
            </select>
            <button className="btn-refresh" onClick={fetchDashboardData}>
              🔄 Refresh
            </button>
          </div>
        </div>

        {/* KPI Cards */}
        <div className="kpi-grid">
          <div className="kpi-card revenue">
            <div className="kpi-icon">💰</div>
            <div className="kpi-content">
              <div className="kpi-label">Total Revenue</div>
              <div className="kpi-value">{formatCurrency(dashboardStats.totalRevenue)}</div>
              <div className="kpi-trend positive">↑ 12% from last month</div>
            </div>
          </div>
          
          <div className="kpi-card invoices">
            <div className="kpi-icon">📄</div>
            <div className="kpi-content">
              <div className="kpi-label">Total Invoices</div>
              <div className="kpi-value">{dashboardStats.totalInvoices}</div>
              <div className="kpi-trend">Avg. {formatCurrency(dashboardStats.averageInvoiceValue)} per invoice</div>
            </div>
          </div>
          
          <div className="kpi-card patients">
            <div className="kpi-icon">👥</div>
            <div className="kpi-content">
              <div className="kpi-label">Total Patients</div>
              <div className="kpi-value">{dashboardStats.totalPatients}</div>
              <div className="kpi-trend">Unique customers served</div>
            </div>
          </div>
          
          <div className="kpi-card pending">
            <div className="kpi-icon">⏳</div>
            <div className="kpi-content">
              <div className="kpi-label">Pending Balance</div>
              <div className="kpi-value">{formatCurrency(dashboardStats.pendingBalance)}</div>
              <div className="kpi-trend negative">Due from customers</div>
            </div>
          </div>
        </div>

        {/* Products Sold Cards */}
        <div className="products-grid">
          <div className="product-card frames">
            <div className="product-icon">👓</div>
            <div className="product-info">
              <div className="product-label">Frames Sold</div>
              <div className="product-value">{dashboardStats.framesSold}</div>
            </div>
          </div>
          <div className="product-card lenses">
            <div className="product-icon">🔍</div>
            <div className="product-info">
              <div className="product-label">Lenses Sold</div>
              <div className="product-value">{dashboardStats.lensesSold}</div>
            </div>
          </div>
        </div>

        {/* Charts Section */}
        <div className="charts-grid">
          <div className="chart-card large">
            <div className="chart-header">
              <h3>Revenue Overview</h3>
            </div>
            <div className="chart-container">
              <Bar data={revenueChartData} options={revenueChartOptions} />
            </div>
          </div>
          
          <div className="chart-card">
            <div className="chart-header">
              <h3>Payment Methods</h3>
            </div>
            <div className="chart-container small">
              <Doughnut data={paymentMethodChartData} options={paymentMethodOptions} />
            </div>
          </div>
        </div>

        {/* Daily Sales Chart */}
        <div className="chart-card full-width">
          <div className="chart-header">
            <h3>Daily Sales Performance</h3>
            <p className="chart-subtitle">Sales breakdown for {new Date(selectedYear, selectedMonth - 1, 1).toLocaleString('default', { month: 'long' })} {selectedYear}</p>
          </div>
          <div className="chart-container medium">
            <Line data={dailySalesChartData} options={dailySalesOptions} />
          </div>
        </div>

        {/* Top Products & Recent Invoices */}
        <div className="two-column-grid">
          {/* Top Products */}
          <div className="info-card">
            <div className="card-header">
              <h3>🏆 Top Selling Products</h3>
            </div>
            <div className="card-body">
              {dashboardStats.topProducts.length === 0 ? (
                <div className="empty-state">No products sold yet</div>
              ) : (
                <div className="top-products-list">
                  {dashboardStats.topProducts.map((product, index) => (
                    <div key={index} className="product-item">
                      <div className="product-rank">{index + 1}</div>
                      <div className="product-name">{product.name}</div>
                      <div className="product-count">{product.count} units</div>
                      <div className="product-bar">
                        <div 
                          className="product-bar-fill" 
                          style={{ 
                            width: `${(product.count / dashboardStats.topProducts[0].count) * 100}%`,
                            backgroundColor: index === 0 ? '#4CAF50' : index === 1 ? '#2196F3' : '#FF9800'
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Recent Invoices */}
          <div className="info-card">
            <div className="card-header">
              <h3>📋 Recent Invoices</h3>
            </div>
            <div className="card-body">
              {dashboardStats.recentInvoices.length === 0 ? (
                <div className="empty-state">No recent invoices</div>
              ) : (
                <div className="recent-invoices-list">
                  {dashboardStats.recentInvoices.map((invoice, index) => (
                    <div key={index} className="invoice-item">
                      <div className="invoice-info">
                        <div className="invoice-number">{invoice.invoiceNumber}</div>
                        <div className="invoice-customer">{invoice.customerName}</div>
                        <div className="invoice-date">
                          {new Date(invoice.date).toLocaleDateString()}
                        </div>
                      </div>
                      <div className="invoice-amounts">
                        <div className="invoice-total">{formatCurrency(invoice.totalAmount)}</div>
                        <div className="invoice-paid">Paid: {formatCurrency(invoice.paidAmount)}</div>
                        {invoice.balanceDue > 0 && (
                          <div className="invoice-due">Due: {formatCurrency(invoice.balanceDue)}</div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Quick Stats Footer */}
        <div className="quick-stats">
          <div className="stat-item">
            <span className="stat-label">Average Invoice Value:</span>
            <span className="stat-value">{formatCurrency(dashboardStats.averageInvoiceValue)}</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Collection Rate:</span>
            <span className="stat-value">
              {((dashboardStats.totalRevenue / (dashboardStats.totalRevenue + dashboardStats.pendingBalance)) * 100).toFixed(1)}%
            </span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Revenue per Patient:</span>
            <span className="stat-value">
              {formatCurrency(dashboardStats.totalPatients > 0 ? dashboardStats.totalRevenue / dashboardStats.totalPatients : 0)}
            </span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Monthly Average:</span>
            <span className="stat-value">
              {formatCurrency(dashboardStats.monthlyRevenue.reduce((a, b) => a + b, 0) / 12)}
            </span>
          </div>
        </div>
      </>
    )}
  </div>
)}


{/******************************************************* view patients  *****************************************************************/}



{selectedOption === "viewPatient" && (
  <div className="patient-directory-container">
    <div className="patient-directory-header">
      <div>
        <h2>Patient Directory</h2>
        <p className="subtitle">View and manage all patient records from invoices</p>
      </div>
      <button className="btn-export-report" onClick={generatePatientReportPDF}>
        📊 Export Patient Report
      </button>
    </div>

    {/* Filters Section */}
    <div className="filters-section">
      <div className="filter-row">
        <div className="filter-group">
          <label>Search:</label>
          <input
            type="text"
            placeholder="Search by name, phone, email..."
            value={patientSearchTerm}
            onChange={(e) => setPatientSearchTerm(e.target.value)}
            className="filter-input"
          />
        </div>

        <div className="filter-group">
          <label>Age Group:</label>
          <select
            value={patientFilterAge}
            onChange={(e) => setPatientFilterAge(e.target.value)}
            className="filter-select"
          >
            <option value="all">All Ages</option>
            <option value="child">Child (&lt; 18)</option>
            <option value="adult">Adult (18-59)</option>
            <option value="senior">Senior (60+)</option>
          </select>
        </div>

        <div className="filter-group">
          <label>Gender:</label>
          <select
            value={patientFilterGender}
            onChange={(e) => setPatientFilterGender(e.target.value)}
            className="filter-select"
          >
            <option value="all">All</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
        </div>

        <div className="filter-group">
          <label>Last Visit Range:</label>
          <input
            type="date"
            value={patientDateRange.start}
            onChange={(e) => setPatientDateRange(prev => ({ ...prev, start: e.target.value }))}
            className="filter-date"
          />
          <span>to</span>
          <input
            type="date"
            value={patientDateRange.end}
            onChange={(e) => setPatientDateRange(prev => ({ ...prev, end: e.target.value }))}
            className="filter-date"
          />
        </div>

        <button className="btn-reset" onClick={resetPatientFilters}>
          🔄 Reset
        </button>
        <button className="btn-refresh" onClick={fetchAllPatients}>
          🔄 Refresh
        </button>
      </div>
    </div>

    {/* Summary Cards */}
    <div className="summary-cards">
      <div className="summary-card">
        <div className="summary-title">Total Patients</div>
        <div className="summary-value">{filteredPatients.length}</div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Total Revenue</div>
        <div className="summary-value">
          Rs. {filteredPatients.reduce((sum, p) => sum + p.totalSpent, 0).toFixed(2)}
        </div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Total Due</div>
        <div className="summary-value">
          Rs. {filteredPatients.reduce((sum, p) => sum + p.totalDue, 0).toFixed(2)}
        </div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Average Spent</div>
        <div className="summary-value">
          Rs. {(filteredPatients.reduce((sum, p) => sum + p.totalSpent, 0) / (filteredPatients.length || 1)).toFixed(2)}
        </div>
      </div>
    </div>

    {/* Patients Table */}
    {isLoadingPatients ? (
      <div className="loading-spinner">Loading patients...</div>
    ) : (
      <div className="patient-table-container">
        <table className="patient-table">
          <thead>
            <tr>
              <th>Patient Name</th>
              <th>Contact</th>
              <th>Age</th>
              <th>Gender</th>
              <th>Total Invoices</th>
              <th>Total Spent</th>
              <th>Balance Due</th>
              <th>Last Visit</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredPatients.length === 0 ? (
              <tr>
                <td colSpan="10" style={{ textAlign: 'center', padding: '40px' }}>
                  No patients found
                </td>
              </tr>
            ) : (
              filteredPatients.map((patient) => (
                <tr key={patient.id}>
                  <td className="patient-name" onClick={() => viewPatientDetails(patient)}>
                    <div className="name-cell">
                      <strong>{patient.fullName}</strong>
                      {patient.title && <small>({patient.title})</small>}
                    </div>
                  </td>
                  <td>
                    <div className="contact-cell">
                      <div>{patient.tpNo || 'N/A'}</div>
                      <small>{patient.email || 'No email'}</small>
                    </div>
                  </td>
                  <td>
                    <div className="age-cell">
                      {patient.age || 'N/A'}
                      <small className="age-group">{getAgeGroup(patient.age)}</small>
                    </div>
                  </td>
                  <td>
                    <span className="gender-badge">{patient.gender || 'Not specified'}</span>
                  </td>
                  <td className="text-center">{patient.totalInvoices}</td>
                  <td className="amount">Rs. {patient.totalSpent.toFixed(2)}</td>
                  <td className={`balance-due ${patient.totalDue <= 0 ? 'settled' : ''}`}>
                    Rs. {patient.totalDue.toFixed(2)}
                  </td>
                  <td>
                    <div className="date-cell">
                      <div>{new Date(patient.lastVisit).toLocaleDateString()}</div>
                      <small>First: {new Date(patient.firstVisit).toLocaleDateString()}</small>
                    </div>
                  </td>
                  <td>
                    <span className={`status-badge ${patient.totalDue <= 0 ? 'paid' : 'pending'}`}>
                      {patient.totalDue <= 0 ? 'Settled' : 'Has Due'}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button
                        className="btn-view"
                        onClick={() => viewPatientDetails(patient)}
                        title="View Details"
                      >
                        👁️
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    )}

    {/* Patient Details Modal */}
    {showPatientDetails && selectedPatient && (
      <div className="modal-overlay" onClick={() => setShowPatientDetails(false)}>
        <div className="modal-content large" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h3>Patient Details</h3>
            <button className="modal-close" onClick={() => setShowPatientDetails(false)}>×</button>
          </div>
          
          <div className="modal-body">
            <div className="details-grid">
              <div className="details-section">
                <h4>Personal Information</h4>
                <div className="detail-item">
                  <label>Full Name:</label>
                  <span className="value">{selectedPatient.fullName}</span>
                </div>
                <div className="detail-item">
                  <label>Age:</label>
                  <span>{selectedPatient.age} years ({getAgeGroup(selectedPatient.age)})</span>
                </div>
                <div className="detail-item">
                  <label>Gender:</label>
                  <span>{selectedPatient.gender || 'Not specified'}</span>
                </div>
                <div className="detail-item">
                  <label>Phone:</label>
                  <span>{selectedPatient.tpNo || 'N/A'}</span>
                </div>
                <div className="detail-item">
                  <label>Email:</label>
                  <span>{selectedPatient.email || 'N/A'}</span>
                </div>
                <div className="detail-item">
                  <label>Address:</label>
                  <span>{selectedPatient.address || 'N/A'}</span>
                </div>
              </div>

              <div className="details-section">
                <h4>Financial Summary</h4>
                <div className="detail-item">
                  <label>Total Invoices:</label>
                  <span>{selectedPatient.totalInvoices}</span>
                </div>
                <div className="detail-item">
                  <label>Total Spent:</label>
                  <span className="amount">Rs. {selectedPatient.totalSpent.toFixed(2)}</span>
                </div>
                <div className="detail-item">
                  <label>Total Paid:</label>
                  <span className="paid-amount">Rs. {selectedPatient.totalPaid.toFixed(2)}</span>
                </div>
                <div className="detail-item highlight">
                  <label>Balance Due:</label>
                  <span className={`balance-due ${selectedPatient.totalDue <= 0 ? 'settled' : ''}`}>
                    Rs. {selectedPatient.totalDue.toFixed(2)}
                  </span>
                </div>
                <div className="detail-item">
                  <label>First Visit:</label>
                  <span>{new Date(selectedPatient.firstVisit).toLocaleDateString()}</span>
                </div>
                <div className="detail-item">
                  <label>Last Visit:</label>
                  <span>{new Date(selectedPatient.lastVisit).toLocaleDateString()}</span>
                </div>
              </div>

              <div className="details-section full-width">
                <h4>Invoice History</h4>
                <div className="invoice-history-table">
                  <table className="mini-table">
                    <thead>
                      <tr>
                        <th>Invoice #</th>
                        <th>Date</th>
                        <th>Frame</th>
                        <th>Lens</th>
                        <th>Total</th>
                        <th>Paid</th>
                        <th>Balance</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedPatient.invoices.map((invoice, idx) => (
                        <tr key={idx}>
                          <td className="invoice-link">{invoice.invoiceNumber}</td>
                          <td>{new Date(invoice.date).toLocaleDateString()}</td>
                          <td>{invoice.products?.frameModel || 'N/A'}</td>
                          <td>{invoice.products?.lensModel || 'N/A'}</td>
                          <td>Rs. {invoice.totalAmount.toFixed(2)}</td>
                          <td>Rs. {invoice.paidAmount.toFixed(2)}</td>
                          <td className={invoice.balanceDue > 0 ? 'balance-due' : 'settled'}>
                            Rs. {invoice.balanceDue.toFixed(2)}
                          </td>
                          <td>
                            <span className={`status-badge ${invoice.status}`}>
                              {invoice.status === 'paid' ? 'Paid' : 'Pending'}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {selectedPatient.prescriptions && selectedPatient.prescriptions.length > 0 && (
                <div className="details-section full-width">
                  <h4>Latest Prescription</h4>
                  <div className="prescription-grid">
                    <div className="eye-prescription">
                      <strong>Right Eye (OD)</strong>
                      <div>VA: {selectedPatient.prescriptions[selectedPatient.prescriptions.length - 1]?.rightEye?.visualAcuity || 'N/A'}</div>
                      <div>SPH: {selectedPatient.prescriptions[selectedPatient.prescriptions.length - 1]?.rightEye?.sph || 'N/A'}</div>
                      <div>CYL: {selectedPatient.prescriptions[selectedPatient.prescriptions.length - 1]?.rightEye?.cyl || 'N/A'}</div>
                      <div>AXIS: {selectedPatient.prescriptions[selectedPatient.prescriptions.length - 1]?.rightEye?.axis || 'N/A'}</div>
                      <div>ADD: {selectedPatient.prescriptions[selectedPatient.prescriptions.length - 1]?.rightEye?.add || 'N/A'}</div>
                    </div>
                    <div className="eye-prescription">
                      <strong>Left Eye (OS)</strong>
                      <div>VA: {selectedPatient.prescriptions[selectedPatient.prescriptions.length - 1]?.leftEye?.visualAcuity || 'N/A'}</div>
                      <div>SPH: {selectedPatient.prescriptions[selectedPatient.prescriptions.length - 1]?.leftEye?.sph || 'N/A'}</div>
                      <div>CYL: {selectedPatient.prescriptions[selectedPatient.prescriptions.length - 1]?.leftEye?.cyl || 'N/A'}</div>
                      <div>AXIS: {selectedPatient.prescriptions[selectedPatient.prescriptions.length - 1]?.leftEye?.axis || 'N/A'}</div>
                      <div>ADD: {selectedPatient.prescriptions[selectedPatient.prescriptions.length - 1]?.leftEye?.add || 'N/A'}</div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="modal-footer">
            <button className="btn-close" onClick={() => setShowPatientDetails(false)}>
              Close
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
)}



{/******************************************************* create Invoice *****************************************************************/}


{selectedOption === "createInvoice" && (
//   <>
//     {showSuccess && (
//       <div className="toast-notification">
//         ✓ Order saved successfully! Total: ${totalAmount.toFixed(2)}
//       </div>
//     )}
    
//     <div className="invoice-wrap">
//       <div className="invoice-header">
//         <h2>Create Invoice</h2>
//         <p className="invoice-subtitle">Fill in all required fields (*) to generate order</p>
//       </div>

//       <div className="invoice-content">
//         {/* Customer Info */}
//         <div className="invoice-section">
//           <div className="section-header">
//             <h3>Customer Information</h3>
//             <span className="section-badge">Required</span>
//           </div>
          
//           <div className="form-row">
//             <div className="form-group">
//               <label>Title</label>
//               <select 
//                 className="form-control"
//                 name="title"
//                 value={formData.title}
//                 onChange={handleInputChange}
//               >
//                 <option value="">Select</option>
//                 <option value="Mr">Mr.</option>
//                 <option value="Mrs">Mrs.</option>
//                 <option value="Ms">Ms.</option>
//                 <option value="Dr">Dr.</option>
//                 <option value="Rev">Rev.</option>
//               </select>
//             </div>

//             <div className="form-group">
//               <label>First Name <span className="required-star">*</span></label>
//               <input 
//                 type="text" 
//                 name="firstName"
//                 value={formData.firstName}
//                 onChange={handleInputChange}
//                 placeholder="Enter first name"
//                 className={errors.firstName ? 'error-input' : ''}
//               />
//               {errors.firstName && <span className="error-message">{errors.firstName}</span>}
//             </div>
            
//             <div className="form-group">
//               <label>Last Name <span className="required-star">*</span></label>
//               <input 
//                 type="text" 
//                 name="lastName"
//                 value={formData.lastName}
//                 onChange={handleInputChange}
//                 placeholder="Enter last name"
//                 className={errors.lastName ? 'error-input' : ''}
//               />
//               {errors.lastName && <span className="error-message">{errors.lastName}</span>}
//             </div>
//           </div>
          
//           <div className="form-row">
//             <div className="form-group">
//               <label>Address <span className="required-star">*</span></label>
//               <input 
//                 type="text" 
//                 name="address"
//                 value={formData.address}
//                 onChange={handleInputChange}
//                 placeholder="Street, city, postal code"
//                 className={errors.address ? 'error-input' : ''}
//               />
//               {errors.address && <span className="error-message">{errors.address}</span>}
//             </div>
            
//             <div className="form-group">
//               <label>TP No <span className="required-star">*</span></label>
//               <input 
//                 type="tel" 
//                 name="tpNo"
//                 value={formData.tpNo}
//                 onChange={handleInputChange}
//                 placeholder="Phone number"
//                 className={errors.tpNo ? 'error-input' : ''}
//               />
//               {errors.tpNo && <span className="error-message">{errors.tpNo}</span>}
//             </div>
            
//             <div className="form-group">
//               <label>Email</label>
//               <input 
//                 type="email" 
//                 name="email"
//                 value={formData.email}
//                 onChange={handleInputChange}
//                 placeholder="customer@example.com"
//               />
//             </div>
            
//             <div className="form-group">
//               <label>Age <span className="required-star">*</span></label>
//               <input 
//                 type="number" 
//                 name="age"
//                 value={formData.age}
//                 onChange={handleInputChange}
//                 placeholder="Years"
//                 className={errors.age ? 'error-input' : ''}
//               />
//               {errors.age && <span className="error-message">{errors.age}</span>}
//             </div>
//           </div>
//         </div>

//         {/* Prescription */}
//         <div className="invoice-section">
//           <div className="section-header">
//             <h3>Optical Prescription</h3>
//             <span className="section-badge">Eye Details</span>
//           </div>
          
//           <div className="form-row">
//             <div className="form-group">
//               <label>Prescription Date</label>
//               <input 
//                 type="date" 
//                 name="prescriptionDate"
//                 value={formData.prescriptionDate}
//                 onChange={handleInputChange}
//               />
//             </div>
            
//             <div className="form-group">
//               <label>Referred By</label>
//               <select 
//                 name="referredBy"
//                 value={formData.referredBy}
//                 onChange={handleInputChange}
//               >
//                 <option value="OWN">OWN</option>
//                 <option value="Other">Other</option>
//               </select>
//             </div>
//           </div>

//           <div className="prescription-grid">
//             {/* Right Eye */}
//             <div className="eye-section">
//               <h4>Right Eye (OD)</h4>

//               <div className="eye-field-group">
//                 <label>Visual Acuity</label>
//                 <select 
//                   className="form-control"
//                   name="rightVisualAcuity"
//                   value={formData.rightVisualAcuity}
//                   onChange={handleInputChange}
//                 >
//                   <option value="">Select</option>
//                   <option value="6/6">6/6</option>
//                   <option value="6/9">6/9</option>
//                   <option value="6/12">6/12</option>
//                   <option value="6/18">6/18</option>
//                   <option value="6/24">6/24</option>
//                   <option value="6/36">6/36</option>
//                   <option value="6/60">6/60</option>  
//                 </select>
//               </div>

//               <div className="eye-fields">
//                 <div className="eye-field-group">
//                   <label>Distance</label>
//                   <div className="presc-inputs">
//                     <input 
//                       type="text" 
//                       name="rightSph"
//                       value={formData.rightSph}
//                       onChange={handleInputChange}
//                       placeholder="SPH"
//                     />
//                     <input 
//                       type="text" 
//                       name="rightCyl"
//                       value={formData.rightCyl}
//                       onChange={handleInputChange}
//                       placeholder="CYL"
//                     />
//                     <input 
//                       type="text" 
//                       name="rightAxis"
//                       value={formData.rightAxis}
//                       onChange={handleInputChange}
//                       placeholder="AXIS"
//                     />
//                   </div>
//                 </div>
//                 <div className="eye-field-group">
//                   <label>Reading</label>
//                   <input 
//                     type="text" 
//                     name="rightAdd"
//                     value={formData.rightAdd}
//                     onChange={handleInputChange}
//                     placeholder="Addition"
//                   />
//                 </div>

//                 <div className="eye-field-group">
//                   <label>Near VA</label>
//                   <select 
//                     className="form-control"
//                     name="rightNearVA"
//                     value={formData.rightNearVA}
//                     onChange={handleInputChange}
//                   >
//                     <option value="">Select</option>
//                     <option value="N5">N5</option>
//                     <option value="N6">N6</option>
//                     <option value="N8">N8</option>
//                     <option value="N10">N10</option>
//                     <option value="N14">N14</option>
//                     <option value="N24">N24</option>
//                     <option value="N36">N36</option>  
//                   </select>
//                 </div>
//               </div>
//             </div>

//             {/* Left Eye */}
//             <div className="eye-section">
//               <h4>Left Eye (OS)</h4>

//               <div className="eye-field-group">
//                 <label>Visual Acuity</label>
//                 <select 
//                   className="form-control"
//                   name="leftVisualAcuity"
//                   value={formData.leftVisualAcuity}
//                   onChange={handleInputChange}
//                 >
//                   <option value="">Select</option>
//                   <option value="6/6">6/6</option>
//                   <option value="6/9">6/9</option>
//                   <option value="6/12">6/12</option>
//                   <option value="6/18">6/18</option>
//                   <option value="6/24">6/24</option>
//                   <option value="6/36">6/36</option>
//                   <option value="6/60">6/60</option>  
//                 </select>
//               </div>

//               <div className="eye-fields">
//                 <div className="eye-field-group">
//                   <label>Distance</label>
//                   <div className="presc-inputs">
//                     <input 
//                       type="text" 
//                       name="leftSph"
//                       value={formData.leftSph}
//                       onChange={handleInputChange}
//                       placeholder="SPH"
//                     />
//                     <input 
//                       type="text" 
//                       name="leftCyl"
//                       value={formData.leftCyl}
//                       onChange={handleInputChange}
//                       placeholder="CYL"
//                     />
//                     <input 
//                       type="text" 
//                       name="leftAxis"
//                       value={formData.leftAxis}
//                       onChange={handleInputChange}
//                       placeholder="AXIS"
//                     />
//                   </div>
//                 </div>
//                 <div className="eye-field-group">
//                   <label>Reading</label>
//                   <input 
//                     type="text" 
//                     name="leftAdd"
//                     value={formData.leftAdd}
//                     onChange={handleInputChange}
//                     placeholder="Addition"
//                   />
//                 </div>

//                 <div className="eye-field-group">
//                   <label>Near VA</label>
//                   <select 
//                     className="form-control"
//                     name="leftNearVA"
//                     value={formData.leftNearVA}
//                     onChange={handleInputChange}
//                   >
//                     <option value="">Select</option>
//                     <option value="N5">N5</option>
//                     <option value="N6">N6</option>
//                     <option value="N8">N8</option>
//                     <option value="N10">N10</option>
//                     <option value="N14">N14</option>
//                     <option value="N24">N24</option>
//                     <option value="N36">N36</option>  
//                   </select>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Lens & Frame */}
//         <div className="invoice-section">
//           <div className="section-header">
//             <h3>Lens & Frame Details</h3>
//             <span className="section-badge">Products</span>
//           </div>
          
//           <div className="form-row">
//             <div className="form-group">
//               <label>Lens Model</label>
//               <select 
//                 className="form-control"
//                 name="lensModel"
//                 value={formData.lensModel}
//                 onChange={handleLensSelect}
//               >
//                 <option value="">Select Lens Model</option>
//                 <option value="CR39 S/V">CR39 S/V</option>
//                 <option value="CR39 S/V AR">CR39 S/V AR</option>
//                 <option value="CR39 S/V AR TRN">CR39 S/V AR TRN</option>
//                 <option value="CR39 S/V TRN">CR39 S/V TRN</option>
//                 <option value="CR39 S/V HND">CR39 S/V HND</option>
//                 <option value="CR39 S/V HND AR">CR39 S/V HND AR</option>
//                 <option value="CR39 S/V HND TRN">CR39 S/V HND TRN</option>
//                 <option value="CR39 S/V HND AR TRN">CR39 S/V HND AR TRN</option>
//                 <option value="CR39 B/F">CR39 B/F</option>
//                 <option value="CR39 B/F AR">CR39 B/F AR</option>
//                 <option value="CR39 B/F TRN">CR39 B/F TRN</option>
//                 <option value="CR39 B/F AR TRN">CR39 B/F AR TRN</option>
//                 <option value="CR39 F/T">CR39 F/T</option>
//                 <option value="CR39 F/T AR">CR39 F/T AR</option>
//                 <option value="CR39 F/T TRN">CR39 F/T TRN</option>
//                 <option value="CR F/T AR TRN">CR F/T AR TRN</option>
//                 <option value="CR39 PROG">CR39 PROG</option>
//                 <option value="CR39 PROG AR">CR39 PROG AR</option>
//                 <option value="CR39 PROG TRN">CR39 PROG TRN</option>
//                 <option value="C/L SOFT REG">C/L SOFT REG</option>
//                 <option value="C/L SOFT DIS">C/L SOFT DIS</option>
//                 <option value="C/L SOFT COS">C/L SOFT COS</option>
//                 <option value="C/L SOFT COS POW">C/L SOFT COS POW</option>
//                 <option value="BF01">BF01</option>
//                 <option value="BF012">BF012</option>
//                 <option value="BF015">BF015</option>
//               </select>
//             </div>
          
// <div className="form-group">
//   <label>Frame Model</label>
//   <div style={{ position: 'relative' }}>
    
//     <input
//       type="text"
//       name="frameModel"
//       value={frameSearchTerm}
//       onChange={(e) => handleFrameSearch(e.target.value)}
//       onFocus={() => frameSearchTerm.length >= 2 && setShowFrameSuggestions(true)}
//       placeholder="Type frame model..."
//       className={errors.frameModel ? 'error-input' : ''}
//     />

//     {showFrameSuggestions && frameSuggestions.length > 0 && (
//       <div className="suggestions-dropdown">
//         {frameSuggestions.map((frame, index) => (
//           <div 
//             key={index}
//             className="suggestion-item"
//             onClick={() => selectFrame(frame)}
//           >
//             <strong>{frame.modelNo}</strong>
//             <div className="suggestion-details">
//               {frame.brand} | {frame.colour} | Rs.{frame.sellingPrice}
//               <span className="stock-badge">Stock: {frame.qty}</span>
//             </div>
//           </div>
//         ))}
//       </div>
//     )}

//   </div>
// </div>
            
//             <div className="form-group">
//               <label>Brand</label>
//               <input 
//                 type="text" 
//                 name="brand"
//                 value={formData.brand}
//                 readOnly
//                 className="readonly-field"
//                 placeholder="Auto-filled from frame"
//               />
//             </div>
            
//             <div className="form-group">
//               <label>Colour</label>
//               <input 
//                 type="text" 
//                 name="colour"
//                 value={formData.colour}
//                 readOnly
//                 className="readonly-field"
//                 placeholder="Auto-filled from frame"
//               />
//             </div>
//           </div>
//         </div>

//         {/* Delivery & Pricing */}
//         <div className="invoice-section">
//           <div className="section-header">
//             <h3>Pricing & Delivery</h3>
//             <span className="section-badge">Financial</span>
//           </div>
          
//           <div className="form-row">
//             <div className="form-group">
//               <label>Delivery Date</label>
//               <input 
//                 type="date" 
//                 name="deliveryDate"
//                 value={formData.deliveryDate}
//                 onChange={handleInputChange}
//               />
//             </div>
            
//             <div className="form-group">
//               <label>Lens Price ($)</label>
//               <input 
//                 type="number" 
//                 name="lensPrice"
//                 value={formData.lensPrice}
//                 onChange={handleInputChange}
//                 placeholder="0.00"
//                 step="0.01"
//               />
//             </div>
            
//             <div className="form-group">
//               <label>Frame Price ($)</label>
//               <input 
//                 type="number" 
//                 name="framePrice"
//                 value={formData.framePrice}
//                 readOnly
//                 className="readonly-field"
//                 placeholder="Auto-filled"
//                 step="0.01"
//               />
//             </div>

//             <div className="form-group total-group">
//               <label>Discount ($)</label>
//               <input 
//                 type="number"
//                 name="discount"
//                 value={formData.discount}
//                 onChange={handleInputChange}
//                 placeholder="0.00"
//                 step="0.01"
//               />
//             </div>

//             <div className="form-group total-group">
//               <label>Advance Payment ($)</label>
//               <input 
//                 type="number"
//                 name="advancePayment"
//                 value={formData.advancePayment}
//                 onChange={handleInputChange}
//                 placeholder="0.00"
//                 step="0.01"
//               />
//             </div>

//             <div className="form-group total-group">
//               <label>Total Amount ($)</label>
//               <input 
//                 type="text" 
//                 value={`$${totalAmount.toFixed(2)}`}
//                 readOnly
//                 className="total-input"
//               />
//             </div>
//           </div>

//           <div className="form-row">
//             <div className="eye-field-group">
//               <label>Bill Description</label>
//               <select 
//                 className="form-control"
//                 name="billDescription"
//                 value={formData.billDescription}
//                 onChange={handleInputChange}
//               >
//                 <option value="Frame and Lenses">Frame and Lenses</option>
//                 <option value="Lenses">Lenses</option>
//                 <option value="Frame">Frame</option>
//                 <option value="Contact Lenses">Contact Lenses</option>
//                 <option value="Sunglass">Sunglass</option>  
//               </select>
//             </div>

//             <div className="eye-field-group">
//               <label>Payment Method</label>
//               <select 
//                 className="form-control"
//                 name="paymentMethod"
//                 value={formData.paymentMethod}
//                 onChange={handleInputChange}
//               >
//                 <option value="Cash">Cash</option>
//                 <option value="Card">Card</option>
//                 <option value="Bank Transfer">Bank Transfer</option>
//                 <option value="Deposit">Deposit</option>
//               </select>
//             </div>
//           </div>
//         </div>

//         {/* Actions */}
//         <div className="invoice-actions">
//           <button className="btn-save" onClick={handleSaveOrder} disabled={isLoading}>
//             {isLoading ? '⏳ Saving...' : '💾 Save Order'}
//           </button>
//           <button className="btn-clear" onClick={handleResetForm}>
//             🗑️ Clear Form
//           </button>
//         </div>
//       </div>
//     </div>
//   </>

    <>
      {showSuccess && (
        <div className="toast-notification">
          ✓ Order saved successfully! Total: ${totalAmount.toFixed(2)}
        </div>
      )}
      
      <div className="invoice-wrap">
        <div className="invoice-header">
          <h2>Create Invoice</h2>
          <p className="invoice-subtitle">Fill in all required fields (*) to generate order</p>
          <div className="invoice-number-display">Next Invoice: {currentInvoiceNumber}</div>
        </div>

        <div className="invoice-content">
          {/* Customer Info */}
          <div className="invoice-section">
            <div className="section-header">
              <h3>Customer Information</h3>
              <span className="section-badge">Required</span>
            </div>
            
            <div className="form-row">
              <div className="form-group">
                <label>Title</label>
                <select 
                  className="form-control"
                  name="title"
                  value={formData.title}
                  onChange={handleInputChange}
                >
                  <option value="">Select</option>
                  <option value="Mr">Mr.</option>
                  <option value="Mrs">Mrs.</option>
                  <option value="Ms">Ms.</option>
                  <option value="Dr">Dr.</option>
                  <option value="Rev">Rev.</option>
                </select>
              </div>

              <div className="form-group">
                <label>First Name <span className="required-star">*</span></label>
                <input 
                  type="text" 
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  placeholder="Enter first name"
                  className={errors.firstName ? 'error-input' : ''}
                />
                {errors.firstName && <span className="error-message">{errors.firstName}</span>}
              </div>
              
              <div className="form-group">
                <label>Last Name <span className="required-star">*</span></label>
                <input 
                  type="text" 
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  placeholder="Enter last name"
                  className={errors.lastName ? 'error-input' : ''}
                />
                {errors.lastName && <span className="error-message">{errors.lastName}</span>}
              </div>
            </div>
            
            <div className="form-row">
              <div className="form-group">
                <label>Address <span className="required-star">*</span></label>
                <input 
                  type="text" 
                  name="address"
                  value={formData.address}
                  onChange={handleInputChange}
                  placeholder="Street, city, postal code"
                  className={errors.address ? 'error-input' : ''}
                />
                {errors.address && <span className="error-message">{errors.address}</span>}
              </div>
              
              <div className="form-group">
                <label>TP No <span className="required-star">*</span></label>
                <input 
                  type="tel" 
                  name="tpNo"
                  value={formData.tpNo}
                  onChange={handleInputChange}
                  placeholder="Phone number"
                  className={errors.tpNo ? 'error-input' : ''}
                />
                {errors.tpNo && <span className="error-message">{errors.tpNo}</span>}
              </div>
              
              <div className="form-group">
                <label>Email</label>
                <input 
                  type="email" 
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="customer@example.com"
                />
              </div>
              
              <div className="form-group">
                <label>Age <span className="required-star">*</span></label>
                <input 
                  type="number" 
                  name="age"
                  value={formData.age}
                  onChange={handleInputChange}
                  placeholder="Years"
                  className={errors.age ? 'error-input' : ''}
                />
                {errors.age && <span className="error-message">{errors.age}</span>}
              </div>
            </div>
          </div>

          {/* Prescription */}
          <div className="invoice-section">
            <div className="section-header">
              <h3>Optical Prescription</h3>
              <span className="section-badge">Eye Details</span>
            </div>
            
            <div className="form-row">
              <div className="form-group">
                <label>Prescription Date</label>
                <input 
                  type="date" 
                  name="prescriptionDate"
                  value={formData.prescriptionDate}
                  onChange={handleInputChange}
                />
              </div>
              
              <div className="form-group">
                <label>Referred By</label>
                <select 
                  name="referredBy"
                  value={formData.referredBy}
                  onChange={handleInputChange}
                >
                  <option value="OWN">OWN</option>
                  <option value="Other">Other</option>
                </select>
              </div>


              <div className="form-group">
                <label>PD:</label>
                  <input
                    type="text"
                    name="pd"
                    value={formData.pd}
                    onChange={handleInputChange}
                    placeholder="PD"
                  />
                  </div>


              <div className="form-group">
                <label>SH:</label>
                  <input
                    type="text"
                    name="sh"
                    value={formData.sh}
                    onChange={handleInputChange}
                    placeholder="SH"
                    />
                  </div>



               </div>

            <div className="prescription-grid">
              {/* Right Eye */}
              <div className="eye-section">
                <h4>Right Eye (OD)</h4>

                <div className="eye-field-group">
                  <label>Visual Acuity</label>
                  <select 
                    className="form-control"
                    name="rightVisualAcuity"
                    value={formData.rightVisualAcuity}
                    onChange={handleInputChange}
                  >
                    <option value="">Select</option>
                    <option value="6/6">6/6</option>
                    <option value="6/9">6/9</option>
                    <option value="6/12">6/12</option>
                    <option value="6/18">6/18</option>
                    <option value="6/24">6/24</option>
                    <option value="6/36">6/36</option>
                    <option value="6/60">6/60</option>  
                  </select>
                </div>

                <div className="eye-fields">
                  <div className="eye-field-group">
                    <label>Distance</label>
                    <div className="presc-inputs">
                      <input 
                        type="text" 
                        name="rightSph"
                        value={formData.rightSph}
                        onChange={handleInputChange}
                        placeholder="SPH"
                      />
                      <input 
                        type="text" 
                        name="rightCyl"
                        value={formData.rightCyl}
                        onChange={handleInputChange}
                        placeholder="CYL"
                      />
                      <input 
                        type="text" 
                        name="rightAxis"
                        value={formData.rightAxis}
                        onChange={handleInputChange}
                        placeholder="AXIS"
                      />
                    </div>
                  </div>
                  <div className="eye-field-group">
                    <label>Reading</label>
                    <input 
                      type="text" 
                      name="rightAdd"
                      value={formData.rightAdd}
                      onChange={handleInputChange}
                      placeholder="Addition"
                    />
                  </div>

                  <div className="eye-field-group">
                    <label>Near VA</label>
                    <select 
                      className="form-control"
                      name="rightNearVA"
                      value={formData.rightNearVA}
                      onChange={handleInputChange}
                    >
                      <option value="">Select</option>
                      <option value="N5">N5</option>
                      <option value="N6">N6</option>
                      <option value="N8">N8</option>
                      <option value="N10">N10</option>
                      <option value="N14">N14</option>
                      <option value="N24">N24</option>
                      <option value="N36">N36</option>  
                    </select>
                  </div>
                </div>
              </div>

              {/* Left Eye */}
              <div className="eye-section">
                <h4>Left Eye (OS)</h4>

                <div className="eye-field-group">
                  <label>Visual Acuity</label>
                  <select 
                    className="form-control"
                    name="leftVisualAcuity"
                    value={formData.leftVisualAcuity}
                    onChange={handleInputChange}
                  >
                    <option value="">Select</option>
                    <option value="6/6">6/6</option>
                    <option value="6/9">6/9</option>
                    <option value="6/12">6/12</option>
                    <option value="6/18">6/18</option>
                    <option value="6/24">6/24</option>
                    <option value="6/36">6/36</option>
                    <option value="6/60">6/60</option>  
                  </select>
                </div>

                <div className="eye-fields">
                  <div className="eye-field-group">
                    <label>Distance</label>
                    <div className="presc-inputs">
                      <input 
                        type="text" 
                        name="leftSph"
                        value={formData.leftSph}
                        onChange={handleInputChange}
                        placeholder="SPH"
                      />
                      <input 
                        type="text" 
                        name="leftCyl"
                        value={formData.leftCyl}
                        onChange={handleInputChange}
                        placeholder="CYL"
                      />
                      <input 
                        type="text" 
                        name="leftAxis"
                        value={formData.leftAxis}
                        onChange={handleInputChange}
                        placeholder="AXIS"
                      />
                    </div>
                  </div>
                  <div className="eye-field-group">
                    <label>Reading</label>
                    <input 
                      type="text" 
                      name="leftAdd"
                      value={formData.leftAdd}
                      onChange={handleInputChange}
                      placeholder="Addition"
                    />
                  </div>

                  <div className="eye-field-group">
                    <label>Near VA</label>
                    <select 
                      className="form-control"
                      name="leftNearVA"
                      value={formData.leftNearVA}
                      onChange={handleInputChange}
                    >
                      <option value="">Select</option>
                      <option value="N5">N5</option>
                      <option value="N6">N6</option>
                      <option value="N8">N8</option>
                      <option value="N10">N10</option>
                      <option value="N14">N14</option>
                      <option value="N24">N24</option>
                      <option value="N36">N36</option>  
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Lens & Frame */}
          <div className="invoice-section">
            <div className="section-header">
              <h3>Lens & Frame Details</h3>
              <span className="section-badge">Products</span>
            </div>
            

           <div className="form-row">
             <div className="form-group">
               <label>Lens Model</label>
              <select 
                 className="form-control"
                 name="lensModel"
                 value={formData.lensModel}
                 onChange={handleLensSelect}
               >
                 <option value="">Select Lens Model</option>
                 <option value="CR39 S/V">CR39 S/V</option>
                 <option value="CR39 S/V AR">CR39 S/V AR</option>
                 <option value="CR39 S/V AR TRN">CR39 S/V AR TRN</option>
                <option value="CR39 S/V TRN">CR39 S/V TRN</option>
                 <option value="CR39 S/V HND">CR39 S/V HND</option>
                <option value="CR39 S/V HND AR">CR39 S/V HND AR</option>
                 <option value="CR39 S/V HND TRN">CR39 S/V HND TRN</option>
                <option value="CR39 S/V HND AR TRN">CR39 S/V HND AR TRN</option>
                <option value="CR39 B/F">CR39 B/F</option>
                <option value="CR39 B/F AR">CR39 B/F AR</option>
                <option value="CR39 B/F TRN">CR39 B/F TRN</option>
                 <option value="CR39 B/F AR TRN">CR39 B/F AR TRN</option>
                 <option value="CR39 F/T">CR39 F/T</option>
                <option value="CR39 F/T AR">CR39 F/T AR</option>
                 <option value="CR39 F/T TRN">CR39 F/T TRN</option>
                <option value="CR F/T AR TRN">CR F/T AR TRN</option>
                 <option value="CR39 PROG">CR39 PROG</option>
                 <option value="CR39 PROG AR">CR39 PROG AR</option>
                 <option value="CR39 PROG TRN">CR39 PROG TRN</option>
                 <option value="C/L SOFT REG">C/L SOFT REG</option>
                 <option value="C/L SOFT DIS">C/L SOFT DIS</option>
                 <option value="C/L SOFT COS">C/L SOFT COS</option>
                 <option value="C/L SOFT COS POW">C/L SOFT COS POW</option>
                 <option value="BF01">BF01</option>
                 <option value="BF012">BF012</option>
                 <option value="BF015">BF015</option>
               </select>
             </div>
            
              <div className="form-group">
                <label>Frame Model <span className="required-star">*</span></label>
                <div style={{ position: 'relative' }}>
                  <input
                    type="text"
                    name="frameModel"
                    value={frameSearchTerm}
                    onChange={(e) => handleFrameSearch(e.target.value)}
                    onFocus={() => frameSearchTerm.length >= 2 && setShowFrameSuggestions(true)}
                    placeholder="Type frame model..."
                    className={errors.frameModel ? 'error-input' : ''}
                  />
                  {errors.frameModel && <span className="error-message">{errors.frameModel}</span>}
                  
                  {showFrameSuggestions && frameSuggestions.length > 0 && (
                    <div className="suggestions-dropdown">
                      {frameSuggestions.map((frame, index) => (
                        <div 
                          key={index}
                          className="suggestion-item"
                          onClick={() => selectFrame(frame)}
                        >
                          <strong>{frame.modelNo}</strong>
                          <div className="suggestion-details">
                            {frame.brand} | {frame.colour} | ${frame.sellingPrice}
                            <span className="stock-badge">Stock: {frame.qty}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              
              <div className="form-group">
                <label>Brand</label>
                <input 
                  type="text" 
                  name="brand"
                  value={formData.brand}
                  readOnly
                  className="readonly-field"
                  placeholder="Auto-filled from frame"
                />
              </div>
              
              <div className="form-group">
                <label>Colour</label>
                <input 
                  type="text" 
                  name="colour"
                  value={formData.colour}
                  readOnly
                  className="readonly-field"
                  placeholder="Auto-filled from frame"
                />
              </div>
            </div>
          </div>

          {/* Delivery & Pricing */}
          <div className="invoice-section">
            <div className="section-header">
              <h3>Pricing & Delivery</h3>
              <span className="section-badge">Financial</span>
            </div>
            
            <div className="form-row">
              <div className="form-group">
                <label>Delivery Date</label>
                <input 
                  type="date" 
                  name="deliveryDate"
                  value={formData.deliveryDate}
                  onChange={handleInputChange}
                />
              </div>
              
              <div className="form-group">
                <label>Lens Price (Rs.)</label>
                <input 
                  type="number" 
                  name="lensPrice"
                  value={formData.lensPrice}
                  onChange={handleInputChange}
                  placeholder="0.00"
                  step="0.01"
                />
              </div>
              
              <div className="form-group">
                <label>Frame Price (Rs.)</label>
                <input 
                  type="number" 
                  name="framePrice"
                  value={formData.framePrice}
                  readOnly
                  className="readonly-field"
                  placeholder="Auto-filled"
                  step="0.01"
                />
              </div>

              <div className="form-group total-group">
                <label>Discount (Rs.)</label>
                <input 
                  type="number"
                  name="discount"
                  value={formData.discount}
                  onChange={handleInputChange}
                  placeholder="0.00"
                  step="0.01"
                />
              </div>

              <div className="form-group total-group">
                <label>Advance Payment (Rs.)</label>
                <input 
                  type="number"
                  name="advancePayment"
                  value={formData.advancePayment}
                  onChange={handleInputChange}
                  placeholder="0.00"
                  step="0.01"
                />
              </div>

              <div className="form-group total-group">
                <label>Total Amount (Rs.)</label>
                <input 
                  type="text" 
                  value={`Rs ${totalAmount.toFixed(2)}`}
                  readOnly
                  className="total-input"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="eye-field-group">
                <label>Bill Description</label>
                <select 
                  className="form-control"
                  name="billDescription"
                  value={formData.billDescription}
                  onChange={handleInputChange}
                >
                  <option value="Frame and Lenses">Frame and Lenses</option>
                  <option value="Lenses">Lenses</option>
                  <option value="Frame">Frame</option>
                  <option value="Contact Lenses">Contact Lenses</option>
                  <option value="Sunglass">Sunglass</option>  
                </select>
              </div>

              <div className="eye-field-group">
                <label>Payment Method</label>
                <select 
                  className="form-control"
                  name="paymentMethod"
                  value={formData.paymentMethod}
                  onChange={handleInputChange}
                >
                  <option value="Cash">Cash</option>
                  <option value="Card">Card</option>
                  <option value="Bank Transfer">Bank Transfer</option>
                  <option value="Deposit">Deposit</option>
                </select>
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="invoice-actions">
            <button className="btn-save" onClick={handleSaveOrder} disabled={isLoading}>
              {isLoading ? '⏳ Saving...' : '💾 Save Order'}
            </button>
            <button className="btn-clear" onClick={handleResetForm}>
              🗑️ Clear Form
            </button>
          </div>
        </div>
      </div>
    </>
)}


{/***************************************************** create blance invoice *********************************************************/}

{selectedOption === "createBalanceInvoice" && (
   <div className="balance-invoice-container">
      <div className="balance-header">
        <h2>Create Balance Invoice</h2>
        <p className="subtitle">Manage pending payments and create balance invoices</p>
      </div>

      {/* Search Section */}
      <div className="search-section">
        <div className="search-box">
          <input
            type="text"
            placeholder="Search by invoice number..."
            value={searchInvoiceNo}
            onChange={(e) => setSearchInvoiceNo(e.target.value)}
            className="search-input"
          />
          <button onClick={handleInvoiceSearch} className="btn-search">
            🔍 Search
          </button>
          <button onClick={() => {
            setSearchInvoiceNo('');
            setFilteredInvoices(balanceInvoices);
          }} className="btn-reset">
            Reset
          </button>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="summary-cards">
        <div className="summary-card">
          <div className="summary-title">Pending Invoices</div>
          <div className="summary-value">{balanceInvoices.length}</div>
        </div>
        <div className="summary-card">
          <div className="summary-title">Total Balance Due</div>
          <div className="summary-value">
            Rs. {balanceInvoices.reduce((sum, inv) => sum + (inv.balanceDue || 0), 0).toFixed(2)}
          </div>
        </div>
        <div className="summary-card">
          <div className="summary-title">Partially Paid</div>
          <div className="summary-value">
            {balanceInvoices.filter(inv => inv.hasBalanceInvoices).length}
          </div>
        </div>
      </div>

      {/* Invoices Table */}
      {isLoadingInvoices ? (
        <div className="loading-spinner">Loading invoices...</div>
      ) : (
        <div className="invoices-table-container">
          <table className="invoices-table">
            <thead>
              <tr>
                <th>Invoice No</th>
                <th>Customer Name</th>
                <th>Phone</th>
                <th>Total Amount</th>
                <th>Advance Paid</th>
                <th>Balance Due</th>
                <th>Balance Payments</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredInvoices.length === 0 ? (
                <tr>
                  <td colSpan="9" style={{ textAlign: 'center' }}>
                    No pending invoices found
                  </td>
                </tr>
              ) : (
                filteredInvoices.map((invoice) => (
                  <tr key={invoice.id}>
                    <td className="invoice-number">{invoice.invoiceNumber}</td>
                    <td>{invoice.customer?.fullName}</td>
                    <td>{invoice.customer?.tpNo}</td>
                    <td>Rs. {(invoice.financial?.totalAmount || 0).toFixed(2)}</td>
                    <td>Rs. {(invoice.financial?.advancePayment || 0).toFixed(2)}</td>
                    <td className="balance-due">
                      Rs. {(invoice.balanceDue || 0).toFixed(2)}
                    </td>
                    <td>
                      {invoice.hasBalanceInvoices && (
                        <div className="balance-payments-list">
                          {invoice.balanceRecords?.map((record, idx) => (
                            <div key={idx} className="payment-record">
                              {record.balanceInvoiceNumber}: Rs.{record.paidAmount.toFixed(2)} 
                              ({record.paymentDateOnly || new Date(record.paymentDate).toLocaleDateString()})
                            </div>
                          ))}
                        </div>
                      )}
                    </td>
                    <td>
                      {invoice.balanceDue <= 0 ? (
                        <span className="status-badge paid">Paid</span>
                      ) : invoice.hasBalanceInvoices ? (
                        <span className="status-badge partial">Partial</span>
                      ) : (
                        <span className="status-badge pending">Pending</span>
                      )}
                    </td>
                    <td>
                      <button
                        className="btn-create-balance"
                        onClick={() => openBalanceModal(invoice)}
                        disabled={invoice.balanceDue <= 0}
                      >
                        {invoice.balanceDue <= 0 ? 'Settled' : 'Create Balance'}
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Balance Invoice Modal */}
      {showBalanceModal && selectedInvoice && (
        <div className="modal-overlay" onClick={() => setShowBalanceModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Create Balance Invoice</h3>
              <button className="modal-close" onClick={() => setShowBalanceModal(false)}>×</button>
            </div>
            
            <div className="modal-body">
              <div className="invoice-details">
                <h4>Original Invoice Details</h4>
                <div className="detail-row">
                  <span>Invoice Number:</span>
                  <strong>{selectedInvoice.invoiceNumber}</strong>
                </div>
                <div className="detail-row">
                  <span>Customer:</span>
                  <strong>{selectedInvoice.customer?.fullName}</strong>
                </div>
                <div className="detail-row">
                  <span>Phone:</span>
                  <strong>{selectedInvoice.customer?.tpNo}</strong>
                </div>
                <div className="detail-row">
                  <span>Total Amount:</span>
                  <strong>Rs. {(selectedInvoice.financial?.totalAmount || 0).toFixed(2)}</strong>
                </div>
                <div className="detail-row">
                  <span>Already Paid:</span>
                  <strong>Rs. {(selectedInvoice.financial?.advancePayment || 0).toFixed(2)}</strong>
                </div>
                <div className="detail-row highlight">
                  <span>Balance Due:</span>
                  <strong>Rs. {(selectedInvoice.balanceDue || 0).toFixed(2)}</strong>
                </div>
                {selectedInvoice.hasBalanceInvoices && (
                  <div className="detail-row">
                    <span>Previous Balance Payments:</span>
                    <div className="previous-payments">
                      {selectedInvoice.balanceRecords?.map((record, idx) => (
                        <div key={idx}>
                          {record.balanceInvoiceNumber}: Rs.{record.paidAmount.toFixed(2)} 
                          ({record.paymentDateOnly || new Date(record.paymentDate).toLocaleDateString()})
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              <div className="payment-details">
                <h4>Payment Information</h4>
                <div className="form-group">
                  <label>Next Balance Invoice Number:</label>
                  <input
                    type="text"
                    value={`${selectedInvoice.invoiceNumber}-${(selectedInvoice.balanceRecords?.length || 0) + 1}`}
                    readOnly
                    className="form-control readonly"
                  />
                </div>

                <div className="form-group">
                  <label>Payment Date <span className="required-star">*</span></label>
                  <input
                    type="date"
                    value={paymentDate}
                    onChange={(e) => setPaymentDate(e.target.value)}
                    className="form-control"
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Amount to Pay (Rs.) <span className="required-star">*</span></label>
                  <input
                    type="number"
                    value={balancePaidAmount}
                    onChange={(e) => setBalancePaidAmount(e.target.value)}
                    placeholder="Enter amount"
                    step="0.01"
                    max={selectedInvoice.balanceDue}
                    className="form-control"
                  />
                  <small>Maximum: Rs. {selectedInvoice.balanceDue.toFixed(2)}</small>
                </div>

                <div className="form-group">
                  <label>Payment Method</label>
                  <select
                    value={balancePaymentMethod}
                    onChange={(e) => setBalancePaymentMethod(e.target.value)}
                    className="form-control"
                  >
                    <option value="Cash">Cash</option>
                    <option value="Card">Card</option>
                    <option value="Bank Transfer">Bank Transfer</option>
                    <option value="Deposit">Deposit</option>
                  </select>
                </div>

                <div className="payment-summary">
                  <div className="summary-row">
                    <span>New Balance After Payment:</span>
                    <strong className={selectedInvoice.balanceDue - parseFloat(balancePaidAmount || 0) <= 0 ? 'text-success' : 'text-warning'}>
                      Rs. {(selectedInvoice.balanceDue - parseFloat(balancePaidAmount || 0)).toFixed(2)}
                    </strong>
                  </div>
                </div>
              </div>
            </div>

            <div>
            </div>

            <div className="modal-footer">
              <button className="btn-cancel" onClick={() => setShowBalanceModal(false)}>
                Cancel
              </button>
              <button 
                className="btn-create" 
                onClick={handleCreateBalanceInvoice}
                disabled={isLoading || !balancePaidAmount || parseFloat(balancePaidAmount) <= 0 || !paymentDate}
              >
                {isLoading ? 'Creating...' : 'Create Balance Invoice'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
)}




















{/******************************************************* create Consultation *****************************************************************/}

{selectedOption === "createConsultation" && (
  <div className="consultation-container">
    <h2>Create Consultation</h2>



 {/* Bill No */}
<div className="form-row">
  <label>Bill No :</label>
  <input 
    type="text"
    value={billNo || "Auto Generated"}
    readOnly
    className="readonly-field"
  />
</div>

    {/* Customer Name */}
    <div className="form-row">
      <label>Customer Name :</label>
      <input 
        type="text" 
        value={customerName}
        onChange={(e) => setCustomerName(e.target.value)}
        placeholder="Enter customer name" 
      />
    </div>

    {/* Item Select */}
    <div className="form-row">
      <label>Item Name :</label>
      <select value={selectedItemId} onChange={(e) => setSelectedItemId(e.target.value)}>
        <option value="">-- Select Item --</option>
        {itemsList.map(item => (
          <option key={item.id} value={item.id}>
            {item.name} - Rs.{item.price}
          </option>
        ))}
      </select>
      <button className="btn-add" onClick={handleAddToCart}>Add</button>
    </div>

    {/* Table */}
    <table className="item-table">
      <thead>
        <tr>
          <th>Item Name</th>
          <th>Cost (Rs.)</th>
        </tr>
      </thead>
      <tbody>
        {cartItems.map((item, index) => (
          <tr key={index}>
            <td>{item.name}</td>
            <td>{item.price.toFixed(2)}</td>
          </tr>
        ))}
      </tbody>
    </table>

    {/* Remove btn */}
    <button className="btn-remove" onClick={handleRemoveLastItem} disabled={cartItems.length === 0}>
      Remove
    </button>

    {/* Total */}
    <div className="total-row">
      <strong>Total :</strong> <span>Rs. {totalAmount.toFixed(2)}</span>
    </div>

    {/* Delivery Date */}
    <div className="form-row">
      <label>Date :</label>
      <input 
        type="date" 
        value={deliveryDate}
        onChange={(e) => setDeliveryDate(e.target.value)}
      />
    </div>

    {/* Submit */}
    <button className="btn-create" onClick={handleCreateConsultation}>Create</button>
  </div>
)}







{/**************************************************** Add Items **********************************/}

{selectedOption === "addItems" && (
  <div className="add-items-container">
    <h2>Add Items</h2>
    
    {/* Item Name */}
    <label>Item Name *</label>
    <input
      type="text"
      value={itemName}
      onChange={(e) => setItemName(e.target.value)}
      placeholder="Enter item name"
    />

    {/* Price */}
    <label>Price (Rs.) *</label>
    <input
      type="number"
      value={itemPrice}
      onChange={(e) => setItemPrice(e.target.value)}
      placeholder="Enter price in Rupees"
      min="0"
      step="0.01"
    />

    {/* Buttons */}
    <button onClick={handleClearItems}>Clear</button>
    <button onClick={handleAddItemforconsultation}>Add Item</button>
  </div>
)}












{/**************************************************** stock history report *******************************************/}

{selectedOption === "StockHistory" && (
  <div className="stock-history-wrap">
    <h2>Stock History</h2>
    
    {/* Category Selection Buttons */}
    <div className="history-category-buttons">
      <button 
        onClick={() => setHistoryCategory("lens")}
        className={`category-btn ${historyCategory === "lens" ? "active" : ""}`}
      >
        Lens History
      </button>
      <button 
        onClick={() => setHistoryCategory("frame")}
        className={`category-btn ${historyCategory === "frame" ? "active" : ""}`}
      >
        Frame History
      </button>
    </div>

    {/* Loading State */}
    {loading && <div className="loading">Loading...</div>}

    {/* Lens Stock History Table */}
    {historyCategory === "lens" && !loading && (
      <div className="history-table-container">
        <table className="history-table">
          <thead>
            <tr>
              <th>Purchase Order No</th>
              <th>Supplier Name</th>
              <th>Purchase Date</th>
              <th>Item Code</th>
              <th>Sph</th>
              <th>Add</th>
              <th>Cyl</th>
              <th>Axis</th>
              <th>Model</th>
              <th>Is Progressive</th>
              <th>Ordered Qty</th>
              <th>Supply Qty</th>
              <th>Status</th>
              <th>Stock Added Date</th>
            </tr>
          </thead>
          <tbody>
            {lensStockHistory.map((stock, index) => (
              stock.items.map((item, itemIndex) => (
                <tr key={`${stock.id}-${itemIndex}`}>
                  <td>{stock.purchaseOrderNo}</td>
                  <td>{stock.supplierName}</td>
                  <td>{stock.purchaseDate}</td>
                  <td>{item.itemCode}</td>
                  <td>{item.sph}</td>
                  <td>{item.add}</td>
                  <td>{item.cyl}</td>
                  <td>{item.axis}</td>
                  <td>{item.model}</td>
                  <td>{item.progressive ? "Yes" : "No"}</td>
                  <td>{item.qty}</td>
                  <td>{item.supplyQty || 0}</td>
                  <td>
                    {item.supplyQty >= item.qty ? 
                      <span className="status-complete">Complete</span> : 
                      <span className="status-pending">Pending</span>
                    }
                  </td>
                  <td>{stock.createdAt?.toDate().toLocaleDateString()}</td>
                </tr>
              ))
            ))}
          </tbody>
        </table>
        {lensStockHistory.length === 0 && (
          <div className="no-data">No lens stock history found</div>
        )}
      </div>
    )}

    {/* Frame Stock History Table */}
    {historyCategory === "frame" && !loading && (
      <div className="history-table-container">
        <table className="history-table">
          <thead>
            <tr>
              <th>Purchase Order No</th>
              <th>Supplier Name</th>
              <th>Purchase Date</th>
              <th>Item Code</th>
              <th>Model No</th>
              <th>Brand</th>
              <th>Colour</th>
              <th>Sex</th>
              <th>Ordered Qty</th>
              <th>Supply Qty</th>
              <th>Status</th>
              <th>Stock Added Date</th>
            </tr>
          </thead>
          <tbody>
            {frameStockHistory.map((stock, index) => (
              stock.items.map((item, itemIndex) => (
                <tr key={`${stock.id}-${itemIndex}`}>
                  <td>{stock.purchaseOrderNo}</td>
                  <td>{stock.supplierName}</td>
                  <td>{stock.purchaseDate}</td>
                  <td>{item.itemCode}</td>
                  <td>{item.modelNo}</td>
                  <td>{item.brand}</td>
                  <td>{item.colour}</td>
                  <td>{item.sex}</td>
                  <td>{item.qty}</td>
                  <td>{item.supplyQty || 0}</td>
                  <td>
                    {item.supplyQty >= item.qty ? 
                      <span className="status-complete">Complete</span> : 
                      <span className="status-pending">Pending</span>
                    }
                  </td>
                  <td>{stock.createdAt?.toDate().toLocaleDateString()}</td>
                </tr>
              ))
            ))}
          </tbody>
        </table>
        {frameStockHistory.length === 0 && (
          <div className="no-data">No frame stock history found</div>
        )}
      </div>
    )}
  </div>
)}

{/******************************************************* View Supplier *****************************************************************/}

        {selectedOption === "viewSupplier" && (
          <div className="sup-wrap">
      <h2>Supplier Management</h2>

      {/* TOP BAR */}
      <div className="sup-topbar">
        <input
          type="text"
          placeholder="Search supplier..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <select onChange={(e) => setSortType(e.target.value)}>
          <option value="newest">Newest</option>
          <option value="az">A - Z</option>
        </select>
      </div>

      {/* TABLE */}
      <table className="sup-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Phone</th>
            <th>Email</th>
            <th>Company</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {currentItems.map((s) => (
            <tr key={s.id}>
              <td>{s.name}</td>
              <td>{s.phone}</td>
              <td>{s.email}</td>
              <td>{s.company}</td>
              <td>
                <button onClick={() => setEditData(s)}>Edit</button>
                <button onClick={() => handleDelete(s.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* PAGINATION */}
      <div className="sup-pagination">
        {[...Array(totalPages)].map((_, i) => (
          <button key={i} onClick={() => setCurrentPage(i + 1)}>
            {i + 1}
          </button>
        ))}
      </div>

      {/* EDIT MODAL */}
      {editData && (
        <div className="sup-modal">
          <div className="sup-modal-box">
            <h3>Edit Supplier</h3>

            <input
              value={editData.name}
              onChange={(e) =>
                setEditData({ ...editData, name: e.target.value })
              }
            />
            <input
              value={editData.phone}
              onChange={(e) =>
                setEditData({ ...editData, phone: e.target.value })
              }
            />
            <input
              value={editData.email}
              onChange={(e) =>
                setEditData({ ...editData, email: e.target.value })
              }
            />
            <input
              value={editData.company}
              onChange={(e) =>
                setEditData({ ...editData, company: e.target.value })
              }
            />
            <textarea
              value={editData.address}
              onChange={(e) =>
                setEditData({ ...editData, address: e.target.value })
              }
            />

            <div className="sup-modal-actions">
              <button onClick={handleUpdate}>Update</button>
              <button onClick={() => setEditData(null)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
)}




{/******************************************************* Report Section *****************************************************************/}


        {selectedOption === "reports" && <h2>Reports Section</h2>}


{/******************************************************* Purchasing Order *****************************************************************/}


{selectedOption === "purchasingOrder" && (
  <div className="purchase-container">
    <h2>Purchasing Order</h2>

    {/* HEADER */}
    <div className="po-header">
      <div className="po-field">
        <label>Purchase Order No:</label>
        <input
          value={purchaseOrderNo}
          readOnly
        />
      </div>

      <div className="po-field">
        <label>Supplier Name:</label>
        <select
          value={supplierName}
          onChange={(e) => setSupplierName(e.target.value)}
          style={{ maxHeight: "120px", overflowY: "auto" }} // scroll
        >
          <option value="">-- Select Supplier --</option>

          {suppliers.map((s) => (
            <option key={s.id} value={s.name}>
              {s.name}
            </option>
          ))}
        </select>
      </div>
    </div>

    {/* LENS SECTION */}
    <div className="section-box">
      <h3>Lens Detail</h3>

      <table>
        <thead>
          <tr>
            <th>Item Code</th>
            <th>Sph</th>
            <th>Add</th>
            <th>Cyl</th>
            <th>Axis</th>
            <th>Model</th>
            <th>Is Progressive</th>
            <th>Qty</th>
          </tr>
        </thead>

        <tbody>
          {lensList.map((l, i) => (
            <tr key={i}>
              <td>{l.itemCode}</td>
              <td>{l.sph}</td>
              <td>{l.add}</td>
              <td>{l.cyl}</td>
              <td>{l.axis}</td>
              <td>{l.model}</td>
              <td>{l.progressive ? "true" : "false"}</td>
              <td>{l.qty}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="lens-form">
        <input
          placeholder="Item Code"
          value={lensForm.itemCode}
          onChange={(e) =>
            setLensForm({ ...lensForm, itemCode: e.target.value })
          }
        />
        <input
          placeholder="Sph"
          value={lensForm.sph}
          onChange={(e) => setLensForm({ ...lensForm, sph: e.target.value })}
        />
        <input
          placeholder="Add"
          value={lensForm.add}
          onChange={(e) => setLensForm({ ...lensForm, add: e.target.value })}
        />
        <input
          placeholder="Cyl"
          value={lensForm.cyl}
          onChange={(e) => setLensForm({ ...lensForm, cyl: e.target.value })}
        />
        <input
          placeholder="Axis"
          value={lensForm.axis}
          onChange={(e) => setLensForm({ ...lensForm, axis: e.target.value })}
        />

        <select
          value={lensForm.model}
          onChange={(e) => setLensForm({ ...lensForm, model: e.target.value })}
        >
          <option value="CR39">CR39</option>
          <option value="CR39 S/V">CR39 S/V</option>
        </select>

        <label className="checkbox-row">
          <input
            type="checkbox"
            checked={lensForm.progressive}
            onChange={(e) =>
              setLensForm({ ...lensForm, progressive: e.target.checked })
            }
          />
          Is Progressive
        </label>

        <input
          placeholder="Qty"
          value={lensForm.qty}
          onChange={(e) => setLensForm({ ...lensForm, qty: e.target.value })}
        />

        <button onClick={handleLensAdd}>Add to List</button>
        <button onClick={() => setLensList([])}>Clear All</button>
      </div>
    </div>

    {/* FRAME SECTION */}
    <div className="section-box">
      <h3>Frame Detail</h3>

      <table>
        <thead>
          <tr>
            <th>Item Code</th>
            <th>Model No</th>
            <th>Brand</th>
            <th>Colour</th>
            <th>Sex</th>
            <th>Qty</th>
          </tr>
        </thead>

        <tbody>
          {frameList.map((f, i) => (
            <tr key={i}>
              <td>{f.itemCode}</td>
              <td>{f.modelNo}</td>
              <td>{f.brand}</td>
              <td>{f.colour}</td>
              <td>{f.sex}</td>
              <td>{f.qty}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="frame-form">
        <input
          placeholder="Item Code"
          value={frameForm.itemCode}
          onChange={(e) =>
            setFrameForm({ ...frameForm, itemCode: e.target.value })
          }
        />
        <input
          placeholder="Model No"
          value={frameForm.modelNo}
          onChange={(e) =>
            setFrameForm({ ...frameForm, modelNo: e.target.value })
          }
        />
        <input
          placeholder="Brand"
          value={frameForm.brand}
          onChange={(e) =>
            setFrameForm({ ...frameForm, brand: e.target.value })
          }
        />
        <input
          placeholder="Colour"
          value={frameForm.colour}
          onChange={(e) =>
            setFrameForm({ ...frameForm, colour: e.target.value })
          }
        />
        <input
          placeholder="Sex"
          value={frameForm.sex}
          onChange={(e) =>
            setFrameForm({ ...frameForm, sex: e.target.value })
          }
        />

        <input
          placeholder="Qty"
          value={frameForm.qty}
          onChange={(e) =>
            setFrameForm({ ...frameForm, qty: e.target.value })
          }
        />

        <button onClick={handleFrameAdd}>Add to List</button>
        <button onClick={() => setFrameList([])}>Clear All</button>
      </div>
    </div>

    {/* CREATE BUTTON */}
    <button className="create-btn" onClick={handleCreatePurchaseOrder}>
      Create
    </button>
  </div>
)}



{/************************************** view stock - out *****************************************************/}

{selectedOption === "viewStockOut" && (
  <div className="stock-out-container">
    <div className="stock-out-header">
      <h2>Stock Out History</h2>
      <button 
        className="btn-export" 
        onClick={generateStockOutReportPDF}
        disabled={filteredStockOut.length === 0}
      >
        📄 Export to PDF
      </button>
    </div>

    {/* Filters Section */}
    <div className="filters-section">
      <div className="filter-row">
        <div className="filter-group">
          <label>Search:</label>
          <input
            type="text"
            placeholder="Search by model, brand, customer, invoice..."
            value={stockOutSearchTerm}
            onChange={(e) => setStockOutSearchTerm(e.target.value)}
            className="filter-input"
          />
        </div>

        <div className="filter-group">
          <label>Product Type:</label>
          <select
            value={stockOutFilterType}
            onChange={(e) => setStockOutFilterType(e.target.value)}
            className="filter-select"
          >
            <option value="all">All Types</option>
            <option value="frame">Frames</option>
            <option value="lens">Lenses</option>
          </select>
        </div>

        <div className="filter-group">
          <label>Date Range:</label>
          <input
            type="date"
            value={stockOutDateRange.start}
            onChange={(e) => setStockOutDateRange(prev => ({ ...prev, start: e.target.value }))}
            className="filter-date"
          />
          <span>to</span>
          <input
            type="date"
            value={stockOutDateRange.end}
            onChange={(e) => setStockOutDateRange(prev => ({ ...prev, end: e.target.value }))}
            className="filter-date"
          />
        </div>

        <button className="btn-reset" onClick={resetStockOutFilters}>
          🔄 Reset Filters
        </button>
        <button className="btn-refresh" onClick={fetchStockOutHistory}>
          🔄 Refresh
        </button>
      </div>
    </div>

    {/* Summary Cards */}
    <div className="summary-cards">
      <div className="summary-card">
        <div className="summary-title">Total Items Sold</div>
        <div className="summary-value">{getStockOutSummary().totalItems}</div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Total Value</div>
        <div className="summary-value">Rs. {getStockOutSummary().totalValue.toFixed(2)}</div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Frames Sold</div>
        <div className="summary-value">{getStockOutSummary().frameTotal}</div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Lenses Sold</div>
        <div className="summary-value">{getStockOutSummary().lensTotal}</div>
      </div>
    </div>

    {/* Stock Out Table */}
    {isLoadingStockOut ? (
      <div className="loading-spinner">Loading stock-out history...</div>
    ) : (
      <>
        <div className="stock-out-table-container">
          <table className="stock-out-table">
            <thead>
              <tr>
                <th>Date & Time</th>
                <th>Type</th>
                <th>Model</th>
                <th>Brand</th>
                <th>Colour</th>
                <th>Customer Name</th>
                <th>Invoice No</th>
                <th>Quantity</th>
                <th>Price</th>
                <th>Total</th>
                <th>Remaining Stock</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredStockOut.length === 0 ? (
                <tr>
                  <td colSpan="12" style={{ textAlign: 'center' }}>
                    No stock-out records found
                  </td>
                </tr>
              ) : (
                filteredStockOut.map((record) => (
                  <tr key={record.id}>
                    <td>
                      {record.dateFormatted}<br/>
                      <small>{record.timeFormatted}</small>
                    </td>
                    <td>
                      <span className={`product-type-badge ${record.productType}`}>
                        {record.productType}
                      </span>
                    </td>
                    <td><strong>{record.productModel}</strong></td>
                    <td>{record.brand || 'N/A'}</td>
                    <td>{record.colour || 'N/A'}</td>
                    <td>{record.customerName}</td>
                    <td>
                      <span className="invoice-link">{record.invoiceNumber}</span>
                    </td>
                    <td className="text-center">{record.quantity}</td>
                    <td>Rs. {(record.price || 0).toFixed(2)}</td>
                    <td>Rs. {((record.price || 0) * (record.quantity || 0)).toFixed(2)}</td>
                    <td className="text-center">
                      <span className={`stock-badge ${record.remainingStock <= 5 ? 'low-stock' : ''}`}>
                        {record.remainingStock}
                      </span>
                    </td>
                    <td>
                      <button 
                        className="btn-delete-small"
                        onClick={() => deleteStockOutRecord(record.id)}
                        title="Delete record"
                      >
                        🗑️
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        
        <div className="stock-out-footer">
          <div className="records-count">
            Showing {filteredStockOut.length} of {stockOutRecords.length} records
          </div>
        </div>
      </>
    )}
  </div>
)}










{/******************************************************* Add Stock *****************************************************************/}

    {selectedOption === "addStock" && (
 <div className="stock-wrap">
  <h2>Add Stock</h2>

  {/* Select Category */}
  <label>Category:</label>
  <select value={selectedCategory} onChange={e => setSelectedCategory(e.target.value)}>
    <option value="">-- Select --</option>
    <option value="lens">Lens</option>
    <option value="frame">Frame</option>
  </select>

  {/* Purchase Order */}
  <label>Purchase Order No:</label>
  <select value={purchaseOrderNo} onChange={e => setPurchaseOrderNo(e.target.value)}>
    <option value="">-- Select Order --</option>
    {purchaseOrders.map(po => (
      <option key={po.id} value={po.purchaseOrderNo}>{po.purchaseOrderNo}</option>
    ))}
  </select>
  <button onClick={handleLoad}>Load</button>

  <label>Supplier Name:</label>
  <input type="text" value={supplierName} readOnly />

  <label>Purchase Date:</label>
  <input type="date" value={purchaseDate} readOnly />

  {/* Dynamic Table */}
  <div className="stock-items">
    <table>
      <thead>
        <tr>
          {selectedCategory === "lens" ? (
            <>
              <th>Item Code</th>
              <th>Sph</th>
              <th>Add</th>
              <th>Cyl</th>
              <th>Axis</th>
              <th>Model</th>
              <th>Is Progressive</th>
              <th>Qty</th>
              <th>Supply Qty</th>
            </>
          ) : selectedCategory === "frame" ? (
            <>
              <th>Item Code</th>
              <th>Model No</th>
              <th>Brand</th>
              <th>Colour</th>
              <th>Sex</th>
              <th>Qty</th>
              <th>Supply Qty</th>
            </>
          ) : null}
        </tr>
      </thead>

      <tbody>
        {items.map((item, i) => (
          <tr key={i}>
            {selectedCategory === "lens" ? (
              <>
                <td>{item.itemCode}</td>
                <td>{item.sph}</td>
                <td>{item.add}</td>
                <td>{item.cyl}</td>
                <td>{item.axis}</td>
                <td>{item.model}</td>
                <td>{item.progressive ? "true" : "false"}</td>
                <td>{item.qty}</td>
                <td>
                  <input
                    type="number"
                    value={item.supplyQty}
                    onChange={e => handleSupplyQtyChange(i, e.target.value)}
                  />
                </td>
              </>
            ) : selectedCategory === "frame" ? (
              <>
                <td>{item.itemCode}</td>
                <td>{item.modelNo}</td>
                <td>{item.brand}</td>
                <td>{item.colour}</td>
                <td>{item.sex}</td>
                <td>{item.qty}</td>
                <td>
                  <input
                    type="number"
                    value={item.supplyQty}
                    onChange={e => handleSupplyQtyChange(i, e.target.value)}
                  />
                </td>
              </>
            ) : null}
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  {/* Actions */}
  <button onClick={handleClear}>Clear</button>
  <button onClick={handleAddItems}>Add Items</button>
</div>
)}

{/***************************************************** quick add stock*************************************************************/}

{selectedOption === "quickAdd" && (
  <div className="quick-add-container">
    <h2>Quick Stock Add</h2>

    {/* Select Category */}
    <label>Category:</label>
    <select value={quickSelectedCategory} onChange={e => setQuickSelectedCategory(e.target.value)}>
      <option value="">-- Select --</option>
      <option value="lens">Lens</option>
      <option value="frame">Frame</option>
    </select>

    {/* Supplier Name */}
    <label>Supplier Name *</label>
    <select value={quickSupplierName} onChange={e => setQuickSupplierName(e.target.value)}>
      <option value="">-- Select Supplier --</option>
      {suppliersList.map(supplier => (
        <option key={supplier.id} value={supplier.name}>
          {supplier.name} - {supplier.company}
        </option>
      ))}
    </select>

    {/* Purchase Date */}
    <label>Purchase Date *</label>
    <input 
      type="date" 
      value={quickPurchaseDate} 
      onChange={e => setQuickPurchaseDate(e.target.value)}
    />

    {/* Dynamic Table for Items */}
    <div className="stock-items">
      <table>
        <thead>
          <tr>
            {quickSelectedCategory === "lens" ? (
              <>
                <th>Item Code</th>
                <th>Sph</th>
                <th>Add</th>
                <th>Cyl</th>
                <th>Axis</th>
                <th>Model</th>
                <th>Is Progressive</th>
                <th>Buying Price</th>
                <th>Selling Price</th>
                <th>Qty</th>
                <th>Supply Qty</th>
                <th>Action</th>
              </>
            ) : quickSelectedCategory === "frame" ? (
              <>
                <th>Item Code</th>
                <th>Model No</th>
                <th>Brand</th>
                <th>Colour</th>
                <th>Sex</th>
                <th>Qty</th>
                <th>Buying Price</th>
                <th>Selling Price</th>
                <th>Supply Qty</th>
                <th>Action</th>
              </>
            ) : null}
          </tr>
        </thead>
        <tbody>
          {quickItems.map((item, i) => (
            <tr key={i}>
              {quickSelectedCategory === "lens" ? (
                <>
                  <td>
                    <input 
                      type="text" 
                      value={item.itemCode} 
                      onChange={e => handleQuickItemChange(i, 'itemCode', e.target.value)}
                      placeholder="Item Code"
                    />
                  </td>
                  <td>
                    <input 
                      type="text" 
                      value={item.sph} 
                      onChange={e => handleQuickItemChange(i, 'sph', e.target.value)}
                      placeholder="Sph"
                    />
                  </td>
                  <td>
                    <input 
                      type="text" 
                      value={item.add} 
                      onChange={e => handleQuickItemChange(i, 'add', e.target.value)}
                      placeholder="Add"
                    />
                  </td>
                  <td>
                    <input 
                      type="text" 
                      value={item.cyl} 
                      onChange={e => handleQuickItemChange(i, 'cyl', e.target.value)}
                      placeholder="Cyl"
                    />
                  </td>
                  <td>
                    <input 
                      type="text" 
                      value={item.axis} 
                      onChange={e => handleQuickItemChange(i, 'axis', e.target.value)}
                      placeholder="Axis"
                    />
                  </td>
                  <td>
                    <input 
                      type="text" 
                      value={item.model} 
                      onChange={e => handleQuickItemChange(i, 'model', e.target.value)}
                      placeholder="Model"
                    />
                  </td>
                  <td>
                    <select 
                      value={item.progressive} 
                      onChange={e => handleQuickItemChange(i, 'progressive', e.target.value === 'true')}
                    >
                      <option value="false">No</option>
                      <option value="true">Yes</option>
                    </select>
                  </td>

                  <td>
                    <input 
                      type="number" 
                      value={item.buyingPrice} 
                      onChange={e => handleQuickItemChange(i, 'buyingPrice', parseInt(e.target.value) || 0)}
                      placeholder="Buying Price"
                    />
                  </td>


                  <td>
                    <input 
                      type="number" 
                      value={item.sellingPrice} 
                      onChange={e => handleQuickItemChange(i, 'sellingPrice', parseInt(e.target.value) || 0)}
                      placeholder="Selling Price"
                    />
                  </td>


                  <td>
                    <input 
                      type="number" 
                      value={item.qty} 
                      onChange={e => handleQuickItemChange(i, 'qty', parseInt(e.target.value) || 0)}
                      placeholder="Qty"
                    />
                  </td>
                  <td>
                    <input 
                      type="number" 
                      value={item.supplyQty} 
                      onChange={e => handleQuickItemChange(i, 'supplyQty', parseInt(e.target.value) || 0)}
                      placeholder="Supply Qty"
                    />
                  </td>
                  <td>
                    <button className="btn-remove-row" onClick={() => handleRemoveQuickItem(i)}>Remove</button>
                  </td>
                </>
              ) : quickSelectedCategory === "frame" ? (
                <>
                  <td>
                    <input 
                      type="text" 
                      value={item.itemCode} 
                      onChange={e => handleQuickItemChange(i, 'itemCode', e.target.value)}
                      placeholder="Item Code"
                    />
                  </td>
                  <td>
                    <input 
                      type="text" 
                      value={item.modelNo} 
                      onChange={e => handleQuickItemChange(i, 'modelNo', e.target.value)}
                      placeholder="Model No"
                    />
                  </td>
                  <td>
                    <input 
                      type="text" 
                      value={item.brand} 
                      onChange={e => handleQuickItemChange(i, 'brand', e.target.value)}
                      placeholder="Brand"
                    />
                  </td>
                  <td>
                    <input 
                      type="text" 
                      value={item.colour} 
                      onChange={e => handleQuickItemChange(i, 'colour', e.target.value)}
                      placeholder="Colour"
                    />
                  </td>
                  <td>
                    <select 
                      value={item.sex} 
                      onChange={e => handleQuickItemChange(i, 'sex', e.target.value)}
                    >
                      <option value="">Select</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Unisex">Unisex</option>
                    </select>
                  </td>
                  <td>
                    <input 
                      type="number" 
                      value={item.qty} 
                      onChange={e => handleQuickItemChange(i, 'qty', parseInt(e.target.value) || 0)}
                      placeholder="Qty"
                    />
                  </td>


                  <td>
                    <input 
                      type="number" 
                      value={item.buyingPrice} 
                      onChange={e => handleQuickItemChange(i, 'buyingPrice', parseInt(e.target.value) || 0)}
                      placeholder="Buying Price"
                    />
                  </td>


                  <td>
                    <input 
                      type="number" 
                      value={item.sellingPrice} 
                      onChange={e => handleQuickItemChange(i, 'sellingPrice', parseInt(e.target.value) || 0)}
                      placeholder="Selling Price"
                    />
                  </td>



                  <td>
                    <input 
                      type="number" 
                      value={item.supplyQty} 
                      onChange={e => handleQuickItemChange(i, 'supplyQty', parseInt(e.target.value) || 0)}
                      placeholder="Supply Qty"
                    />
                  </td>
                  <td>
                    <button className="btn-remove-row" onClick={() => handleRemoveQuickItem(i)}>Remove</button>
                  </td>
                </>
              ) : null}
            </tr>
          ))}
        </tbody>
      </table>
    </div>

    {/* Add Row Button */}
    <button className="btn-add-row" onClick={handleAddQuickItemRow}>
      + Add Item
    </button>

    {/* Actions */}
    <div className="quick-actions">
      <button onClick={handleClearQuickForm}>Clear</button>
      <button onClick={handleQuickAddStock}>Add to Stock</button>
    </div>
  </div>
)}



{/******************************************************* Stock History *****************************************************************/}

       {selectedOption === "stockHistory" && (
  <div className="stock-history-container">
    <h2>Stock History</h2>

    {/* Filters */}
    <div className="sh-filters">
      <div className="sh-field">
        <label>From Date</label>
        <input type="date" />
      </div>

      <div className="sh-field">
        <label>To Date</label>
        <input type="date" />
      </div>

      <div className="sh-field">
        <label>Supplier</label>
        <select>
          <option>All Suppliers</option>
          <option>BAURS</option>
          <option>Vision Care</option>
        </select>
      </div>

      <div className="sh-field">
        <label>Search</label>
        <input type="text" placeholder="Search by model, SPH, CYL..." />
      </div>

      <button className="sh-filter-btn">Filter</button>
    </div>

    {/* Table */}
    <table className="sh-table">
      <thead>
        <tr>
          <th>Date</th>
          <th>Supplier</th>
          <th>Item</th>
          <th>Details (SPH/CYL/ADD)</th>
          <th>Model</th>
          <th>Qty</th>
          <th>Remarks</th>
        </tr>
      </thead>

      <tbody>
        {/* Dynamic rows load here */}
      </tbody>
    </table>
  </div>
)}

{/******************************************************* Search *****************************************************************/}


        {selectedOption === "about" && <h2>About</h2>}





{/******************************************************* Sales report *****************************************************************/}




{selectedOption === "salesReport" && (
  <div className="sales-report-container">
    <h2>Sales Overview</h2>

    <div style={{ marginBottom: "15px" }}>
      <button onClick={downloadExcel}>Download Excel</button>
      <button onClick={downloadPDF} style={{ marginLeft: "10px" }}>
        Download PDF
      </button>
    </div>


    <div style={{ marginBottom: "15px", display: "flex", gap: "10px" }}>
  
  {/* Month Filter */}
  <select
    value={selectedMonth}
    onChange={(e) => setSelectedMonth(e.target.value)}
  >
    <option value="all">All Months</option>
    <option value="1">Jan</option>
    <option value="2">Feb</option>
    <option value="3">Mar</option>
    <option value="4">Apr</option>
    <option value="5">May</option>
    <option value="6">Jun</option>
    <option value="7">Jul</option>
    <option value="8">Aug</option>
    <option value="9">Sep</option>
    <option value="10">Oct</option>
    <option value="11">Nov</option>
    <option value="12">Dec</option>
  </select>

  {/* Year Filter */}
  <select
    value={selectedYear}
    onChange={(e) => setSelectedYear(e.target.value)}
  >
    <option value="all">All Years</option>
    <option value="2025">2025</option>
    <option value="2026">2026</option>
    <option value="2027">2027</option>
    <option value="2028">2028</option>
  </select>

</div>




    {loading ? (
      <p>Loading...</p>
    ) : (
      <table border="1" cellPadding="10" style={{ width: "100%" }}>
        <thead>
          <tr>
            <th>Invoice</th>
            <th>Customer</th>
            <th>Total</th>
            <th>Advance</th>
            <th>Later Payments</th>
            <th>Total Paid</th>
            <th>Remaining</th>
            <th>Status</th>
          </tr>
        </thead>

        <tbody>
          {filteredReport.length === 0 ? (
            <tr>
              <td colSpan="8" style={{ textAlign: "center" }}>
                No data available
              </td>
            </tr>
          ) : (
           filteredReport.map((r, i) => (
              <tr key={i}>
                <td>{r.invoiceNumber}</td>
                <td>{r.customer}</td>
                <td>{r.totalAmount}</td>
                <td>{r.advancePaid}</td>
                <td>{r.laterPayments}</td>
                <td>{r.totalPaid}</td>
                <td>{r.remaining}</td>
                <td
                  style={{
                    color: r.status === "Settled" ? "green" : "red",
                    fontWeight: "bold"
                  }}
                >
                  {r.status}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    )}
  </div>
)}


{/******************************************************* Log Out *****************************************************************/}


        {selectedOption === "logout" && <h2>Logging Out…</h2>}
      </div>
    </>
  );
}

export default AdminPanel;